var Lu = Object.defineProperty, Pu = Object.defineProperties;
var Nu = Object.getOwnPropertyDescriptors;
var Ce = Object.getOwnPropertySymbols, Iu = Object.getPrototypeOf, wi = Object.prototype.hasOwnProperty, Ri = Object.prototype.propertyIsEnumerable, Cu = Reflect.get;
var Li = (e) => {
  throw TypeError(e);
};
var br = (e, t, r) => t in e ? Lu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, m = (e, t) => {
  for (var r in t || (t = {}))
    wi.call(t, r) && br(e, r, t[r]);
  if (Ce)
    for (var r of Ce(t))
      Ri.call(t, r) && br(e, r, t[r]);
  return e;
}, I = (e, t) => Pu(e, Nu(t));
var Ar = (e, t) => {
  var r = {};
  for (var n in e)
    wi.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && Ce)
    for (var n of Ce(e))
      t.indexOf(n) < 0 && Ri.call(e, n) && (r[n] = e[n]);
  return r;
};
var O = (e, t, r) => br(e, typeof t != "symbol" ? t + "" : t, r), Pi = (e, t, r) => t.has(e) || Li("Cannot " + r);
var Ni = (e, t, r) => (Pi(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Ii = (e, t, r) => t.has(e) ? Li("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Ci = (e, t, r, n) => (Pi(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
var wr = (e, t, r) => Cu(Iu(e), r, t);
var U = (e, t, r) => new Promise((n, i) => {
  var o = (c) => {
    try {
      u(r.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(r.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(o, a);
  u((r = r.apply(e, t)).next());
});
import { U as ya, W as Mu, X as Tn, Y as xu, s as he, Z as it, _ as Ea, $ as ma, a0 as Ta, a1 as lt, P as Du, a2 as Uu, a3 as Sa, x as Bu, a4 as ku, a5 as Gu, a6 as $u, a7 as Hu, a8 as ju, a9 as qe, q as Vu, aa as Rr, ab as Lr, ac as Fu, ad as Xu, c as zu, n as qu, o as Ku, L as Wu, h as Yu, t as Ju, ae as Zu, E as Qu, af as tc, ag as ec, J as Mi, I as Pr, ah as rc, ai as nc, K as ic, N as oc, O as ac, Q as sc, R as uc, T as cc, aj as lc, ak as fc, al as xi, am as dc, an as pc, ao as hc } from "./common-CCkWfcP_.js";
import { a as _c, i as Oa } from "./buffer-DIFxvF2Q.js";
import { LDObserve as vc } from "./LDObserve.js";
const ba = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var _t = /* @__PURE__ */ ((e) => (e.DeviceMemory = "DeviceMemory", e.ViewportHeight = "ViewportHeight", e.ViewportWidth = "ViewportWidth", e.ScreenHeight = "ScreenHeight", e.ScreenWidth = "ScreenWidth", e.ViewportArea = "ViewportArea", e))(_t || {}), j = /* @__PURE__ */ ((e) => (e.Device = "Device", e.WebVital = "WebVital", e.Performance = "Performance", e.Frontend = "Frontend", e.Backend = "Backend", e))(j || {}), Aa = { exports: {} }, Nr = { exports: {} }, Di;
function gc() {
  return Di || (Di = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(ya, function() {
      function r(h) {
        return !isNaN(parseFloat(h)) && isFinite(h);
      }
      function n(h) {
        return h.charAt(0).toUpperCase() + h.substring(1);
      }
      function i(h) {
        return function() {
          return this[h];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], u = ["fileName", "functionName", "source"], c = ["args"], s = ["evalOrigin"], l = o.concat(a, u, c, s);
      function f(h) {
        if (h)
          for (var g = 0; g < l.length; g++)
            h[l[g]] !== void 0 && this["set" + n(l[g])](h[l[g]]);
      }
      f.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(h) {
          if (Object.prototype.toString.call(h) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = h;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(h) {
          if (h instanceof f)
            this.evalOrigin = h;
          else if (h instanceof Object)
            this.evalOrigin = new f(h);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var h = this.getFileName() || "", g = this.getLineNumber() || "", y = this.getColumnNumber() || "", E = this.getFunctionName() || "";
          return this.getIsEval() ? h ? "[eval] (" + h + ":" + g + ":" + y + ")" : "[eval]:" + g + ":" + y : E ? E + " (" + h + ":" + g + ":" + y + ")" : h + ":" + g + ":" + y;
        }
      }, f.fromString = function(g) {
        var y = g.indexOf("("), E = g.lastIndexOf(")"), A = g.substring(0, y), w = g.substring(y + 1, E).split(","), P = g.substring(E + 1);
        if (P.indexOf("@") === 0)
          var M = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(P, ""), It = M[1], pt = M[2], Ct = M[3];
        return new f({
          functionName: A,
          args: w || void 0,
          fileName: It,
          lineNumber: pt || void 0,
          columnNumber: Ct || void 0
        });
      };
      for (var d = 0; d < o.length; d++)
        f.prototype["get" + n(o[d])] = i(o[d]), f.prototype["set" + n(o[d])] = /* @__PURE__ */ function(h) {
          return function(g) {
            this[h] = !!g;
          };
        }(o[d]);
      for (var p = 0; p < a.length; p++)
        f.prototype["get" + n(a[p])] = i(a[p]), f.prototype["set" + n(a[p])] = /* @__PURE__ */ function(h) {
          return function(g) {
            if (!r(g))
              throw new TypeError(h + " must be a Number");
            this[h] = Number(g);
          };
        }(a[p]);
      for (var _ = 0; _ < u.length; _++)
        f.prototype["get" + n(u[_])] = i(u[_]), f.prototype["set" + n(u[_])] = /* @__PURE__ */ function(h) {
          return function(g) {
            this[h] = String(g);
          };
        }(u[_]);
      return f;
    });
  }(Nr)), Nr.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(gc());
  })(ya, function(n) {
    var i = /(^|@)\S+:\d+/, o = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(c) {
        if (typeof c.stacktrace != "undefined" || typeof c["opera#sourceloc"] != "undefined")
          return this.parseOpera(c);
        if (c.stack && c.stack.match(o))
          return this.parseV8OrIE(c);
        if (c.stack)
          return this.parseFFOrSafari(c);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(c) {
        if (c.indexOf(":") === -1)
          return [c];
        var s = /(.+?)(?::(\d+))?(?::(\d+))?$/, l = s.exec(c.replace(/[()]/g, ""));
        return [l[1], l[2] || void 0, l[3] || void 0];
      },
      parseV8OrIE: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(o);
        }, this);
        return s.map(function(l) {
          l.indexOf("(eval ") > -1 && (l = l.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var f = l.replace(/^\s+/, "").replace(/\(eval code/g, "("), d = f.match(/ (\((.+):(\d+):(\d+)\)$)/);
          f = d ? f.replace(d[0], "") : f;
          var p = f.split(/\s+/).slice(1), _ = this.extractLocation(d ? d[1] : p.pop()), h = p.join(" ") || void 0, g = ["eval", "<anonymous>"].indexOf(_[0]) > -1 ? void 0 : _[0];
          return new n({
            functionName: h,
            fileName: g,
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseFFOrSafari: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !l.match(a);
        }, this);
        return s.map(function(l) {
          if (l.indexOf(" > eval") > -1 && (l = l.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), l.indexOf("@") === -1 && l.indexOf(":") === -1)
            return new n({
              functionName: l
            });
          var f = /((.*".+"[^@]*)?[^@]*)(?:@)/, d = l.match(f), p = d && d[1] ? d[1] : void 0, _ = this.extractLocation(l.replace(f, ""));
          return new n({
            functionName: p,
            fileName: _[0],
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseOpera: function(c) {
        return !c.stacktrace || c.message.indexOf(`
`) > -1 && c.message.split(`
`).length > c.stacktrace.split(`
`).length ? this.parseOpera9(c) : c.stack ? this.parseOpera11(c) : this.parseOpera10(c);
      },
      parseOpera9: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)/i, l = c.message.split(`
`), f = [], d = 2, p = l.length; d < p; d += 2) {
          var _ = s.exec(l[d]);
          _ && f.push(new n({
            fileName: _[2],
            lineNumber: _[1],
            source: l[d]
          }));
        }
        return f;
      },
      parseOpera10: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, l = c.stacktrace.split(`
`), f = [], d = 0, p = l.length; d < p; d += 2) {
          var _ = s.exec(l[d]);
          _ && f.push(
            new n({
              functionName: _[3] || void 0,
              fileName: _[2],
              lineNumber: _[1],
              source: l[d]
            })
          );
        }
        return f;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(i) && !l.match(/^Error created at/);
        }, this);
        return s.map(function(l) {
          var f = l.split("@"), d = this.extractLocation(f.pop()), p = f.shift() || "", _ = p.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, h;
          p.match(/\(([^)]*)\)/) && (h = p.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var g = h === void 0 || h === "[arguments not available]" ? void 0 : h.split(",");
          return new n({
            functionName: _,
            args: g,
            fileName: d[0],
            lineNumber: d[1],
            columnNumber: d[2],
            source: l
          });
        }, this);
      }
    };
  });
})(Aa);
var yc = Aa.exports;
const Ui = /* @__PURE__ */ Mu(yc);
function pr(e) {
  try {
    return Ui.parse(e);
  } catch (t) {
    try {
      return Ui.parse(new Error());
    } catch (r) {
      return console.warn("Highlight Warning: failed to parse error", {
        originalError: t,
        secondaryError: r
      }), [];
    }
  }
}
const kT = {
  level: [...ba],
  logger: "console",
  stringifyOptions: {
    depthOfLimit: 10,
    numOfKeysLimit: 100,
    stringLengthLimit: 1e3
  }
};
function Ec(e, t) {
  const r = t.logger;
  if (!r)
    return () => {
    };
  let n;
  typeof r == "string" ? n = window[r] : n = r;
  const i = [];
  if (t.level.includes("error") && window) {
    const a = (u) => {
      const { message: c, error: s } = u;
      let l = [];
      s && (l = pr(s));
      const f = [
        Tn(c, t.stringifyOptions)
      ];
      e({
        type: "Error",
        trace: l,
        time: Date.now(),
        value: f
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of t.level)
    i.push(o(n, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, u) {
    return a[u] ? xu(a, u, (c) => (...s) => {
      c.apply(this, s);
      try {
        e(mc(u, t, ...s));
      } catch (l) {
        c("highlight logger error:", l, ...s);
      }
    }) : () => {
    };
  }
}
function mc(e, t, ...r) {
  const n = pr(new Error()), i = t.serializeConsoleAttributes ? r.map(
    (o) => typeof o == "object" ? Tn(o, t.stringifyOptions) : o
  ) : r.filter((o) => typeof o != "object").map((o) => `${o}`);
  return {
    type: e,
    trace: n,
    value: i,
    attributes: Tn(
      r.filter((o) => typeof o == "object").reduce((o, a) => m(m({}, o), a), {}),
      t.stringifyOptions
    ),
    time: Date.now()
  };
}
const Tc = {
  start: 0,
  end: 3
}, Sc = {
  start: 4,
  end: 5
}, Ir = {
  start: 6,
  end: 7
}, Cr = {
  start: 8,
  end: 8
}, Oc = {
  start: 9,
  end: 9
}, bc = {
  start: 10,
  end: 15
};
function Ac() {
  if (crypto && crypto.getRandomValues) {
    const t = new Uint8Array(16);
    return crypto.getRandomValues(t), [...t.values()];
  }
  const e = [];
  for (let t = 0; t < 16; t += 1)
    e.push(Math.floor(Math.random() * 256));
  return e;
}
function xt(e, t) {
  let r = "";
  for (let n = t.start; n <= t.end; n += 1)
    r += e[n].toString(16).padStart(2, "0");
  return r;
}
function wc(e) {
  return e[Cr.start] = (e[Cr.start] | 128) & 191, e[Ir.start] = e[Ir.start] & 15 | 64, `${xt(e, Tc)}-${xt(e, Sc)}-${xt(e, Ir)}-${xt(e, Cr)}${xt(e, Oc)}-${xt(e, bc)}`;
}
function Rc() {
  const e = Ac();
  return wc(e);
}
function Sn() {
  return typeof crypto != "undefined" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : Rc();
}
function Mr(e, t, r, n) {
  var c, s, l, f;
  let i = n != null ? n : t, o = pr(i), a = {};
  t instanceof Error && (t = t.message, t.cause && (a = { "exception.cause": t.cause }));
  const u = Pc(o);
  e({
    error: i,
    event: he(t),
    type: "window.onerror",
    url: window.location.href,
    source: r != null ? r : "",
    lineNumber: (c = u[0]) != null && c.lineNumber ? (s = u[0]) == null ? void 0 : s.lineNumber : 0,
    columnNumber: (l = u[0]) != null && l.columnNumber ? (f = u[0]) == null ? void 0 : f.columnNumber : 0,
    stackTrace: u,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: a ? he(a) : void 0,
    id: Sn()
  });
}
const Lc = (e, { enablePromisePatch: t }) => {
  if (typeof window == "undefined") return () => {
  };
  const r = window.onerror = (a, u, c, s, l) => {
    Mr(e, a, u, l);
  }, n = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const u = a.promise;
      u.getStack ? Mr(
        e,
        a.reason,
        a.type,
        u.getStack()
      ) : Mr(e, a.reason, a.type);
    }
  }, i = window.Promise, o = class extends i {
    constructor(c) {
      super(c);
      O(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const c = typeof window.Zone == "undefined";
      return t && c;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = r;
  };
}, Pc = (e) => {
  var r, n;
  if (e.length === 0)
    return e;
  const t = e[0];
  return (r = t.fileName) != null && r.includes("highlight.run") || (n = t.fileName) != null && n.includes("highlight.io") || t.functionName === "new highlightPromise" ? e.slice(1) : e;
}, Nc = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Ic = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var Cc = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, mt = "1.9.0", Bi = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function Mc(e) {
  var t = /* @__PURE__ */ new Set([e]), r = /* @__PURE__ */ new Set(), n = e.match(Bi);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(c) {
      return c === e;
    };
  function o(u) {
    return r.add(u), !1;
  }
  function a(u) {
    return t.add(u), !0;
  }
  return function(c) {
    if (t.has(c))
      return !0;
    if (r.has(c))
      return !1;
    var s = c.match(Bi);
    if (!s)
      return o(c);
    var l = {
      major: +s[1],
      minor: +s[2],
      patch: +s[3],
      prerelease: s[4]
    };
    return l.prerelease != null || i.major !== l.major ? o(c) : i.major === 0 ? i.minor === l.minor && i.patch <= l.patch ? a(c) : o(c) : i.minor <= l.minor ? a(c) : o(c);
  };
}
var xc = Mc(mt), Dc = mt.split(".")[0], _e = Symbol.for("opentelemetry.js.api." + Dc), ve = Cc;
function Ae(e, t, r, n) {
  var i;
  n === void 0 && (n = !1);
  var o = ve[_e] = (i = ve[_e]) !== null && i !== void 0 ? i : {
    version: mt
  };
  if (!n && o[e]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return r.error(a.stack || a.message), !1;
  }
  if (o.version !== mt) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + e + " does not match previously registered API v" + mt);
    return r.error(a.stack || a.message), !1;
  }
  return o[e] = t, r.debug("@opentelemetry/api: Registered a global for " + e + " v" + mt + "."), !0;
}
function Ot(e) {
  var t, r, n = (t = ve[_e]) === null || t === void 0 ? void 0 : t.version;
  if (!(!n || !xc(n)))
    return (r = ve[_e]) === null || r === void 0 ? void 0 : r[e];
}
function we(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + mt + ".");
  var r = ve[_e];
  r && delete r[e];
}
var Uc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Bc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, kc = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return te("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return te("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return te("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return te("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return te("verbose", this._namespace, t);
    }, e;
  }()
);
function te(e, t, r) {
  var n = Ot("diag");
  if (n)
    return r.unshift(t), n[e].apply(n, Bc([], Uc(r), !1));
}
var L;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(L || (L = {}));
function Gc(e, t) {
  e < L.NONE ? e = L.NONE : e > L.ALL && (e = L.ALL), t = t || {};
  function r(n, i) {
    var o = t[n];
    return typeof o == "function" && e >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: r("error", L.ERROR),
    warn: r("warn", L.WARN),
    info: r("info", L.INFO),
    debug: r("debug", L.DEBUG),
    verbose: r("verbose", L.VERBOSE)
  };
}
var $c = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Hc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, jc = "diag", Y = (
  /** @class */
  function() {
    function e() {
      function t(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = Ot("diag");
          if (u)
            return u[i].apply(u, Hc([], $c(o), !1));
        };
      }
      var r = this, n = function(i, o) {
        var a, u, c;
        if (o === void 0 && (o = { logLevel: L.INFO }), i === r) {
          var s = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return r.error((a = s.stack) !== null && a !== void 0 ? a : s.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var l = Ot("diag"), f = Gc((u = o.logLevel) !== null && u !== void 0 ? u : L.INFO, i);
        if (l && !o.suppressOverrideMessage) {
          var d = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
          l.warn("Current logger will be overwritten from " + d), f.warn("Current logger will overwrite one already registered from " + d);
        }
        return Ae("diag", f, r, !0);
      };
      r.setLogger = n, r.disable = function() {
        we(jc, r);
      }, r.createComponentLogger = function(i) {
        return new kc(i);
      }, r.verbose = t("verbose"), r.debug = t("debug"), r.info = t("info"), r.warn = t("warn"), r.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
), Vc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Fc = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Xc = (
  /** @class */
  function() {
    function e(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return e.prototype.getEntry = function(t) {
      var r = this._entries.get(t);
      if (r)
        return Object.assign({}, r);
    }, e.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var r = Vc(t, 2), n = r[0], i = r[1];
        return [n, i];
      });
    }, e.prototype.setEntry = function(t, r) {
      var n = new e(this._entries);
      return n._entries.set(t, r), n;
    }, e.prototype.removeEntry = function(t) {
      var r = new e(this._entries);
      return r._entries.delete(t), r;
    }, e.prototype.removeEntries = function() {
      for (var t, r, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new e(this._entries);
      try {
        for (var a = Fc(n), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          o._entries.delete(c);
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          u && !u.done && (r = a.return) && r.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return o;
    }, e.prototype.clear = function() {
      return new e();
    }, e;
  }()
), zc = Symbol("BaggageEntryMetadata"), qc = Y.instance();
function Kc(e) {
  return e === void 0 && (e = {}), new Xc(new Map(Object.entries(e)));
}
function wa(e) {
  return typeof e != "string" && (qc.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
    __TYPE__: zc,
    toString: function() {
      return e;
    }
  };
}
function hr(e) {
  return Symbol.for(e);
}
var Wc = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      r._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), r.getValue = function(n) {
        return r._currentContext.get(n);
      }, r.setValue = function(n, i) {
        var o = new e(r._currentContext);
        return o._currentContext.set(n, i), o;
      }, r.deleteValue = function(n) {
        var i = new e(r._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return e;
  }()
), vt = new Wc(), wt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Yc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.createGauge = function(t, r) {
      return ol;
    }, e.prototype.createHistogram = function(t, r) {
      return al;
    }, e.prototype.createCounter = function(t, r) {
      return il;
    }, e.prototype.createUpDownCounter = function(t, r) {
      return sl;
    }, e.prototype.createObservableGauge = function(t, r) {
      return cl;
    }, e.prototype.createObservableCounter = function(t, r) {
      return ul;
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      return ll;
    }, e.prototype.addBatchObservableCallback = function(t, r) {
    }, e.prototype.removeBatchObservableCallback = function(t) {
    }, e;
  }()
), _r = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), Jc = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(_r)
), Zc = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(_r)
), Qc = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(_r)
), tl = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(_r)
), ri = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.addCallback = function(t) {
    }, e.prototype.removeCallback = function(t) {
    }, e;
  }()
), el = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(ri)
), rl = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(ri)
), nl = (
  /** @class */
  function(e) {
    wt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(ri)
), Ra = new Yc(), il = new Jc(), ol = new Qc(), al = new tl(), sl = new Zc(), ul = new el(), cl = new rl(), ll = new nl();
function fl() {
  return Ra;
}
var ft;
(function(e) {
  e[e.INT = 0] = "INT", e[e.DOUBLE = 1] = "DOUBLE";
})(ft || (ft = {}));
var dl = {
  get: function(e, t) {
    if (e != null)
      return e[t];
  },
  keys: function(e) {
    return e == null ? [] : Object.keys(e);
  }
}, pl = {
  set: function(e, t, r) {
    e != null && (e[t] = r);
  }
}, hl = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, _l = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, vl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return vt;
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return r.call.apply(r, _l([n], hl(i), !1));
    }, e.prototype.bind = function(t, r) {
      return r;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), gl = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, yl = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, xr = "context", El = new vl(), vr = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return Ae(xr, t, Y.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, r, n) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, yl([t, r, n], gl(o), !1));
    }, e.prototype.bind = function(t, r) {
      return this._getContextManager().bind(t, r);
    }, e.prototype._getContextManager = function() {
      return Ot(xr) || El;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), we(xr, Y.instance());
    }, e;
  }()
), J;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(J || (J = {}));
var La = "0000000000000000", Pa = "00000000000000000000000000000000", Na = {
  traceId: Pa,
  spanId: La,
  traceFlags: J.NONE
}, le = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = Na), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, r) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, r) {
    }, e;
  }()
), ni = hr("OpenTelemetry Context Key SPAN");
function ii(e) {
  return e.getValue(ni) || void 0;
}
function ml() {
  return ii(vr.getInstance().active());
}
function oi(e, t) {
  return e.setValue(ni, t);
}
function Tl(e) {
  return e.deleteValue(ni);
}
function Sl(e, t) {
  return oi(e, new le(t));
}
function Ia(e) {
  var t;
  return (t = ii(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var Ol = /^([0-9a-f]{32})$/i, bl = /^[0-9a-f]{16}$/i;
function Ca(e) {
  return Ol.test(e) && e !== Pa;
}
function Al(e) {
  return bl.test(e) && e !== La;
}
function Re(e) {
  return Ca(e.traceId) && Al(e.spanId);
}
function wl(e) {
  return new le(e);
}
var Dr = vr.getInstance(), Ma = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, r, n) {
      n === void 0 && (n = Dr.active());
      var i = !!(r != null && r.root);
      if (i)
        return new le();
      var o = n && Ia(n);
      return Rl(o) && Re(o) ? new le(o) : new le();
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : Dr.active(), s = this.startSpan(t, o, c), l = oi(c, s);
        return Dr.with(l, u, void 0, s);
      }
    }, e;
  }()
);
function Rl(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var Ll = new Ma(), Pl = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.startSpan = function(t, r, n) {
      return this._getTracer().startSpan(t, r, n);
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Ll;
    }, e;
  }()
), Nl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      return new Ma();
    }, e;
  }()
), Il = new Nl(), ki = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i;
      return (i = this.getDelegateTracer(t, r, n)) !== null && i !== void 0 ? i : new Pl(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Il;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, r, n);
    }, e;
  }()
), tr;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(tr || (tr = {}));
var ge;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(ge || (ge = {}));
var er;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(er || (er = {}));
var b = vr.getInstance(), v = Y.instance(), Cl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getMeter = function(t, r, n) {
      return Ra;
    }, e;
  }()
), Ml = new Cl(), Ur = "metrics", xl = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(t) {
      return Ae(Ur, t, Y.instance());
    }, e.prototype.getMeterProvider = function() {
      return Ot(Ur) || Ml;
    }, e.prototype.getMeter = function(t, r, n) {
      return this.getMeterProvider().getMeter(t, r, n);
    }, e.prototype.disable = function() {
      we(Ur, Y.instance());
    }, e;
  }()
), qt = xl.getInstance(), Dl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r) {
    }, e.prototype.extract = function(t, r) {
      return t;
    }, e.prototype.fields = function() {
      return [];
    }, e;
  }()
), ai = hr("OpenTelemetry Baggage Key");
function xa(e) {
  return e.getValue(ai) || void 0;
}
function Ul() {
  return xa(vr.getInstance().active());
}
function Bl(e, t) {
  return e.setValue(ai, t);
}
function kl(e) {
  return e.deleteValue(ai);
}
var Br = "propagation", Gl = new Dl(), $l = (
  /** @class */
  function() {
    function e() {
      this.createBaggage = Kc, this.getBaggage = xa, this.getActiveBaggage = Ul, this.setBaggage = Bl, this.deleteBaggage = kl;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalPropagator = function(t) {
      return Ae(Br, t, Y.instance());
    }, e.prototype.inject = function(t, r, n) {
      return n === void 0 && (n = pl), this._getGlobalPropagator().inject(t, r, n);
    }, e.prototype.extract = function(t, r, n) {
      return n === void 0 && (n = dl), this._getGlobalPropagator().extract(t, r, n);
    }, e.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
      we(Br, Y.instance());
    }, e.prototype._getGlobalPropagator = function() {
      return Ot(Br) || Gl;
    }, e;
  }()
), k = $l.getInstance(), kr = "trace", Hl = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new ki(), this.wrapSpanContext = wl, this.isSpanContextValid = Re, this.deleteSpan = Tl, this.getSpan = ii, this.getActiveSpan = ml, this.getSpanContext = Ia, this.setSpan = oi, this.setSpanContext = Sl;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var r = Ae(kr, this._proxyTracerProvider, Y.instance());
      return r && this._proxyTracerProvider.setDelegate(t), r;
    }, e.prototype.getTracerProvider = function() {
      return Ot(kr) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, r) {
      return this.getTracerProvider().getTracer(t, r);
    }, e.prototype.disable = function() {
      we(kr, Y.instance()), this._proxyTracerProvider = new ki();
    }, e;
  }()
), R = Hl.getInstance(), Da = hr("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function jl(e) {
  return e.setValue(Da, !0);
}
function Ua(e) {
  return e.getValue(Da) === !0;
}
var Vl = "=", On = ";", bn = ",", Gr = "baggage", Fl = 180, Xl = 4096, zl = 8192, ql = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Kl(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? bn : "") + r;
    return n.length > zl ? t : n;
  }, "");
}
function Wl(e) {
  return e.getAllEntries().map(function(t) {
    var r = ql(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += On + i.metadata.toString()), o;
  });
}
function Yl(e) {
  var t = e.split(On);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(Vl);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = wa(t.join(On))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var Jl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = k.getBaggage(t);
      if (!(!i || Ua(t))) {
        var o = Wl(i).filter(function(u) {
          return u.length <= Xl;
        }).slice(0, Fl), a = Kl(o);
        a.length > 0 && n.set(r, Gr, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Gr), o = Array.isArray(i) ? i.join(bn) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(bn);
      return u.forEach(function(c) {
        var s = Yl(c);
        if (s) {
          var l = { value: s.value };
          s.metadata && (l.metadata = s.metadata), a[s.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : k.setBaggage(t, k.createBaggage(a));
    }, e.prototype.fields = function() {
      return [Gr];
    }, e;
  }()
);
function Zl() {
  return function(e) {
    v.error(Ql(e));
  };
}
function Ql(e) {
  return typeof e == "string" ? e : JSON.stringify(tf(e));
}
function tf(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var ef = Zl();
function Gi(e) {
  try {
    ef(e);
  } catch (t) {
  }
}
var An;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(An || (An = {}));
var rf = ",", nf = ["OTEL_SDK_DISABLED"];
function of(e) {
  return nf.indexOf(e) > -1;
}
var af = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function sf(e) {
  return af.indexOf(e) > -1;
}
var uf = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function cf(e) {
  return uf.indexOf(e) > -1;
}
var $r = 1 / 0, Hr = 128, lf = 128, ff = 128, Ba = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: L.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: $r,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Hr,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: $r,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Hr,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: $r,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Hr,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: lf,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: ff,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: An.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function df(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function pf(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function hf(e, t, r, n) {
  n === void 0 && (n = rf);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var _f = {
  ALL: L.ALL,
  VERBOSE: L.VERBOSE,
  DEBUG: L.DEBUG,
  INFO: L.INFO,
  WARN: L.WARN,
  ERROR: L.ERROR,
  NONE: L.NONE
};
function vf(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = _f[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function gf(e) {
  var t = {};
  for (var r in Ba) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        vf(n, t, e);
        break;
      default:
        if (of(n))
          df(n, t, e);
        else if (sf(n))
          pf(n, t, e);
        else if (cf(n))
          hf(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var yf = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Ef() {
  var e = gf(yf);
  return Object.assign({}, Ba, e);
}
function $i(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function si(e) {
  for (var t = new Uint8Array(e.length / 2), r = 0, n = 0; n < e.length; n += 2) {
    var i = $i(e.charCodeAt(n)), o = $i(e.charCodeAt(n + 1));
    t[r++] = i << 4 | o;
  }
  return t;
}
var wn = performance, mf = "1.30.1", Tf = "process.runtime.name", Sf = "telemetry.sdk.name", Of = "telemetry.sdk.language", bf = "telemetry.sdk.version", Af = Tf, wf = Sf, Rf = Of, Lf = bf, Pf = "webjs", Nf = Pf, Dt, jr = (Dt = {}, Dt[wf] = "opentelemetry", Dt[Af] = "browser", Dt[Rf] = Nf, Dt[Lf] = mf, Dt), If = 9, Cf = 6, Mf = Math.pow(10, Cf), Rn = Math.pow(10, If);
function ye(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Mf);
  return [r, n];
}
function xf() {
  var e = wn.timeOrigin;
  if (typeof e != "number") {
    var t = wn;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Df(e) {
  var t = ye(xf()), r = ye(wn.now());
  return Bf(t, r);
}
function Uf(e) {
  return e[0] * Rn + e[1];
}
function Me(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
function Bf(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= Rn && (r[1] -= Rn, r[0] += 1), r;
}
var N;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(N || (N = {}));
var kf = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Gf = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = kf(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            v.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          v.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), Ln = "[_0-9a-z-*/]", $f = "[a-z]" + Ln + "{0,255}", Hf = "[a-z0-9]" + Ln + "{0,240}@[a-z]" + Ln + "{0,13}", jf = new RegExp("^(?:" + $f + "|" + Hf + ")$"), Vf = /^[ -~]{0,255}[!-~]$/, Ff = /,|=/;
function Xf(e) {
  return jf.test(e);
}
function zf(e) {
  return Vf.test(e) && !Ff.test(e);
}
var Hi = 32, qf = 512, ji = ",", Vi = "=", Kf = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + Vi + t.get(n)), r;
      }, []).join(ji);
    }, e.prototype._parse = function(t) {
      t.length > qf || (this._internalState = t.split(ji).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(Vi);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          Xf(a) && zf(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > Hi && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Hi))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), Vr = "traceparent", Fr = "tracestate", Wf = "00", Yf = "(?!ff)[\\da-f]{2}", Jf = "(?![0]{32})[\\da-f]{32}", Zf = "(?![0]{16})[\\da-f]{16}", Qf = "[\\da-f]{2}", td = new RegExp("^\\s?(" + Yf + ")-(" + Jf + ")-(" + Zf + ")-(" + Qf + ")(-.*)?\\s?$");
function ed(e) {
  var t = td.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var rd = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = R.getSpanContext(t);
      if (!(!i || Ua(t) || !Re(i))) {
        var o = Wf + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || J.NONE).toString(16);
        n.set(r, Vr, o), i.traceState && n.set(r, Fr, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Vr);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = ed(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, Fr);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new Kf(typeof c == "string" ? c : void 0);
      }
      return R.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [Vr, Fr];
    }, e;
  }()
), nd = "[object Object]", id = "[object Null]", od = "[object Undefined]", ad = Function.prototype, ka = ad.toString, sd = ka.call(Object), ud = cd(Object.getPrototypeOf, Object), Ga = Object.prototype, $a = Ga.hasOwnProperty, gt = Symbol ? Symbol.toStringTag : void 0, Ha = Ga.toString;
function cd(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function Fi(e) {
  if (!ld(e) || fd(e) !== nd)
    return !1;
  var t = ud(e);
  if (t === null)
    return !0;
  var r = $a.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && ka.call(r) === sd;
}
function ld(e) {
  return e != null && typeof e == "object";
}
function fd(e) {
  return e == null ? e === void 0 ? od : id : gt && gt in Object(e) ? dd(e) : pd(e);
}
function dd(e) {
  var t = $a.call(e, gt), r = e[gt], n = !1;
  try {
    e[gt] = void 0, n = !0;
  } catch (o) {
  }
  var i = Ha.call(e);
  return n && (t ? e[gt] = r : delete e[gt]), i;
}
function pd(e) {
  return Ha.call(e);
}
var hd = 20;
function _d() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = ja(r, e.shift(), 0, n);
  return r;
}
function Xr(e) {
  return rr(e) ? e.slice() : e;
}
function ja(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > hd)) {
    if (r++, Ke(e) || Ke(t) || Va(t))
      i = Xr(t);
    else if (rr(e)) {
      if (i = e.slice(), rr(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(Xr(t[o]));
      else if (ee(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = Xr(t[c]);
        }
    } else if (ee(e))
      if (ee(t)) {
        if (!vd(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (Ke(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var l = i[c], f = s;
            if (Xi(e, c, n) || Xi(t, c, n))
              delete i[c];
            else {
              if (ee(l) && ee(f)) {
                var d = n.get(l) || [], p = n.get(f) || [];
                d.push({ obj: e, key: c }), p.push({ obj: t, key: c }), n.set(l, d), n.set(f, p);
              }
              i[c] = ja(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Xi(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function rr(e) {
  return Array.isArray(e);
}
function Va(e) {
  return typeof e == "function";
}
function ee(e) {
  return !Ke(e) && !rr(e) && !Va(e) && typeof e == "object";
}
function Ke(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function vd(e, t) {
  return !(!Fi(e) || !Fi(t));
}
function gd(e, t) {
  return new Promise(function(r) {
    b.with(jl(b.active()), function() {
      e.export(t, function(n) {
        r(n);
      });
    });
  });
}
var yd = {
  _export: gd
}, Fa = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), Ed = new Fa(), md = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new Fa();
    }, e;
  }()
), Xa = new md(), Td = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Ed;
    }, e;
  }()
), zi = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new Td(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Xa;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), Sd = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, xe = Symbol.for("io.opentelemetry.js.api.logs"), re = Sd;
function Od(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var qi = 1, bd = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new zi();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return re[xe] ? this.getLoggerProvider() : (re[xe] = Od(qi, t, Xa), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = re[xe]) === null || t === void 0 ? void 0 : t.call(re, qi)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete re[xe], this._proxyLoggerProvider = new zi();
    }, e;
  }()
), za = bd.getInstance();
function Ad(e, t, r, n) {
  for (var i = 0, o = e.length; i < o; i++) {
    var a = e[i];
    t && a.setTracerProvider(t), r && a.setMeterProvider(r), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function wd(e) {
  e.forEach(function(t) {
    return t.disable();
  });
}
function Rd(e) {
  var t, r, n = e.tracerProvider || R.getTracerProvider(), i = e.meterProvider || qt.getMeterProvider(), o = e.loggerProvider || za.getLoggerProvider(), a = (r = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && r !== void 0 ? r : [];
  return Ad(a, n, i, o), function() {
    wd(a);
  };
}
function Pn(e) {
  return typeof e == "function";
}
var G = console.error.bind(console);
function ne(e, t, r) {
  var n = !!e[t] && e.propertyIsEnumerable(t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: r
  });
}
function Le(e) {
  e && e.logger && (Pn(e.logger) ? G = e.logger : G("new logger isn't a function, not replacing"));
}
function qa(e, t, r) {
  if (!e || !e[t]) {
    G("no original function " + t + " to wrap");
    return;
  }
  if (!r) {
    G("no wrapper function"), G(new Error().stack);
    return;
  }
  if (!Pn(e[t]) || !Pn(r)) {
    G("original object and wrapper must be functions");
    return;
  }
  var n = e[t], i = r(n, t);
  return ne(i, "__original", n), ne(i, "__unwrap", function() {
    e[t] === i && ne(e, t, n);
  }), ne(i, "__wrapped", !0), ne(e, t, i), i;
}
function Ld(e, t, r) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    G("must provide one or more modules to patch"), G(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    G("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach(function(n) {
    t.forEach(function(i) {
      qa(n, i, r);
    });
  });
}
function Ka(e, t) {
  if (!e || !e[t]) {
    G("no function to unwrap."), G(new Error().stack);
    return;
  }
  if (!e[t].__unwrap)
    G("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return e[t].__unwrap();
}
function Pd(e, t) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    G("must provide one or more modules to patch"), G(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    G("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach(function(r) {
    t.forEach(function(n) {
      Ka(r, n);
    });
  });
}
Le.wrap = qa;
Le.massWrap = Ld;
Le.unwrap = Ka;
Le.massUnwrap = Pd;
var D = Le, Nn = function() {
  return Nn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Nn.apply(this, arguments);
}, Nd = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = D.wrap, this._unwrap = D.unwrap, this._massWrap = D.massWrap, this._massUnwrap = D.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = R.getTracer(t, r), this._meter = qt.getMeter(t, r), this._logger = za.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = Nn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), Id = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Wa = (
  /** @class */
  function(e) {
    Id(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Nd)
);
function B(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var nr = performance, Cd = "traceparent", Ya = hr("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Md(e) {
  return e.setValue(Ya, !0);
}
function ui(e) {
  return e.getValue(Ya) === !0;
}
var xd = "=", In = ";", Cn = ",", zr = "baggage", Dd = 180, Ud = 4096, Bd = 8192, kd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Gd(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? Cn : "") + r;
    return n.length > Bd ? t : n;
  }, "");
}
function $d(e) {
  return e.getAllEntries().map(function(t) {
    var r = kd(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += In + i.metadata.toString()), o;
  });
}
function Hd(e) {
  var t = e.split(In);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(xd);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = wa(t.join(In))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var jd = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = k.getBaggage(t);
      if (!(!i || ui(t))) {
        var o = $d(i).filter(function(u) {
          return u.length <= Ud;
        }).slice(0, Dd), a = Gd(o);
        a.length > 0 && n.set(r, zr, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, zr), o = Array.isArray(i) ? i.join(Cn) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(Cn);
      return u.forEach(function(c) {
        var s = Hd(c);
        if (s) {
          var l = { value: s.value };
          s.metadata && (l.metadata = s.metadata), a[s.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : k.setBaggage(t, k.createBaggage(a));
    }, e.prototype.fields = function() {
      return [zr];
    }, e;
  }()
), Ja = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Vd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function We(e) {
  var t, r, n = {};
  if (typeof e != "object" || e == null)
    return n;
  try {
    for (var i = Ja(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = Vd(o.value, 2), u = a[0], c = a[1];
      if (!Fd(u)) {
        v.warn("Invalid attribute key: " + u);
        continue;
      }
      if (!Za(c)) {
        v.warn("Invalid attribute value set for key: " + u);
        continue;
      }
      Array.isArray(c) ? n[u] = c.slice() : n[u] = c;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function Fd(e) {
  return typeof e == "string" && e.length > 0;
}
function Za(e) {
  return e == null ? !0 : Array.isArray(e) ? Xd(e) : Qa(e);
}
function Xd(e) {
  var t, r, n;
  try {
    for (var i = Ja(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (Qa(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function Qa(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function zd() {
  return function(e) {
    v.error(qd(e));
  };
}
function qd(e) {
  return typeof e == "string" ? e : JSON.stringify(Kd(e));
}
function Kd(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var Wd = zd();
function Ft(e) {
  try {
    Wd(e);
  } catch (t) {
  }
}
var q;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(q || (q = {}));
var Yd = ",", Jd = ["OTEL_SDK_DISABLED"];
function Zd(e) {
  return Jd.indexOf(e) > -1;
}
var Qd = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function tp(e) {
  return Qd.indexOf(e) > -1;
}
var ep = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function rp(e) {
  return ep.indexOf(e) > -1;
}
var Ye = 1 / 0, Je = 128, np = 128, ip = 128, ts = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: L.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: Ye,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Je,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: Ye,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Je,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: Ye,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Je,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: np,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: ip,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: q.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function op(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function ap(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function sp(e, t, r, n) {
  n === void 0 && (n = Yd);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var up = {
  ALL: L.ALL,
  VERBOSE: L.VERBOSE,
  DEBUG: L.DEBUG,
  INFO: L.INFO,
  WARN: L.WARN,
  ERROR: L.ERROR,
  NONE: L.NONE
};
function cp(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = up[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function es(e) {
  var t = {};
  for (var r in ts) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        cp(n, t, e);
        break;
      default:
        if (Zd(n))
          op(n, t, e);
        else if (tp(n))
          ap(n, t, e);
        else if (rp(n))
          sp(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var rs = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Ee() {
  var e = es(rs);
  return Object.assign({}, ts, e);
}
function lp() {
  return es(rs);
}
var Ht = performance, fp = "1.30.1", dp = "exception.type", pp = "exception.message", hp = "exception.stacktrace", _p = "http.response_content_length", vp = "http.response_content_length_uncompressed", qr = dp, Kr = pp, gp = hp, yp = _p, Ep = vp, mp = "process.runtime.name", Tp = "service.name", Sp = "telemetry.sdk.name", Op = "telemetry.sdk.language", bp = "telemetry.sdk.version", Ap = mp, wp = Tp, Mn = Sp, xn = Op, Dn = bp, Rp = "webjs", Lp = Rp, Ut, Wr = (Ut = {}, Ut[Mn] = "opentelemetry", Ut[Ap] = "browser", Ut[xn] = Lp, Ut[Dn] = fp, Ut), Pp = 9, Np = 6, Ip = Math.pow(10, Np), ir = Math.pow(10, Pp);
function ut(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Ip);
  return [r, n];
}
function ci() {
  var e = Ht.timeOrigin;
  if (typeof e != "number") {
    var t = Ht;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function ns(e) {
  var t = ut(ci()), r = ut(typeof e == "number" ? e : Ht.now());
  return is(t, r);
}
function fe(e) {
  if (li(e))
    return e;
  if (typeof e == "number")
    return e < ci() ? ns(e) : ut(e);
  if (e instanceof Date)
    return ut(e.getTime());
  throw TypeError("Invalid input type");
}
function Cp(e, t) {
  var r = t[0] - e[0], n = t[1] - e[1];
  return n < 0 && (r -= 1, n += ir), [r, n];
}
function ct(e) {
  return e[0] * ir + e[1];
}
function li(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function Ki(e) {
  return li(e) || typeof e == "number" || e instanceof Date;
}
function is(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= ir && (r[1] -= ir, r[0] += 1), r;
}
var Un;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(Un || (Un = {}));
var Mp = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, xp = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = Mp(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            v.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          v.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), Bn = "[_0-9a-z-*/]", Dp = "[a-z]" + Bn + "{0,255}", Up = "[a-z0-9]" + Bn + "{0,240}@[a-z]" + Bn + "{0,13}", Bp = new RegExp("^(?:" + Dp + "|" + Up + ")$"), kp = /^[ -~]{0,255}[!-~]$/, Gp = /,|=/;
function $p(e) {
  return Bp.test(e);
}
function Hp(e) {
  return kp.test(e) && !Gp.test(e);
}
var Wi = 32, jp = 512, Yi = ",", Ji = "=", Vp = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + Ji + t.get(n)), r;
      }, []).join(Yi);
    }, e.prototype._parse = function(t) {
      t.length > jp || (this._internalState = t.split(Yi).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(Ji);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          $p(a) && Hp(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > Wi && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Wi))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), Yr = "traceparent", Jr = "tracestate", Fp = "00", Xp = "(?!ff)[\\da-f]{2}", zp = "(?![0]{32})[\\da-f]{32}", qp = "(?![0]{16})[\\da-f]{16}", Kp = "[\\da-f]{2}", Wp = new RegExp("^\\s?(" + Xp + ")-(" + zp + ")-(" + qp + ")-(" + Kp + ")(-.*)?\\s?$");
function Yp(e) {
  var t = Wp.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var Jp = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = R.getSpanContext(t);
      if (!(!i || ui(t) || !Re(i))) {
        var o = Fp + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || J.NONE).toString(16);
        n.set(r, Yr, o), i.traceState && n.set(r, Jr, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Yr);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = Yp(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, Jr);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new Vp(typeof c == "string" ? c : void 0);
      }
      return R.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [Yr, Jr];
    }, e;
  }()
), Zp = "[object Object]", Qp = "[object Null]", th = "[object Undefined]", eh = Function.prototype, os = eh.toString, rh = os.call(Object), nh = ih(Object.getPrototypeOf, Object), as = Object.prototype, ss = as.hasOwnProperty, yt = Symbol ? Symbol.toStringTag : void 0, us = as.toString;
function ih(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function Zi(e) {
  if (!oh(e) || ah(e) !== Zp)
    return !1;
  var t = nh(e);
  if (t === null)
    return !0;
  var r = ss.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && os.call(r) === rh;
}
function oh(e) {
  return e != null && typeof e == "object";
}
function ah(e) {
  return e == null ? e === void 0 ? th : Qp : yt && yt in Object(e) ? sh(e) : uh(e);
}
function sh(e) {
  var t = ss.call(e, yt), r = e[yt], n = !1;
  try {
    e[yt] = void 0, n = !0;
  } catch (o) {
  }
  var i = us.call(e);
  return n && (t ? e[yt] = r : delete e[yt]), i;
}
function uh(e) {
  return us.call(e);
}
var ch = 20;
function lh() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = cs(r, e.shift(), 0, n);
  return r;
}
function Zr(e) {
  return or(e) ? e.slice() : e;
}
function cs(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > ch)) {
    if (r++, Ze(e) || Ze(t) || ls(t))
      i = Zr(t);
    else if (or(e)) {
      if (i = e.slice(), or(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(Zr(t[o]));
      else if (ie(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = Zr(t[c]);
        }
    } else if (ie(e))
      if (ie(t)) {
        if (!fh(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (Ze(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var l = i[c], f = s;
            if (Qi(e, c, n) || Qi(t, c, n))
              delete i[c];
            else {
              if (ie(l) && ie(f)) {
                var d = n.get(l) || [], p = n.get(f) || [];
                d.push({ obj: e, key: c }), p.push({ obj: t, key: c }), n.set(l, d), n.set(f, p);
              }
              i[c] = cs(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Qi(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function or(e) {
  return Array.isArray(e);
}
function ls(e) {
  return typeof e == "function";
}
function ie(e) {
  return !Ze(e) && !or(e) && !ls(e) && typeof e == "object";
}
function Ze(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function fh(e, t) {
  return !(!Zi(e) || !Zi(t));
}
function dh(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
var ph = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(r, n) {
        t._resolve = r, t._reject = n;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), hh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, _h = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, vh = (
  /** @class */
  function() {
    function e(t, r) {
      this._callback = t, this._that = r, this._isCalled = !1, this._deferred = new ph();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, _h([this._that], hh(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
), gh = "exception", kn = function() {
  return kn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, kn.apply(this, arguments);
}, yh = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, to = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Eh = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, mh = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, l) {
      u === void 0 && (u = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: er.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = u;
      var f = Date.now();
      this._performanceStartTime = Ht.now(), this._performanceOffset = f - (this._performanceStartTime + ci()), this._startTimeProvided = c != null, this.startTime = this._getTime(c != null ? c : f), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, l != null && this.setAttributes(l), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, r);
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return r == null || this._isSpanEnded() ? this : t.length === 0 ? (v.warn("Invalid attribute key: " + t), this) : Za(r) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(r), this) : (v.warn("Invalid attribute value set for key: " + t), this);
    }, e.prototype.setAttributes = function(t) {
      var r, n;
      try {
        for (var i = yh(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = to(o.value, 2), u = a[0], c = a[1];
          this.setAttribute(u, c);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
      return this;
    }, e.prototype.addEvent = function(t, r, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return v.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && v.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), Ki(r) && (Ki(n) || (n = r), r = void 0);
      var i = We(r);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, e.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, e.prototype.addLinks = function(t) {
      var r;
      return (r = this.links).push.apply(r, Eh([], to(t), !1)), this;
    }, e.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = kn({}, t), this.status.message != null && typeof t.message != "string" && (v.warn("Dropping invalid status.message of type '" + typeof t.message + "', expected 'string'"), delete this.status.message), this);
    }, e.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, e.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        v.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = Cp(this.startTime, this.endTime), this._duration[0] < 0 && (v.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && v.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, e.prototype._getTime = function(t) {
      if (typeof t == "number" && t <= Ht.now())
        return ns(t + this._performanceOffset);
      if (typeof t == "number")
        return ut(t);
      if (t instanceof Date)
        return ut(t.getTime());
      if (li(t))
        return t;
      if (this._startTimeProvided)
        return ut(Date.now());
      var r = Ht.now() - this._performanceStartTime;
      return is(this.startTime, ut(r));
    }, e.prototype.isRecording = function() {
      return this._ended === !1;
    }, e.prototype.recordException = function(t, r) {
      var n = {};
      typeof t == "string" ? n[Kr] = t : t && (t.code ? n[qr] = t.code.toString() : t.name && (n[qr] = t.name), t.message && (n[Kr] = t.message), t.stack && (n[gp] = t.stack)), n[qr] || n[Kr] ? this.addEvent(gh, n, r) : v.warn("Failed to record an exception " + t);
    }, Object.defineProperty(e.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._isSpanEnded = function() {
      return this._ended && v.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(t, r) {
      return t.length <= r ? t : t.substring(0, r);
    }, e.prototype._truncateToSize = function(t) {
      var r = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (v.warn("Attribute value limit must be positive, got " + n), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? r._truncateToLimitUtil(i, n) : i;
      }) : t;
    }, e;
  }()
), Xt;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Xt || (Xt = {}));
var ar = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Xt.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, e;
  }()
), jt = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Xt.RECORD_AND_SAMPLED
      };
    }, e.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, e;
  }()
), Qr = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o;
      this._root = t.root, this._root || (Ft(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new jt()), this._remoteParentSampled = (r = t.remoteParentSampled) !== null && r !== void 0 ? r : new jt(), this._remoteParentNotSampled = (n = t.remoteParentNotSampled) !== null && n !== void 0 ? n : new ar(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new jt(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new ar();
    }
    return e.prototype.shouldSample = function(t, r, n, i, o, a) {
      var u = R.getSpanContext(t);
      return !u || !Re(u) ? this._root.shouldSample(t, r, n, i, o, a) : u.isRemote ? u.traceFlags & J.SAMPLED ? this._remoteParentSampled.shouldSample(t, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(t, r, n, i, o, a) : u.traceFlags & J.SAMPLED ? this._localParentSampled.shouldSample(t, r, n, i, o, a) : this._localParentNotSampled.shouldSample(t, r, n, i, o, a);
    }, e.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
  }()
), eo = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return e.prototype.shouldSample = function(t, r) {
      return {
        decision: Ca(r) && this._accumulate(r) < this._upperBound ? Xt.RECORD_AND_SAMPLED : Xt.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, e.prototype._accumulate = function(t) {
      for (var r = 0, n = 0; n < t.length / 8; n++) {
        var i = n * 8, o = parseInt(t.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, e;
  }()
), Th = q.AlwaysOn, Bt = 1;
function fs() {
  var e = Ee();
  return {
    sampler: ds(e),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function ds(e) {
  switch (e === void 0 && (e = Ee()), e.OTEL_TRACES_SAMPLER) {
    case q.AlwaysOn:
      return new jt();
    case q.AlwaysOff:
      return new ar();
    case q.ParentBasedAlwaysOn:
      return new Qr({
        root: new jt()
      });
    case q.ParentBasedAlwaysOff:
      return new Qr({
        root: new ar()
      });
    case q.TraceIdRatio:
      return new eo(ro(e));
    case q.ParentBasedTraceIdRatio:
      return new Qr({
        root: new eo(ro(e))
      });
    default:
      return v.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + Th + '".'), new jt();
  }
}
function ro(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "")
    return v.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + Bt + "."), Bt;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + Bt + "."), Bt) : t < 0 || t > 1 ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + Bt + "."), Bt) : t;
}
function Sh(e) {
  var t = {
    sampler: ds()
  }, r = fs(), n = Object.assign({}, r, t, e);
  return n.generalLimits = Object.assign({}, r.generalLimits, e.generalLimits || {}), n.spanLimits = Object.assign({}, r.spanLimits, e.spanLimits || {}), n;
}
function Oh(e) {
  var t, r, n, i, o, a, u, c, s, l, f, d, p = Object.assign({}, e.spanLimits), _ = lp();
  return p.attributeCountLimit = (a = (o = (i = (r = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && r !== void 0 ? r : (n = e.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : _.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : _.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Je, p.attributeValueLengthLimit = (d = (f = (l = (c = (u = e.spanLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : (s = e.generalLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && l !== void 0 ? l : _.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : _.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : Ye, Object.assign({}, e, { spanLimits: p });
}
var bh = (
  /** @class */
  function() {
    function e(t, r) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = Ee();
      this._maxExportBatchSize = typeof (r == null ? void 0 : r.maxExportBatchSize) == "number" ? r.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (r == null ? void 0 : r.maxQueueSize) == "number" ? r.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (r == null ? void 0 : r.scheduledDelayMillis) == "number" ? r.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (r == null ? void 0 : r.exportTimeoutMillis) == "number" ? r.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new vh(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (v.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || (t.spanContext().traceFlags & J.SAMPLED) !== 0 && this._addToBuffer(t);
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, e.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && v.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (v.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(r, n) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, u = o; a < u; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          r();
        }).catch(n);
      });
    }, e.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(r, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        b.with(Md(b.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(f) {
              var d;
              clearTimeout(i), f.code === Un.SUCCESS ? r() : n((d = f.error) !== null && d !== void 0 ? d : new Error("BatchSpanProcessor: span export failed"));
            });
          }, u = null, c = 0, s = o.length; c < s; c++) {
            var l = o[c];
            l.resource.asyncAttributesPending && l.resource.waitForAsyncAttributes && (u != null || (u = []), u.push(l.resource.waitForAsyncAttributes()));
          }
          u === null ? a() : Promise.all(u).then(a, function(f) {
            Ft(f), n(f);
          });
        });
      });
    }, e.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var r = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(n) {
            t._isExporting = !1, Ft(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return r();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return r();
        }, this._scheduledDelayMillis));
      }
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
  }()
), Ah = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ps = (
  /** @class */
  function(e) {
    Ah(t, e);
    function t(r, n) {
      var i = e.call(this, r, n) || this;
      return i.onInit(n), i;
    }
    return t.prototype.onInit = function(r) {
      var n = this;
      (r == null ? void 0 : r.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush().catch(function(i) {
          Ft(i);
        });
      }, this._pageHideListener = function() {
        n.forceFlush().catch(function(i) {
          Ft(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(bh)
), wh = 8, Rh = 16, Lh = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.generateTraceId = no(Rh), this.generateSpanId = no(wh);
    }
    return e;
  }()
), De = Array(32);
function no(e) {
  return function() {
    for (var r = 0; r < e * 2; r++)
      De[r] = Math.floor(Math.random() * 16) + 48, De[r] >= 58 && (De[r] += 39);
    return String.fromCharCode.apply(null, De.slice(0, e * 2));
  };
}
var Ph = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._tracerProvider = n;
      var i = Sh(r);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = r.idGenerator || new Lh(), this.resource = n.resource, this.instrumentationLibrary = t;
    }
    return e.prototype.startSpan = function(t, r, n) {
      var i, o, a;
      r === void 0 && (r = {}), n === void 0 && (n = b.active()), r.root && (n = R.deleteSpan(n));
      var u = R.getSpan(n);
      if (ui(n)) {
        v.debug("Instrumentation suppressed, returning Noop Span");
        var c = R.wrapSpanContext(Na);
        return c;
      }
      var s = u == null ? void 0 : u.spanContext(), l = this._idGenerator.generateSpanId(), f, d, p;
      !s || !R.isSpanContextValid(s) ? f = this._idGenerator.generateTraceId() : (f = s.traceId, d = s.traceState, p = s.spanId);
      var _ = (i = r.kind) !== null && i !== void 0 ? i : ge.INTERNAL, h = ((o = r.links) !== null && o !== void 0 ? o : []).map(function(M) {
        return {
          context: M.context,
          attributes: We(M.attributes)
        };
      }), g = We(r.attributes), y = this._sampler.shouldSample(n, f, t, _, g, h);
      d = (a = y.traceState) !== null && a !== void 0 ? a : d;
      var E = y.decision === tr.RECORD_AND_SAMPLED ? J.SAMPLED : J.NONE, A = { traceId: f, spanId: l, traceFlags: E, traceState: d };
      if (y.decision === tr.NOT_RECORD) {
        v.debug("Recording is off, propagating context in a non-recording span");
        var c = R.wrapSpanContext(A);
        return c;
      }
      var w = We(Object.assign(g, y.attributes)), P = new mh(this, n, t, A, _, p, h, r.startTime, void 0, w);
      return P;
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : b.active(), s = this.startSpan(t, o, c), l = R.setSpan(c, s);
        return b.with(l, u, void 0, s);
      }
    }, e.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, e;
  }()
);
function Nh() {
  return "unknown_service";
}
var ot = function() {
  return ot = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ot.apply(this, arguments);
}, Ih = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Ch = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Mh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, io = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return v.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[wp] = Nh(), t[xn] = Wr[xn], t[Mn] = Wr[Mn], t[Dn] = Wr[Dn], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && v.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return Ih(this, void 0, void 0, function() {
        return Ch(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = ot(ot({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = Mh(a, 2), s = c[0], l = c[1];
        return ot(ot(ot(ot({}, r._syncAttributes), s), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
), Ue = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, oo = (
  /** @class */
  function() {
    function e(t) {
      this._spanProcessors = t;
    }
    return e.prototype.forceFlush = function() {
      var t, r, n = [];
      try {
        for (var i = Ue(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u) {
        Promise.all(n).then(function() {
          u();
        }).catch(function(c) {
          Ft(c || new Error("MultiSpanProcessor: forceFlush failed")), u();
        });
      });
    }, e.prototype.onStart = function(t, r) {
      var n, i;
      try {
        for (var o = Ue(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          u.onStart(t, r);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.onEnd = function(t) {
      var r, n;
      try {
        for (var i = Ue(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (u) {
        r = { error: u };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype.shutdown = function() {
      var t, r, n = [];
      try {
        for (var i = Ue(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u, c) {
        Promise.all(n).then(function() {
          u();
        }, c);
      });
    }, e;
  }()
), xh = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e;
  }()
), Dh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Uh = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Et;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(Et || (Et = {}));
var Bh = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r, n;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = lh({}, fs(), Oh(t));
      if (this.resource = (r = i.resource) !== null && r !== void 0 ? r : io.empty(), i.mergeResourceWithDefaults && (this.resource = io.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((n = t.spanProcessors) === null || n === void 0) && n.length)
        this._registeredSpanProcessors = Uh([], Dh(t.spanProcessors), !1), this.activeSpanProcessor = new oo(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new ps(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new xh();
      }
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i = t + "@" + (r || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new Ph({ name: t, version: r, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, e.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(r) {
        return v.error("Error while trying to shutdown current span processor", r);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new oo(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, e.prototype.register = function(t) {
      t === void 0 && (t = {}), R.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && b.setGlobalContextManager(t.contextManager), t.propagator && k.setGlobalPropagator(t.propagator);
    }, e.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, r = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = Et.timeout;
          }, t);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== Et.timeout && (o = Et.resolved, i(o));
          }).catch(function(u) {
            clearTimeout(a), o = Et.error, i(u);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(r).then(function(o) {
          var a = o.filter(function(u) {
            return u !== Et.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, e.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(t) {
      var r;
      return (r = this.constructor._registeredPropagators.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._getSpanExporter = function(t) {
      var r;
      return (r = this.constructor._registeredExporters.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._buildPropagatorFromEnv = function() {
      var t = this, r = Array.from(new Set(Ee().OTEL_PROPAGATORS)), n = r.map(function(o) {
        var a = t._getPropagator(o);
        return a || v.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return r.length === 1 ? i[0] : new xp({
          propagators: i
        });
    }, e.prototype._buildExporterFromEnv = function() {
      var t = Ee().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var r = this._getSpanExporter(t);
        return r || v.error('Exporter "' + t + '" requested through environment variable is unavailable.'), r;
      }
    }, e._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new Jp();
      }],
      ["baggage", function() {
        return new jd();
      }]
    ]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
  }()
), kh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Gh = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, hs = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._currentContext = vt;
    }
    return e.prototype._bindFunction = function(t, r) {
      t === void 0 && (t = vt);
      var n = this, i = function() {
        for (var o = this, a = [], u = 0; u < arguments.length; u++)
          a[u] = arguments[u];
        return n.with(t, function() {
          return r.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: r.length
      }), i;
    }, e.prototype.active = function() {
      return this._currentContext;
    }, e.prototype.bind = function(t, r) {
      return t === void 0 && (t = this.active()), typeof r == "function" ? this._bindFunction(t, r) : r;
    }, e.prototype.disable = function() {
      return this._currentContext = vt, this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = vt, this);
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || vt;
      try {
        return r.call.apply(r, Gh([n], kh(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, e;
  }()
), $h = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Hh = (
  /** @class */
  function(e) {
    $h(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, r) || this;
      if (r.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (r.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return t.prototype.register = function(r) {
      r === void 0 && (r = {}), r.contextManager === void 0 && (r.contextManager = new hs()), r.contextManager && r.contextManager.enable(), e.prototype.register.call(this, r);
    }, t;
  }(Bh)
), T;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(T || (T = {}));
var tn;
function jh() {
  return tn || (tn = document.createElement("a")), tn;
}
function dt(e, t) {
  return t in e;
}
function C(e, t, r, n) {
  var i = void 0, o = void 0;
  dt(r, t) && typeof r[t] == "number" && (i = r[t]);
  var a = T.FETCH_START;
  if (dt(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return e.addEvent(t, i), e;
}
function zt(e, t, r) {
  r === void 0 && (r = !1), r || (C(e, T.FETCH_START, t), C(e, T.DOMAIN_LOOKUP_START, t), C(e, T.DOMAIN_LOOKUP_END, t), C(e, T.CONNECT_START, t), dt(t, "name") && t.name.startsWith("https:") && C(e, T.SECURE_CONNECTION_START, t), C(e, T.CONNECT_END, t), C(e, T.REQUEST_START, t), C(e, T.RESPONSE_START, t), C(e, T.RESPONSE_END, t));
  var n = t[T.ENCODED_BODY_SIZE];
  n !== void 0 && e.setAttribute(yp, n);
  var i = t[T.DECODED_BODY_SIZE];
  i !== void 0 && n !== i && e.setAttribute(Ep, i);
}
function Vh(e) {
  return e.slice().sort(function(t, r) {
    var n = t[T.FETCH_START], i = r[T.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function _s() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function vs(e, t, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = tt(e);
  e = a.toString();
  var u = Xh(e, t, r, n, i, o);
  if (u.length === 0)
    return {
      mainRequest: void 0
    };
  if (u.length === 1)
    return {
      mainRequest: u[0]
    };
  var c = Vh(u);
  if (a.origin !== _s() && c.length > 1) {
    var s = c[0], l = Fh(c, s[T.RESPONSE_END], r), f = s[T.RESPONSE_END], d = l[T.FETCH_START];
    return d < f && (l = s, s = void 0), {
      corsPreFlightRequest: s,
      mainRequest: l
    };
  } else
    return {
      mainRequest: u[0]
    };
}
function Fh(e, t, r) {
  for (var n = ct(r), i = ct(fe(t)), o = e[1], a, u = e.length, c = 1; c < u; c++) {
    var s = e[c], l = ct(fe(s[T.FETCH_START])), f = ct(fe(s[T.RESPONSE_END])), d = n - f;
    l >= i && (!a || d < a) && (a = d, o = s);
  }
  return o;
}
function Xh(e, t, r, n, i, o) {
  var a = ct(t), u = ct(r), c = n.filter(function(s) {
    var l = ct(fe(s[T.FETCH_START])), f = ct(fe(s[T.RESPONSE_END]));
    return s.initiatorType.toLowerCase() === (o || "xmlhttprequest") && s.name === e && l >= a && f <= u;
  });
  return c.length > 0 && (c = c.filter(function(s) {
    return !i.has(s);
  })), c;
}
function tt(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var t = jh();
  return t.href = e, t;
}
function gs(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var r = qh(e, t);
  if (t && r.indexOf("@id") > 0)
    return r;
  var n = "";
  return e.parentNode && (n += gs(e.parentNode, !1)), n += r, n;
}
function zh(e) {
  if (!e.parentNode)
    return 0;
  var t = [e.nodeType];
  e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var r = Array.from(e.parentNode.childNodes);
  return r = r.filter(function(n) {
    var i = n.localName;
    return t.indexOf(n.nodeType) >= 0 && i === e.localName;
  }), r.length >= 1 ? r.indexOf(e) + 1 : 0;
}
function qh(e, t) {
  var r = e.nodeType, n = zh(e), i = "";
  if (r === Node.ELEMENT_NODE) {
    var o = e.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = e.localName;
  } else if (r === Node.TEXT_NODE || r === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (r === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function ys(e, t) {
  var r = t || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = tt(e);
  return n.origin === _s() ? !0 : r.some(function(i) {
    return dh(e, i);
  });
}
var Es = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), Kh = new Es(), Wh = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new Es();
    }, e;
  }()
), ms = new Wh(), Yh = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Kh;
    }, e;
  }()
), ao = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new Yh(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : ms;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), Jh = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Be = Symbol.for("io.opentelemetry.js.api.logs"), oe = Jh;
function Zh(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var so = 1, Qh = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new ao();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return oe[Be] ? this.getLoggerProvider() : (oe[Be] = Zh(so, t, ms), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = oe[Be]) === null || t === void 0 ? void 0 : t.call(oe, so)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete oe[Be], this._proxyLoggerProvider = new ao();
    }, e;
  }()
), t_ = Qh.getInstance(), Gn = function() {
  return Gn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Gn.apply(this, arguments);
}, e_ = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = D.wrap, this._unwrap = D.unwrap, this._massWrap = D.massWrap, this._massUnwrap = D.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = R.getTracer(t, r), this._meter = qt.getMeter(t, r), this._logger = t_.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = Gn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), r_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), n_ = (
  /** @class */
  function(e) {
    r_(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(e_)
);
function uo(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
var de;
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(de || (de = {}));
var i_ = "0.44.0", o_ = "@opentelemetry/instrumentation-document-load";
const a_ = "http.url", s_ = "http.user_agent", Vt = a_, u_ = s_;
var sr;
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(sr || (sr = {}));
var c_ = function() {
  var e, t, r = {}, n = (t = (e = nr).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "navigation")[0];
  if (n) {
    var i = Object.values(T);
    i.forEach(function(u) {
      if (dt(n, u)) {
        var c = n[u];
        typeof c == "number" && (r[u] = c);
      }
    });
  } else {
    var o = nr, a = o.timing;
    if (a) {
      var i = Object.values(T);
      i.forEach(function(c) {
        if (dt(a, c)) {
          var s = a[c];
          typeof s == "number" && (r[c] = s);
        }
      });
    }
  }
  return r;
}, co = {
  "first-paint": sr.FIRST_PAINT,
  "first-contentful-paint": sr.FIRST_CONTENTFUL_PAINT
}, l_ = function(e) {
  var t, r, n = (r = (t = nr).getEntriesByType) === null || r === void 0 ? void 0 : r.call(t, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    dt(co, o) && e.addEvent(co[o], a);
  });
}, f_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), d_ = (
  /** @class */
  function(e) {
    f_(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, o_, i_, r) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var r = this;
      window.setTimeout(function() {
        r._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(r) {
      var n = this, i, o, a = (o = (i = nr).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(u) {
        n._initResourceSpan(u, r);
      });
    }, t.prototype._collectPerformance = function() {
      var r = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === Cd;
      }), i = c_(), o = n && n.content || "";
      b.with(k.extract(vt, { traceparent: o }), function() {
        var a, u = r._startSpan(de.DOCUMENT_LOAD, T.FETCH_START, i);
        u && (b.with(R.setSpan(b.active(), u), function() {
          var c = r._startSpan(de.DOCUMENT_FETCH, T.FETCH_START, i);
          c && (c.setAttribute(Vt, location.href), b.with(R.setSpan(b.active(), c), function() {
            var s;
            r.getConfig().ignoreNetworkEvents || zt(c, i), r._addCustomAttributesOnSpan(c, (s = r.getConfig().applyCustomAttributesOnSpan) === null || s === void 0 ? void 0 : s.documentFetch), r._endSpan(c, T.RESPONSE_END, i);
          }));
        }), u.setAttribute(Vt, location.href), u.setAttribute(u_, navigator.userAgent), r._addResourcesSpans(u), r.getConfig().ignoreNetworkEvents || (C(u, T.FETCH_START, i), C(u, T.UNLOAD_EVENT_START, i), C(u, T.UNLOAD_EVENT_END, i), C(u, T.DOM_INTERACTIVE, i), C(u, T.DOM_CONTENT_LOADED_EVENT_START, i), C(u, T.DOM_CONTENT_LOADED_EVENT_END, i), C(u, T.DOM_COMPLETE, i), C(u, T.LOAD_EVENT_START, i), C(u, T.LOAD_EVENT_END, i)), r.getConfig().ignorePerformancePaintEvents || l_(u), r._addCustomAttributesOnSpan(u, (a = r.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), r._endSpan(u, T.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(r, n, i) {
      r && (dt(i, n) ? r.end(i[n]) : r.end());
    }, t.prototype._initResourceSpan = function(r, n) {
      var i, o = this._startSpan(de.RESOURCE_FETCH, T.FETCH_START, r, n);
      o && (o.setAttribute(Vt, r.name), this.getConfig().ignoreNetworkEvents || zt(o, r), this._addCustomAttributesOnResourceSpan(o, r, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, T.RESPONSE_END, r));
    }, t.prototype._startSpan = function(r, n, i, o) {
      if (dt(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(r, {
          startTime: i[n]
        }, o ? R.setSpan(b.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._addCustomAttributesOnSpan = function(r, n) {
      var i = this;
      n && uo(function() {
        return n(r);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      });
    }, t.prototype._addCustomAttributesOnResourceSpan = function(r, n, i) {
      var o = this;
      i && uo(function() {
        return i(r, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      });
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }(n_)
), Ts = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), p_ = new Ts(), h_ = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new Ts();
    }, e;
  }()
), Ss = new h_(), __ = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : p_;
    }, e;
  }()
), lo = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new __(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Ss;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), v_ = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, ke = Symbol.for("io.opentelemetry.js.api.logs"), ae = v_;
function g_(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var fo = 1, y_ = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new lo();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return ae[ke] ? this.getLoggerProvider() : (ae[ke] = g_(fo, t, Ss), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = ae[ke]) === null || t === void 0 ? void 0 : t.call(ae, fo)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete ae[ke], this._proxyLoggerProvider = new lo();
    }, e;
  }()
), E_ = y_.getInstance(), $n = function() {
  return $n = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, $n.apply(this, arguments);
}, m_ = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = D.wrap, this._unwrap = D.unwrap, this._massWrap = D.massWrap, this._massUnwrap = D.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = R.getTracer(t, r), this._meter = qt.getMeter(t, r), this._logger = E_.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = $n({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), T_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), S_ = (
  /** @class */
  function(e) {
    T_(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(m_)
);
function O_(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function b_(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var en = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Hn = performance, A_ = "http.method", w_ = "http.url", R_ = "http.host", L_ = "http.scheme", P_ = "http.status_code", N_ = "http.user_agent", I_ = "http.request_content_length_uncompressed", C_ = A_, M_ = w_, x_ = R_, D_ = L_, U_ = P_, B_ = N_, k_ = I_, G_ = 9, $_ = 6, H_ = Math.pow(10, $_), po = Math.pow(10, G_);
function jn(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * H_);
  return [r, n];
}
function j_() {
  var e = Hn.timeOrigin;
  if (typeof e != "number") {
    var t = Hn;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function ho(e) {
  var t = jn(j_()), r = jn(Hn.now());
  return V_(t, r);
}
function V_(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= po && (r[1] -= po, r[0] += 1), r;
}
var F_ = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function X_(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function z_(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = F_(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (X_(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var ur;
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(ur || (ur = {}));
var q_ = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, K_ = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, W_ = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Y_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Os = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function J_() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e[0] instanceof URL || typeof e[0] == "string") {
    var r = e[1];
    if (!(r != null && r.body))
      return Promise.resolve();
    if (r.body instanceof ReadableStream) {
      var n = Z_(r.body), i = n.body, o = n.length;
      return r.body = i, o;
    } else
      return Promise.resolve(Q_(r.body));
  } else {
    var a = e[0];
    return a != null && a.body ? a.clone().text().then(function(u) {
      return Vn(u);
    }) : Promise.resolve();
  }
}
function Z_(e) {
  if (!e.pipeThrough)
    return Os.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: e,
      length: Promise.resolve(void 0)
    };
  var t = 0, r, n = new Promise(function(o) {
    r = o;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(o, a) {
      return q_(this, void 0, void 0, function() {
        var u;
        return K_(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, o];
            case 1:
              return u = c.sent(), t += u.byteLength, a.enqueue(o), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      r(t);
    }
  });
  return {
    body: e.pipeThrough(i),
    length: n
  };
}
function Q_(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return ev(e);
  if (e instanceof URLSearchParams)
    return Vn(e.toString());
  if (typeof e == "string")
    return Vn(e);
  Os.warn("unknown body type");
}
var tv = new TextEncoder();
function Vn(e) {
  return tv.encode(e).byteLength;
}
function ev(e) {
  var t, r, n = 0;
  try {
    for (var i = W_(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = Y_(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var _o = "0.57.2", rv = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), nv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, iv = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, rn, ov = 300, vo = typeof process == "object" && ((rn = process.release) === null || rn === void 0 ? void 0 : rn.name) === "node", av = (
  /** @class */
  function(e) {
    rv(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-fetch", _o, r) || this;
      return n.component = "fetch", n.version = _o, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[T.FETCH_START]
      }, R.setSpan(b.active(), r));
      zt(i, n, this.getConfig().ignoreNetworkEvents), i.end(n[T.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(r, n) {
      var i = tt(n.url);
      r.setAttribute(U_, n.status), n.statusText != null && r.setAttribute(ur.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(x_, i.host), r.setAttribute(D_, i.protocol.replace(":", "")), typeof navigator != "undefined" && r.setAttribute(B_, navigator.userAgent);
    }, t.prototype._addHeaders = function(r, n) {
      if (!ys(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        k.inject(b.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (r instanceof Request)
        k.inject(b.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Headers)
        k.inject(b.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Map)
        k.inject(b.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else {
        var i = {};
        k.inject(b.active(), i), r.headers = Object.assign({}, i, r.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(r, n) {
      var i;
      if (n === void 0 && (n = {}), z_(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: ge.CLIENT,
        attributes: (i = {}, i[ur.COMPONENT] = this.moduleName, i[C_] = o, i[M_] = r, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = vs(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var u = a.mainRequest;
        this._markResourceAsUsed(u);
        var c = a.corsPreFlightRequest;
        c && (this._addChildSpan(r, c), this._markResourceAsUsed(c)), zt(r, u, this.getConfig().ignoreNetworkEvents);
      }
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._endSpan = function(r, n, i) {
      var o = this, a = jn(Date.now()), u = ho();
      this._addFinalSpanAttributes(r, i), setTimeout(function() {
        var c;
        (c = n.observer) === null || c === void 0 || c.disconnect(), o._findResourceAndAddNetworkEvents(r, n, u), o._tasksCount--, o._clearResources(), r.end(a);
      }, ov);
    }, t.prototype._patchConstructor = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = this, s = tt(a[0] instanceof Request ? a[0].url : String(a[0])).href, l = a[0] instanceof Request ? a[0] : a[1] || {}, f = i._createSpan(s, l);
          if (!f)
            return n.apply(this, a);
          var d = i._prepareSpanData(s);
          i.getConfig().measureRequestSize && J_.apply(void 0, iv([], nv(a), !1)).then(function(y) {
            y && f.setAttribute(k_, y);
          }).catch(function(y) {
            i._diag.warn("getFetchBodyLength", y);
          });
          function p(y, E) {
            i._applyAttributesAfterFetch(y, l, E), i._endSpan(y, d, {
              status: E.status || 0,
              statusText: E.message,
              url: s
            });
          }
          function _(y, E) {
            i._applyAttributesAfterFetch(y, l, E), E.status >= 200 && E.status < 400 ? i._endSpan(y, d, E) : i._endSpan(y, d, {
              status: E.status,
              statusText: E.statusText,
              url: s
            });
          }
          function h(y, E, A) {
            try {
              var w = A.clone(), P = A.clone(), M = w.body;
              if (M) {
                var It = M.getReader(), pt = function() {
                  It.read().then(function(Ct) {
                    var Ei = Ct.done;
                    Ei ? _(y, P) : pt();
                  }, function(Ct) {
                    p(y, Ct);
                  });
                };
                pt();
              } else
                _(y, A);
            } finally {
              E(A);
            }
          }
          function g(y, E, A) {
            try {
              p(y, A);
            } finally {
              E(A);
            }
          }
          return new Promise(function(y, E) {
            return b.with(R.setSpan(b.active(), f), function() {
              return i._addHeaders(l, s), i._tasksCount++, n.apply(c, l instanceof Request ? [l] : [s, l]).then(h.bind(c, f, y), g.bind(c, f, E));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(r, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && O_(function() {
        return a(r, n, i);
      }, function(u) {
        u && o._diag.error("applyCustomAttributesOnSpan", u);
      });
    }, t.prototype._prepareSpanData = function(r) {
      var n = ho(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: r };
      var o = new PerformanceObserver(function(a) {
        var u = a.getEntries();
        u.forEach(function(c) {
          c.initiatorType === "fetch" && c.name === r && i.push(c);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: r };
    }, t.prototype.enable = function() {
      if (vo) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      b_(fetch) && (this._unwrap(en, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(en, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      vo || (this._unwrap(en, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }(S_)
), bs = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), sv = new bs(), uv = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new bs();
    }, e;
  }()
), As = new uv(), cv = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : sv;
    }, e;
  }()
), go = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new cv(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : As;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), lv = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Ge = Symbol.for("io.opentelemetry.js.api.logs"), se = lv;
function fv(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var yo = 1, dv = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new go();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return se[Ge] ? this.getLoggerProvider() : (se[Ge] = fv(yo, t, As), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = se[Ge]) === null || t === void 0 ? void 0 : t.call(se, yo)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete se[Ge], this._proxyLoggerProvider = new go();
    }, e;
  }()
), pv = dv.getInstance(), Fn = function() {
  return Fn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Fn.apply(this, arguments);
}, hv = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = D.wrap, this._unwrap = D.unwrap, this._massWrap = D.massWrap, this._massUnwrap = D.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = R.getTracer(t, r), this._meter = qt.getMeter(t, r), this._logger = pv.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = Fn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), _v = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), vv = (
  /** @class */
  function(e) {
    _v(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(hv)
);
function gv(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function Eo(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var me = performance, yv = "http.method", Ev = "http.url", mv = "http.host", Tv = "http.scheme", Sv = "http.status_code", Ov = "http.user_agent", bv = "http.request_content_length_uncompressed", Av = yv, wv = Ev, Rv = mv, Lv = Tv, Pv = Sv, Nv = Ov, Iv = bv, Cv = 9, Mv = 6, xv = Math.pow(10, Mv), mo = Math.pow(10, Cv);
function To(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * xv);
  return [r, n];
}
function Dv() {
  var e = me.timeOrigin;
  if (typeof e != "number") {
    var t = me;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function So(e) {
  var t = To(Dv()), r = To(me.now());
  return Uv(t, r);
}
function Uv(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= mo && (r[1] -= mo, r[0] += 1), r;
}
var Bv = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function kv(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function Gv(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = Bv(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (kv(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var Q;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(Q || (Q = {}));
var $v = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Hv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, jv = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function Vv(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return Xv(e);
  if (e instanceof URLSearchParams)
    return Oo(e.toString());
  if (typeof e == "string")
    return Oo(e);
  jv.warn("unknown body type");
}
var Fv = new TextEncoder();
function Oo(e) {
  return Fv.encode(e).byteLength;
}
function Xv(e) {
  var t, r, n = 0;
  try {
    for (var i = $v(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = Hv(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var bo = "0.57.2", Xn;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(Xn || (Xn = {}));
var zv = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), qv = 300, Kv = (
  /** @class */
  function(e) {
    zv(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-xml-http-request", bo, r) || this;
      return n.component = "xml-http-request", n.version = bo, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(r, n) {
      var i = tt(n).href;
      if (!ys(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        k.inject(b.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      k.inject(b.active(), a), Object.keys(a).forEach(function(u) {
        r.setRequestHeader(u, String(a[u]));
      });
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this;
      b.with(R.setSpan(b.active(), r), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[T.FETCH_START]
        });
        zt(o, n, i.getConfig().ignoreNetworkEvents), o.end(n[T.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(r, n, i) {
      if (typeof i == "string") {
        var o = tt(i);
        n.status !== void 0 && r.setAttribute(Pv, n.status), n.statusText !== void 0 && r.setAttribute(Xn.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(Rv, o.host), r.setAttribute(Lv, o.protocol.replace(":", "")), r.setAttribute(Nv, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(r, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && gv(function() {
        return o(r, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, t.prototype._addResourceObserver = function(r, n) {
      var i = this._xhrMem.get(r);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), u = tt(n);
          a.forEach(function(c) {
            c.initiatorType === "xmlhttprequest" && c.name === u.href && i.createdResources && i.createdResources.entries.push(c);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (me.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i, o, a) {
      if (!(!i || !o || !a || !r.createdResources)) {
        var u = r.createdResources.entries;
        (!u || !u.length) && (u = me.getEntriesByType("resource"));
        var c = vs(tt(i).href, o, a, u, this._usedResources);
        if (c.mainRequest) {
          var s = c.mainRequest;
          this._markResourceAsUsed(s);
          var l = c.corsPreFlightRequest;
          l && (this._addChildSpan(n, l), this._markResourceAsUsed(l)), zt(n, s, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(r) {
      var n = this._xhrMem.get(r);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(r);
      }
    }, t.prototype._createSpan = function(r, n, i) {
      var o;
      if (Gv(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), u = this.tracer.startSpan(a, {
        kind: ge.CLIENT,
        attributes: (o = {}, o[Av] = i, o[wv] = tt(n).toString(), o)
      });
      return u.addEvent(Q.METHOD_OPEN), this._cleanPreviousSpanInformation(r), this._xhrMem.set(r, {
        span: u,
        spanUrl: n
      }), u;
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._patchOpen = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = a[0], s = a[1];
          return i._createSpan(this, s, c), n.apply(this, a);
        };
      };
    }, t.prototype._patchSend = function() {
      var r = this;
      function n(l, f, d, p) {
        var _ = f.callbackToRemoveEvents;
        typeof _ == "function" && _();
        var h = f.span, g = f.spanUrl, y = f.sendStartTime;
        h && (r._findResourceAndAddNetworkEvents(f, h, g, y, d), h.addEvent(l, p), r._addFinalSpanAttributes(h, f, g), h.end(p), r._tasksCount--), r._clearResources();
      }
      function i(l, f) {
        var d = r._xhrMem.get(f);
        if (d) {
          d.status = f.status, d.statusText = f.statusText, r._xhrMem.delete(f), d.span && r._applyAttributesAfterXHR(d.span, f);
          var p = So(), _ = Date.now();
          setTimeout(function() {
            n(l, d, p, _);
          }, qv);
        }
      }
      function o() {
        i(Q.EVENT_ERROR, this);
      }
      function a() {
        i(Q.EVENT_ABORT, this);
      }
      function u() {
        i(Q.EVENT_TIMEOUT, this);
      }
      function c() {
        this.status < 299 ? i(Q.EVENT_LOAD, this) : i(Q.EVENT_ERROR, this);
      }
      function s(l) {
        l.removeEventListener("abort", a), l.removeEventListener("error", o), l.removeEventListener("load", c), l.removeEventListener("timeout", u);
        var f = r._xhrMem.get(l);
        f && (f.callbackToRemoveEvents = void 0);
      }
      return function(l) {
        return function() {
          for (var d = this, p = [], _ = 0; _ < arguments.length; _++)
            p[_] = arguments[_];
          var h = r._xhrMem.get(this);
          if (!h)
            return l.apply(this, p);
          var g = h.span, y = h.spanUrl;
          if (g && y) {
            if (r.getConfig().measureRequestSize && (p != null && p[0])) {
              var E = p[0], A = Vv(E);
              A !== void 0 && g.setAttribute(Iv, A);
            }
            b.with(R.setSpan(b.active(), g), function() {
              r._tasksCount++, h.sendStartTime = So(), g.addEvent(Q.METHOD_SEND), d.addEventListener("abort", a), d.addEventListener("error", o), d.addEventListener("load", c), d.addEventListener("timeout", u), h.callbackToRemoveEvents = function() {
                s(d), h.createdResources && h.createdResources.observer.disconnect();
              }, r._addHeaders(d, y), r._addResourceObserver(d, y);
            });
          }
          return l.apply(this, p);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), Eo(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), Eo(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }(vv)
), Wv = "service.name", Yv = "telemetry.sdk.name", Jv = "telemetry.sdk.language", Zv = "telemetry.sdk.version", Qv = Wv, Ao = Yv, wo = Jv, Ro = Zv;
function tg() {
  return "unknown_service";
}
var at = function() {
  return at = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, at.apply(this, arguments);
}, eg = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, rg = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, ng = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, zn = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return v.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[Qv] = tg(), t[wo] = jr[wo], t[Ao] = jr[Ao], t[Ro] = jr[Ro], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && v.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return eg(this, void 0, void 0, function() {
        return rg(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = at(at({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = ng(a, 2), s = c[0], l = c[1];
        return at(at(at(at({}, r._syncAttributes), s), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
);
const nn = /\b(query|mutation|subscription)\b\s*([A-Za-z_]\w*)?/g;
function ig(e) {
  var s;
  const t = ag(e);
  if (t === null || typeof t != "object")
    return null;
  const r = Array.isArray(t) ? t[0] : t;
  if (!r || typeof r != "object")
    return null;
  const n = r, i = typeof n.query == "string" ? n.query : void 0, o = typeof n.operationName == "string" ? n.operationName : void 0;
  if (i === void 0 && o === void 0)
    return null;
  const a = i ? og(i, o) : null, u = (s = a == null ? void 0 : a[1]) != null ? s : sg(i), c = o != null ? o : a == null ? void 0 : a[2];
  return c === void 0 && u === void 0 ? null : { name: c, type: u };
}
function og(e, t) {
  nn.lastIndex = 0;
  let r = null;
  for (let n = nn.exec(e); n !== null; n = nn.exec(e)) {
    if (t === void 0 || n[2] === t)
      return n;
    r === null && (r = n);
  }
  return r;
}
function ag(e) {
  if (e == null)
    return null;
  if (typeof e == "object")
    return e;
  if (typeof e != "string")
    return null;
  try {
    return JSON.parse(e);
  } catch (t) {
    return null;
  }
}
function sg(e) {
  if (e !== void 0 && /^\s*\{/.test(e))
    return "query";
}
const Lo = (e, t, r) => {
  const n = gr(
    t,
    e.headers,
    r
  );
  return I(m({}, e), {
    headers: n
  });
}, gr = (e, t, r) => {
  var i, o;
  const n = m({}, t);
  return r ? ((i = Object.keys(n)) == null || i.forEach((a) => {
    [...r].includes(a == null ? void 0 : a.toLowerCase()) || (n[a] = "[REDACTED]");
  }), n) : ((o = Object.keys(n)) == null || o.forEach((a) => {
    [...ug, ...e].includes(
      a == null ? void 0 : a.toLowerCase()
    ) && (n[a] = "[REDACTED]");
  }), n);
}, ug = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "set-cookie",
  "token"
], cg = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
], lg = [
  "awsaccesskeyid",
  "signature",
  "sig",
  "x-goog-signature",
  "access_token",
  "id_token",
  "token",
  "code",
  "refresh_token",
  "session_state"
], fg = [
  "access_token",
  "id_token",
  "token",
  "code",
  "refresh_token",
  "session_state"
], ws = (e) => {
  var t, r;
  try {
    return new URL(e);
  } catch (n) {
    return new URL(e, (r = (t = globalThis.location) == null ? void 0 : t.origin) != null ? r : "http://example.com");
  }
}, dg = (e) => {
  if (!e || e === "#") return "";
  const t = e.slice(1);
  if (!t.includes("=")) return e;
  const r = t.indexOf("?"), n = r >= 0 ? t.slice(r + 1) : t, i = new URLSearchParams(n);
  for (const o of i.keys())
    if (fg.includes(o.toLowerCase()))
      return "";
  return e;
}, qn = (e) => {
  try {
    const t = ws(e);
    (t.username || t.password) && (t.username = "REDACTED", t.password = "REDACTED");
    const r = t.searchParams;
    lg.forEach((i) => {
      for (const o of Array.from(r.keys()))
        o.toLowerCase() === i && r.set(o, "REDACTED");
    });
    const n = dg(t.hash);
    if (t.hash = n, !e.includes("://") && !e.startsWith("//"))
      return t.pathname + t.search + n;
    if (e.startsWith("//")) {
      let i = "//";
      return (t.username || t.password) && (i += t.username + ":" + t.password + "@"), i += t.host + t.pathname + t.search + n, i;
    }
    return t.toString();
  } catch (t) {
    return e;
  }
}, pg = new RegExp("sdk\\/evalx\\/[^/]+\\/contexts\\/(?<context>[^/?]*)\\??.*?"), hg = new RegExp("\\/eval\\/[^/]+\\/(?<context>[^/?]*)\\??.*?");
function _g(e) {
  return !!(e.includes("/sdk/evalx") && e.match(pg) || e.includes("/eval/") && e.match(hg));
}
const Rs = "X-Highlight-Request", Po = (e) => {
  let t = e;
  return !e.startsWith("https://") && !e.startsWith("http://") && (t = `${window.location.origin}${t}`), t.replace(/\/+$/, "");
}, vg = (e, {
  headersToRedact: t,
  headersToRecord: r,
  requestResponseSanitizer: n
}) => {
  var c, s;
  let i = e;
  if (n) {
    let f = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (p) {
      f = !1;
    }
    let d = !0;
    try {
      i.response.body = JSON.parse(
        i.response.body
      );
    } catch (p) {
      d = !1;
    }
    try {
      i = n(i);
    } catch (p) {
    } finally {
      f = f && !!((c = i == null ? void 0 : i.request) != null && c.body), d = d && !!((s = i == null ? void 0 : i.response) != null && s.body), f && (i.request.body = JSON.stringify(
        i.request.body
      )), d && (i.response.body = JSON.stringify(
        i.response.body
      ));
    }
    if (!i)
      return null;
  }
  const l = i, { request: o, response: a } = l, u = Ar(l, ["request", "response"]);
  return m({
    request: Lo(o, t, r),
    response: Lo(a, t, r)
  }, u);
}, $T = (e, t, r, n) => {
  e.sort((c, s) => c.responseEnd - s.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, o = e.reduce((c, s) => {
    const l = Po(s.name);
    return s.initiatorType === r ? c[r][l] = [
      ...c[r][l] || [],
      s
    ] : c.others[l] = [
      ...c.others[l] || [],
      s
    ], c;
  }, i);
  let a = {};
  a = t.reduce(
    (c, s) => {
      const l = Po(s.request.url);
      return c[l] = [...c[l] || [], s], c;
    },
    a
  );
  for (let c in o[r]) {
    const s = o[r][c], l = a[c];
    if (!l)
      continue;
    const f = Math.max(
      s.length - l.length,
      0
    );
    for (let d = f; d < s.length; d++)
      s[d] && (s[d].requestResponsePair = l[d - f]);
  }
  let u = [];
  for (let c in o)
    for (let s in o[c])
      u = u.concat(o[c][s]);
  return u.sort((c, s) => c.fetchStart - s.fetchStart).reduce(
    (c, s) => {
      let l = s.requestResponsePair;
      return l && (l = vg(
        s.requestResponsePair,
        n
      ), !l) || (s.toJSON = function() {
        const f = window.performance.timeOrigin;
        return {
          initiatorType: this.initiatorType,
          startTimeAbs: f + this.startTime,
          connectStartAbs: f + this.connectStart,
          connectEndAbs: f + this.connectEnd,
          domainLookupStartAbs: f + this.domainLookupStart,
          domainLookupEndAbs: f + this.domainLookupEnd,
          fetchStartAbs: f + this.fetchStart,
          redirectStartAbs: f + this.redirectStart,
          redirectEndAbs: f + this.redirectEnd,
          requestStartAbs: f + this.requestStart,
          responseStartAbs: f + this.responseStart,
          responseEndAbs: f + this.responseEnd,
          secureConnectionStartAbs: f + this.secureConnectionStart,
          workerStartAbs: f + this.workerStart,
          name: this.name,
          transferSize: this.transferSize,
          encodedBodySize: this.encodedBodySize,
          decodedBodySize: this.decodedBodySize,
          nextHopProtocol: this.nextHopProtocol,
          requestResponsePairs: l
        };
      }, c.push(s)), c;
    },
    []
  );
}, gg = (e) => ["events.ld.catamorphic.com", "events.launchdarkly.com"].some(
  (t) => e.toLocaleLowerCase().includes(t)
), yg = (e) => _g(e), Eg = (e, t) => t.some(
  (r) => e.toLocaleLowerCase().includes(r)
), fi = (e, t, r) => !Eg(e, t) && !yg(e) && !gg(e), di = (e, t, r) => {
  var a;
  if (r.some(
    (u) => e.toLowerCase().includes(u)
  ))
    return !1;
  let n = [];
  t === !0 ? (n = ["localhost", /^\//], (a = window == null ? void 0 : window.location) != null && a.host && n.push(Ls(window.location.host))) : t instanceof Array && (n = t);
  const i = Tg(e);
  let o = !1;
  return n.forEach((u) => {
    i.match(u) && (o = !0);
  }), o;
}, mg = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), Ls = (e) => new RegExp("^https?://([^/]+\\.)?" + mg(e) + "([:/?#]|$)"), Tg = (e) => {
  if (e.startsWith("/") && !e.startsWith("//"))
    return e;
  try {
    return new URL(e).origin;
  } catch (t) {
    return e;
  }
};
function Sg(e) {
  for (var t = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length, i = 0; i < e; i++)
    t += r.charAt(
      Math.floor(Math.random() * n)
    );
  return t;
}
const Ps = () => {
  const e = Sg(10), t = Gm(), r = t == null ? void 0 : t.spanContext().traceId;
  return [it(), r != null ? r : e];
}, Ns = (e, t) => e + "/" + t, HT = (e, t, r, n, i, o) => {
  const a = XMLHttpRequest.prototype, u = a.open, c = a.send, s = a.setRequestHeader;
  return a.open = function(l, f) {
    return typeof f == "string" ? this._url = f : this._url = f.toString(), this._method = l, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some(
      (d) => this._url.toLowerCase().includes(d)
    ), u.apply(this, arguments);
  }, a.setRequestHeader = function(l, f) {
    return this._requestHeaders[l] = f, s.apply(this, arguments);
  }, a.send = function(l) {
    if (!fi(
      this._url,
      t
    ))
      return c.apply(this, arguments);
    const [f, d] = Ps();
    di(
      this._url,
      r,
      n
    ) && this.setRequestHeader(
      Rs,
      Ns(f, d)
    );
    const p = this._shouldRecordHeaderAndBody, _ = {
      sessionSecureID: f,
      id: d,
      url: this._url,
      verb: this._method,
      headers: p ? this._requestHeaders : {},
      body: void 0
    };
    if (p && l) {
      const h = No(l, _.url);
      h && (this._body = h, _.body = et(
        h,
        i,
        o,
        _.headers
      ));
    }
    return this.addEventListener("load", function() {
      return U(this, null, function* () {
        const h = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (p) {
          const E = this.getAllResponseHeaders().trim().split(/[\r\n]+/), A = {};
          if (E.forEach(function(w) {
            const P = w.split(": "), M = P.shift();
            A[M] = P.join(": ");
          }), h.headers = A, l) {
            const w = No(l, _.url);
            w && (_.body = et(
              w,
              i,
              o,
              h.headers
            ));
          }
          if (this.responseType === "" || this.responseType === "text")
            h.body = et(
              this.responseText,
              i,
              o,
              h.headers
            ), h.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const w = yield this.response.text();
                h.body = et(
                  w,
                  i,
                  o,
                  h.headers
                ), h.size = this.response.size;
              } catch (w) {
              }
          } else
            try {
              h.body = et(
                this.response,
                i,
                o,
                h.headers
              );
            } catch (w) {
            }
        }
        e({
          request: _,
          response: h,
          urlBlocked: !p
        });
      });
    }), this.addEventListener("error", function() {
      return U(this, null, function* () {
        const h = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        e({
          request: _,
          response: h,
          urlBlocked: !1
        });
      });
    }), c.apply(this, arguments);
  }, () => {
    a.open = u, a.send = c, a.setRequestHeader = s;
  };
}, No = (e, t) => {
  if (typeof e == "string") {
    if (!((t != null && t.includes("localhost") || t != null && t.includes("highlight.run")) && (e.includes("pushPayload") || e.includes("pushSessionEvents"))))
      return e;
  } else if (typeof e == "object" || typeof e == "number" || typeof e == "boolean")
    return he(e);
  return null;
}, Io = 64 * 1024, Og = {
  "application/json": 64 * 1024 * 1024,
  // MB
  "text/plain": 64 * 1024 * 1024
  // MB
}, et = (e, t, r, n) => {
  var o, a, u;
  let i = Io;
  if (n) {
    let c = "";
    typeof n.get == "function" ? c = (o = n.get("content-type")) != null ? o : "" : c = (a = n["content-type"]) != null ? a : "";
    try {
      c = c.split(";")[0];
    } catch (s) {
    }
    i = (u = Og[c]) != null ? u : Io;
  }
  if (e) {
    if (t)
      try {
        const c = JSON.parse(e);
        Array.isArray(c) ? c.forEach((s) => {
          Object.keys(s).forEach((l) => {
            t.includes(
              l.toLocaleLowerCase()
            ) && (s[l] = "[REDACTED]");
          });
        }) : Object.keys(c).forEach((s) => {
          t.includes(s.toLocaleLowerCase()) && (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch (c) {
      }
    if (r)
      try {
        const c = JSON.parse(e);
        Object.keys(c).forEach((s) => {
          r.includes(s.toLocaleLowerCase()) || (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch (c) {
      }
  }
  try {
    e = e.slice(0, i);
  } catch (c) {
  }
  return e;
}, jT = (e, t, r, n, i, o) => {
  const a = window._fetchProxy;
  return window._fetchProxy = function(u, c) {
    const { method: s, url: l } = bg(u, c);
    if (!fi(
      l,
      t
    ))
      return a.call(this, u, c);
    const [f, d] = Ps();
    if (di(l, r, n)) {
      c = c || {};
      let g = new Headers(c.headers);
      u instanceof Request && [...u.headers].forEach(
        ([y, E]) => g.set(y, E)
      ), g.set(
        Rs,
        Ns(f, d)
      ), c.headers = Object.fromEntries(g.entries());
    }
    const p = {
      sessionSecureID: f,
      id: d,
      headers: {},
      body: void 0,
      url: l,
      verb: s
    }, _ = !n.some(
      (g) => l.toLowerCase().includes(g)
    );
    _ && (p.headers = Object.fromEntries(
      new Headers(c == null ? void 0 : c.headers).entries()
    ), p.body = et(
      c == null ? void 0 : c.body,
      i,
      o,
      c == null ? void 0 : c.headers
    ));
    let h = a.call(this, u, c);
    return Ag(
      h,
      p,
      e,
      _,
      i,
      o
    ), h;
  }, () => {
    window._fetchProxy = a;
  };
}, bg = (e, t) => {
  const r = t && t.method || typeof e == "object" && "method" in e && e.method || "GET";
  let n;
  return typeof e == "object" ? "url" in e && e.url ? n = e.url : n = e.toString() : n = e, {
    method: r,
    url: n
  };
}, Ag = (e, t, r, n, i, o) => {
  const a = (u) => U(void 0, null, function* () {
    let c = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, s = !1, l = !n;
    "stack" in u || u instanceof Error ? (c = I(m({}, c), {
      body: u.message,
      status: 0,
      size: void 0
    }), s = !0) : "status" in u && (c = I(m({}, c), {
      status: u.status
    }), n && (c.body = yield Is(
      u,
      o,
      i
    ), c.headers = Object.fromEntries(
      u.headers.entries()
    ), c.size = c.body.length * 8), (u.type === "opaque" || u.type === "opaqueredirect") && (l = !0, c = I(m({}, c), {
      body: "CORS blocked request"
    })), s = !0), s && r({
      request: t,
      response: c,
      urlBlocked: l
    });
  });
  e.then(a).catch(() => {
  });
}, Is = (e, t, r) => U(void 0, null, function* () {
  let n;
  try {
    const o = e.clone().body;
    if (o) {
      let a = o.getReader(), u = new TextDecoder(), c, s = "";
      for (; !(c = yield a.read()).done; ) {
        let l = c.value;
        s += u.decode(l);
      }
      n = s, n = et(
        n,
        r,
        t,
        e.headers
      );
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var Cs = (
  /** @class */
  function() {
    function e(t) {
      this._delegate = t;
    }
    return e.prototype.export = function(t, r) {
      this._delegate.export(t, r);
    }, e.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, e.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, e;
  }()
), wg = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Co = (
  /** @class */
  function(e) {
    wg(t, e);
    function t(r, n, i) {
      var o = e.call(this, r) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return t;
  }(Error)
);
function Rg(e) {
  if (!Number.isNaN(e) && Number.isFinite(e) && e > 0)
    return e;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + e + "')");
}
function Lg(e) {
  if (e != null)
    return function() {
      return e;
    };
}
function Pg(e, t, r) {
  var n, i, o, a, u, c;
  return {
    timeoutMillis: Rg((i = (n = e.timeoutMillis) !== null && n !== void 0 ? n : t.timeoutMillis) !== null && i !== void 0 ? i : r.timeoutMillis),
    concurrencyLimit: (a = (o = e.concurrencyLimit) !== null && o !== void 0 ? o : t.concurrencyLimit) !== null && a !== void 0 ? a : r.concurrencyLimit,
    compression: (c = (u = e.compression) !== null && u !== void 0 ? u : t.compression) !== null && c !== void 0 ? c : r.compression
  };
}
function Ng() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var Ig = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Cg = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Mg = (
  /** @class */
  function() {
    function e(t) {
      this._sendingPromises = [], this._concurrencyLimit = t;
    }
    return e.prototype.pushPromise = function(t) {
      var r = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(t);
      var n = function() {
        var i = r._sendingPromises.indexOf(t);
        r._sendingPromises.splice(i, 1);
      };
      t.then(n, n);
    }, e.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, e.prototype.awaitAll = function() {
      return Ig(this, void 0, void 0, function() {
        return Cg(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function xg(e) {
  return new Mg(e.concurrencyLimit);
}
function Dg(e) {
  return Object.prototype.hasOwnProperty.call(e, "partialSuccess");
}
function Ug() {
  return {
    handleResponse: function(e) {
      e == null || !Dg(e) || e.partialSuccess == null || Object.keys(e.partialSuccess).length === 0 || v.warn("Received Partial Success response:", JSON.stringify(e.partialSuccess));
    }
  };
}
var Bg = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, kg = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Gg = (
  /** @class */
  function() {
    function e(t, r, n, i, o) {
      this._transport = t, this._serializer = r, this._responseHandler = n, this._promiseQueue = i, this._timeout = o, this._diagLogger = v.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return e.prototype.export = function(t, r) {
      var n = this;
      if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) {
        r({
          code: N.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(t);
      if (i == null) {
        r({
          code: N.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(o) {
        if (o.status === "success") {
          if (o.data != null)
            try {
              n._responseHandler.handleResponse(n._serializer.deserializeResponse(o.data));
            } catch (a) {
              n._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, o.data);
            }
          r({
            code: N.SUCCESS
          });
          return;
        } else if (o.status === "failure" && o.error) {
          r({
            code: N.FAILED,
            error: o.error
          });
          return;
        } else o.status === "retryable" ? r({
          code: N.FAILED,
          error: new Co("Export failed with retryable status")
        }) : r({
          code: N.FAILED,
          error: new Co("Export failed with unknown error")
        });
      }, function(o) {
        return r({
          code: N.FAILED,
          error: o
        });
      }));
    }, e.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, e.prototype.shutdown = function() {
      return Bg(this, void 0, void 0, function() {
        return kg(this, function(t) {
          switch (t.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return t.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function $g(e, t) {
  return new Gg(e.transport, e.serializer, Ug(), e.promiseHandler, t.timeout);
}
function Ms(e, t, r) {
  return $g({
    transport: r,
    serializer: t,
    promiseHandler: xg(e)
  }, { timeout: e.timeoutMillis });
}
function xs(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function Hg(e) {
  var t = Number(BigInt.asUintN(32, e)), r = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: r };
}
function Ds(e) {
  var t = xs(e);
  return Hg(t);
}
function jg(e) {
  var t = xs(e);
  return t.toString();
}
var Vg = typeof BigInt != "undefined" ? jg : Uf;
function Mo(e) {
  return e;
}
function Us(e) {
  if (e !== void 0)
    return si(e);
}
var Fg = {
  encodeHrTime: Ds,
  encodeSpanContext: si,
  encodeOptionalSpanContext: Us
};
function Bs(e) {
  var t, r;
  if (e === void 0)
    return Fg;
  var n = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, i = (r = e.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: n ? Ds : Vg,
    encodeSpanContext: i ? Mo : si,
    encodeOptionalSpanContext: i ? Mo : Us
  };
}
var Xg = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function ks(e) {
  return {
    attributes: Rt(e.attributes),
    droppedAttributesCount: 0
  };
}
function Gs(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function Rt(e) {
  return Object.keys(e).map(function(t) {
    return $s(t, e[t]);
  });
}
function $s(e, t) {
  return {
    key: e,
    value: Hs(t)
  };
}
function Hs(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(Hs) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(r) {
        var n = Xg(r, 2), i = n[0], o = n[1];
        return $s(i, o);
      })
    }
  } : {};
}
var X;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE";
})(X || (X = {}));
var W;
(function(e) {
  e[e.HISTOGRAM = 0] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", e[e.GAUGE = 2] = "GAUGE", e[e.SUM = 3] = "SUM";
})(W || (W = {}));
var zg = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), xo = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Do = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, qg = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Kg = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Wg = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Yg(e) {
  return e != null;
}
function js(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "" : (t = t.sort(), JSON.stringify(t.map(function(r) {
    return [r, e[r]];
  })));
}
function Jg(e) {
  var t, r;
  return e.name + ":" + ((t = e.version) !== null && t !== void 0 ? t : "") + ":" + ((r = e.schemaUrl) !== null && r !== void 0 ? r : "");
}
var Vs = (
  /** @class */
  function(e) {
    zg(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return Object.setPrototypeOf(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function Te(e, t) {
  var r, n = new Promise(function(o, a) {
    r = setTimeout(function() {
      a(new Vs("Operation timed out."));
    }, t);
  });
  return Promise.race([e, n]).then(function(i) {
    return clearTimeout(r), i;
  }, function(i) {
    throw clearTimeout(r), i;
  });
}
function Zg(e) {
  return xo(this, void 0, void 0, function() {
    var t = this;
    return Do(this, function(r) {
      return [2, Promise.all(e.map(function(n) {
        return xo(t, void 0, void 0, function() {
          var i, o;
          return Do(this, function(a) {
            switch (a.label) {
              case 0:
                return a.trys.push([0, 2, , 3]), [4, n];
              case 1:
                return i = a.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return o = a.sent(), [2, {
                  status: "rejected",
                  reason: o
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function Qg(e) {
  return e.status === "rejected";
}
function Uo(e, t) {
  var r = [];
  return e.forEach(function(n) {
    r.push.apply(r, Kg([], qg(t(n)), !1));
  }), r;
}
function ty(e, t) {
  var r, n;
  if (e.size !== t.size)
    return !1;
  try {
    for (var i = Wg(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (!t.has(a))
        return !1;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !0;
}
function ey(e, t) {
  for (var r = 0, n = e.length - 1, i = e.length; n >= r; ) {
    var o = r + Math.trunc((n - r) / 2);
    e[o] < t ? r = o + 1 : (i = o, n = o - 1);
  }
  return i;
}
function ry(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
var bt;
(function(e) {
  e[e.DROP = 0] = "DROP", e[e.SUM = 1] = "SUM", e[e.LAST_VALUE = 2] = "LAST_VALUE", e[e.HISTOGRAM = 3] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(bt || (bt = {}));
var ny = (
  /** @class */
  function() {
    function e() {
      this.kind = bt.DROP;
    }
    return e.prototype.createAccumulation = function() {
    }, e.prototype.merge = function(t, r) {
    }, e.prototype.diff = function(t, r) {
    }, e.prototype.toMetricData = function(t, r, n, i) {
    }, e;
  }()
), S;
(function(e) {
  e.COUNTER = "COUNTER", e.GAUGE = "GAUGE", e.HISTOGRAM = "HISTOGRAM", e.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", e.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", e.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", e.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(S || (S = {}));
function nt(e, t, r) {
  var n, i, o, a;
  return sy(e) || v.warn('Invalid metric name: "' + e + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: e,
    type: t,
    description: (n = r == null ? void 0 : r.description) !== null && n !== void 0 ? n : "",
    unit: (i = r == null ? void 0 : r.unit) !== null && i !== void 0 ? i : "",
    valueType: (o = r == null ? void 0 : r.valueType) !== null && o !== void 0 ? o : ft.DOUBLE,
    advice: (a = r == null ? void 0 : r.advice) !== null && a !== void 0 ? a : {}
  };
}
function iy(e, t) {
  var r, n;
  return {
    name: (r = e.name) !== null && r !== void 0 ? r : t.name,
    description: (n = e.description) !== null && n !== void 0 ? n : t.description,
    type: t.type,
    unit: t.unit,
    valueType: t.valueType,
    advice: t.advice
  };
}
function oy(e, t) {
  return ry(e.name, t.name) && e.unit === t.unit && e.type === t.type && e.valueType === t.valueType;
}
var ay = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function sy(e) {
  return e.match(ay) != null;
}
var uy = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function cy(e) {
  var t = e.map(function() {
    return 0;
  });
  return t.push(0), {
    buckets: {
      boundaries: e,
      counts: t
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var on = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = !0), i === void 0 && (i = cy(r)), this.startTime = t, this._boundaries = r, this._recordMinMax = n, this._current = i;
    }
    return e.prototype.record = function(t) {
      if (!Number.isNaN(t)) {
        this._current.count += 1, this._current.sum += t, this._recordMinMax && (this._current.min = Math.min(t, this._current.min), this._current.max = Math.max(t, this._current.max), this._current.hasMinMax = !0);
        var r = ey(this._boundaries, t);
        this._current.buckets.counts[r] += 1;
      }
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), Fs = (
  /** @class */
  function() {
    function e(t, r) {
      this._boundaries = t, this._recordMinMax = r, this.kind = bt.HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new on(t, this._boundaries, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = o[c] + a[c];
      var s = 1 / 0, l = -1 / 0;
      return this._recordMinMax && (n.hasMinMax && i.hasMinMax ? (s = Math.min(n.min, i.min), l = Math.max(n.max, i.max)) : n.hasMinMax ? (s = n.min, l = n.max) : i.hasMinMax && (s = i.min, l = i.max)), new on(t.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: n.count + i.count,
        sum: n.sum + i.sum,
        hasMinMax: this._recordMinMax && (n.hasMinMax || i.hasMinMax),
        min: s,
        max: l
      });
    }, e.prototype.diff = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = a[c] - o[c];
      return new on(r.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: i.count - n.count,
        sum: i.sum - n.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: W.HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = uy(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === S.GAUGE || t.type === S.UP_DOWN_COUNTER || t.type === S.OBSERVABLE_GAUGE || t.type === S.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              buckets: s.buckets,
              count: s.count
            }
          };
        })
      };
    }, e;
  }()
), an = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, sn = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Bo = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      t === void 0 && (t = new ly()), r === void 0 && (r = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.backing = t, this.indexBase = r, this.indexStart = n, this.indexEnd = i;
    }
    return Object.defineProperty(e.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.counts = function() {
      var t = this;
      return Array.from({ length: this.length }, function(r, n) {
        return t.at(n);
      });
    }, e.prototype.at = function(t) {
      var r = this.indexBase - this.indexStart;
      return t < r && (t += this.backing.length), t -= r, this.backing.countAt(t);
    }, e.prototype.incrementBucket = function(t, r) {
      this.backing.increment(t, r);
    }, e.prototype.decrementBucket = function(t, r) {
      this.backing.decrement(t, r);
    }, e.prototype.trim = function() {
      for (var t = 0; t < this.length; t++)
        if (this.at(t) !== 0) {
          this.indexStart += t;
          break;
        } else if (t === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var t = this.length - 1; t >= 0; t--)
        if (this.at(t) !== 0) {
          this.indexEnd -= this.length - t - 1;
          break;
        }
      this._rotate();
    }, e.prototype.downscale = function(t) {
      this._rotate();
      for (var r = 1 + this.indexEnd - this.indexStart, n = 1 << t, i = 0, o = 0, a = this.indexStart; a <= this.indexEnd; ) {
        var u = a % n;
        u < 0 && (u += n);
        for (var c = u; c < n && i < r; c++)
          this._relocateBucket(o, i), i++, a++;
        o++;
      }
      this.indexStart >>= t, this.indexEnd >>= t, this.indexBase = this.indexStart;
    }, e.prototype.clone = function() {
      return new e(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, e.prototype._rotate = function() {
      var t = this.indexBase - this.indexStart;
      t !== 0 && (t > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, t), this.backing.reverse(t, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + t)), this.indexBase = this.indexStart);
    }, e.prototype._relocateBucket = function(t, r) {
      t !== r && this.incrementBucket(t, this.backing.emptyBucket(r));
    }, e;
  }()
), ly = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = [0]), this._counts = t;
    }
    return Object.defineProperty(e.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.countAt = function(t) {
      return this._counts[t];
    }, e.prototype.growTo = function(t, r, n) {
      var i = new Array(t).fill(0);
      i.splice.apply(i, sn([
        n,
        this._counts.length - r
      ], an(this._counts.slice(r)), !1)), i.splice.apply(i, sn([0, r], an(this._counts.slice(0, r)), !1)), this._counts = i;
    }, e.prototype.reverse = function(t, r) {
      for (var n = Math.floor((t + r) / 2) - t, i = 0; i < n; i++) {
        var o = this._counts[t + i];
        this._counts[t + i] = this._counts[r - i - 1], this._counts[r - i - 1] = o;
      }
    }, e.prototype.emptyBucket = function(t) {
      var r = this._counts[t];
      return this._counts[t] = 0, r;
    }, e.prototype.increment = function(t, r) {
      this._counts[t] += r;
    }, e.prototype.decrement = function(t, r) {
      this._counts[t] >= r ? this._counts[t] -= r : this._counts[t] = 0;
    }, e.prototype.clone = function() {
      return new e(sn([], an(this._counts), !1));
    }, e;
  }()
), fy = 52, dy = 2146435072, py = 1048575, pi = 1023, Xs = -pi + 1, zs = pi, Kn = Math.pow(2, -1022);
function qs(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = (r & dy) >> 20;
  return n - pi;
}
function Ks(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = t.getUint32(4), i = (r & py) * Math.pow(2, 32);
  return i + n;
}
function Wn(e, t) {
  return e === 0 || e === Number.POSITIVE_INFINITY || e === Number.NEGATIVE_INFINITY || Number.isNaN(e) ? e : e * Math.pow(2, t);
}
function hy(e) {
  return e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, e++, e;
}
var _y = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Se = (
  /** @class */
  function(e) {
    _y(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Error)
), vy = (
  /** @class */
  function() {
    function e(t) {
      this._shift = -t;
    }
    return e.prototype.mapToIndex = function(t) {
      if (t < Kn)
        return this._minNormalLowerBoundaryIndex();
      var r = qs(t), n = this._rightShift(Ks(t) - 1, fy);
      return r + n >> this._shift;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._minNormalLowerBoundaryIndex();
      if (t < r)
        throw new Se("underflow: " + t + " is < minimum lower boundary: " + r);
      var n = this._maxNormalLowerBoundaryIndex();
      if (t > n)
        throw new Se("overflow: " + t + " is > maximum lower boundary: " + n);
      return Wn(1, t << this._shift);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      var t = Xs >> this._shift;
      return this._shift < 2 && t--, t;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return zs >> this._shift;
    }, e.prototype._rightShift = function(t, r) {
      return Math.floor(t * Math.pow(2, -r));
    }, e;
  }()
), gy = (
  /** @class */
  function() {
    function e(t) {
      this._scale = t, this._scaleFactor = Wn(Math.LOG2E, t), this._inverseFactor = Wn(Math.LN2, -t);
    }
    return e.prototype.mapToIndex = function(t) {
      if (t <= Kn)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (Ks(t) === 0) {
        var r = qs(t);
        return (r << this._scale) - 1;
      }
      var n = Math.floor(Math.log(t) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return n >= i ? i : n;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._maxNormalLowerBoundaryIndex();
      if (t >= r) {
        if (t === r)
          return 2 * Math.exp((t - (1 << this._scale)) / this._scaleFactor);
        throw new Se("overflow: " + t + " is > maximum lower boundary: " + r);
      }
      var n = this._minNormalLowerBoundaryIndex();
      if (t <= n) {
        if (t === n)
          return Kn;
        if (t === n - 1)
          return Math.exp((t + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new Se("overflow: " + t + " is < minimum lower boundary: " + n);
      }
      return Math.exp(t * this._inverseFactor);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      return Xs << this._scale;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return (zs + 1 << this._scale) - 1;
    }, e;
  }()
), ko = -10, Go = 20, yy = Array.from({ length: 31 }, function(e, t) {
  return t > 10 ? new gy(t - 10) : new vy(t - 10);
});
function $o(e) {
  if (e > Go || e < ko)
    throw new Se("expected scale >= " + ko + " && <= " + Go + ", got: " + e);
  return yy[e + 10];
}
var Ey = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, $e = (
  /** @class */
  function() {
    function e(t, r) {
      this.low = t, this.high = r;
    }
    return e.combine = function(t, r) {
      return new e(Math.min(t.low, r.low), Math.max(t.high, r.high));
    }, e;
  }()
), my = 20, Ty = 160, un = 2, Sy = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, l, f) {
      t === void 0 && (t = t), r === void 0 && (r = Ty), n === void 0 && (n = !0), i === void 0 && (i = 0), o === void 0 && (o = 0), a === void 0 && (a = 0), u === void 0 && (u = Number.POSITIVE_INFINITY), c === void 0 && (c = Number.NEGATIVE_INFINITY), s === void 0 && (s = new Bo()), l === void 0 && (l = new Bo()), f === void 0 && (f = $o(my)), this.startTime = t, this._maxSize = r, this._recordMinMax = n, this._sum = i, this._count = o, this._zeroCount = a, this._min = u, this._max = c, this._positive = s, this._negative = l, this._mapping = f, this._maxSize < un && (v.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + un), this._maxSize = un);
    }
    return e.prototype.record = function(t) {
      this.updateByIncrement(t, 1);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(e.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateByIncrement = function(t, r) {
      if (!Number.isNaN(t)) {
        if (t > this._max && (this._max = t), t < this._min && (this._min = t), this._count += r, t === 0) {
          this._zeroCount += r;
          return;
        }
        this._sum += t * r, t > 0 ? this._updateBuckets(this._positive, t, r) : this._updateBuckets(this._negative, -t, r);
      }
    }, e.prototype.merge = function(t) {
      this._count === 0 ? (this._min = t.min, this._max = t.max) : t.count !== 0 && (t.min < this.min && (this._min = t.min), t.max > this.max && (this._max = t.max)), this.startTime = t.startTime, this._sum += t.sum, this._count += t.count, this._zeroCount += t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._mergeBuckets(this.positive, t, t.positive, r), this._mergeBuckets(this.negative, t, t.negative, r);
    }, e.prototype.diff = function(t) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= t.sum, this._count -= t.count, this._zeroCount -= t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._diffBuckets(this.positive, t, t.positive, r), this._diffBuckets(this.negative, t, t.negative, r);
    }, e.prototype.clone = function() {
      return new e(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, e.prototype._updateBuckets = function(t, r, n) {
      var i = this._mapping.mapToIndex(r), o = !1, a = 0, u = 0;
      if (t.length === 0 ? (t.indexStart = i, t.indexEnd = t.indexStart, t.indexBase = t.indexStart) : i < t.indexStart && t.indexEnd - i >= this._maxSize ? (o = !0, u = i, a = t.indexEnd) : i > t.indexEnd && i - t.indexStart >= this._maxSize && (o = !0, u = t.indexStart, a = i), o) {
        var c = this._changeScale(a, u);
        this._downscale(c), i = this._mapping.mapToIndex(r);
      }
      this._incrementIndexBy(t, i, n);
    }, e.prototype._incrementIndexBy = function(t, r, n) {
      if (n !== 0) {
        if (t.length === 0 && (t.indexStart = t.indexEnd = t.indexBase = r), r < t.indexStart) {
          var i = t.indexEnd - r;
          i >= t.backing.length && this._grow(t, i + 1), t.indexStart = r;
        } else if (r > t.indexEnd) {
          var i = r - t.indexStart;
          i >= t.backing.length && this._grow(t, i + 1), t.indexEnd = r;
        }
        var o = r - t.indexBase;
        o < 0 && (o += t.backing.length), t.incrementBucket(o, n);
      }
    }, e.prototype._grow = function(t, r) {
      var n = t.backing.length, i = t.indexBase - t.indexStart, o = n - i, a = hy(r);
      a > this._maxSize && (a = this._maxSize);
      var u = a - i;
      t.backing.growTo(a, o, u);
    }, e.prototype._changeScale = function(t, r) {
      for (var n = 0; t - r >= this._maxSize; )
        t >>= 1, r >>= 1, n++;
      return n;
    }, e.prototype._downscale = function(t) {
      if (t !== 0) {
        if (t < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var r = this._mapping.scale - t;
        this._positive.downscale(t), this._negative.downscale(t), this._mapping = $o(r);
      }
    }, e.prototype._minScale = function(t) {
      var r = Math.min(this.scale, t.scale), n = $e.combine(this._highLowAtScale(this.positive, this.scale, r), this._highLowAtScale(t.positive, t.scale, r)), i = $e.combine(this._highLowAtScale(this.negative, this.scale, r), this._highLowAtScale(t.negative, t.scale, r));
      return Math.min(r - this._changeScale(n.high, n.low), r - this._changeScale(i.high, i.low));
    }, e.prototype._highLowAtScale = function(t, r, n) {
      if (t.length === 0)
        return new $e(0, -1);
      var i = r - n;
      return new $e(t.indexStart >> i, t.indexEnd >> i);
    }, e.prototype._mergeBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++)
        this._incrementIndexBy(t, o + u >> a, n.at(u));
    }, e.prototype._diffBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++) {
        var c = o + u >> a, s = c - t.indexBase;
        s < 0 && (s += t.backing.length), t.decrementBucket(s, n.at(u));
      }
      t.trim();
    }, e;
  }()
), Oy = (
  /** @class */
  function() {
    function e(t, r) {
      this._maxSize = t, this._recordMinMax = r, this.kind = bt.EXPONENTIAL_HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new Sy(t, this._maxSize, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      var n = r.clone();
      return n.merge(t), n;
    }, e.prototype.diff = function(t, r) {
      var n = r.clone();
      return n.diff(t), n;
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: W.EXPONENTIAL_HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = Ey(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === S.GAUGE || t.type === S.UP_DOWN_COUNTER || t.type === S.OBSERVABLE_GAUGE || t.type === S.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              positive: {
                offset: s.positive.offset,
                bucketCounts: s.positive.bucketCounts
              },
              negative: {
                offset: s.negative.offset,
                bucketCounts: s.negative.bucketCounts
              },
              count: s.count,
              scale: s.scale,
              zeroCount: s.zeroCount
            }
          };
        })
      };
    }, e;
  }()
), by = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, cn = (
  /** @class */
  function() {
    function e(t, r, n) {
      r === void 0 && (r = 0), n === void 0 && (n = [0, 0]), this.startTime = t, this._current = r, this.sampleTime = n;
    }
    return e.prototype.record = function(t) {
      this._current = t, this.sampleTime = ye(Date.now());
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), Ay = (
  /** @class */
  function() {
    function e() {
      this.kind = bt.LAST_VALUE;
    }
    return e.prototype.createAccumulation = function(t) {
      return new cn(t);
    }, e.prototype.merge = function(t, r) {
      var n = Me(r.sampleTime) >= Me(t.sampleTime) ? r : t;
      return new cn(t.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.diff = function(t, r) {
      var n = Me(r.sampleTime) >= Me(t.sampleTime) ? r : t;
      return new cn(r.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: W.GAUGE,
        dataPoints: n.map(function(o) {
          var a = by(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        })
      };
    }, e;
  }()
), wy = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ue = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = !1), this.startTime = t, this.monotonic = r, this._current = n, this.reset = i;
    }
    return e.prototype.record = function(t) {
      this.monotonic && t < 0 || (this._current += t);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), Ho = (
  /** @class */
  function() {
    function e(t) {
      this.monotonic = t, this.kind = bt.SUM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new ue(t, this.monotonic);
    }, e.prototype.merge = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return r.reset ? new ue(r.startTime, this.monotonic, i, r.reset) : new ue(t.startTime, this.monotonic, n + i);
    }, e.prototype.diff = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return this.monotonic && n > i ? new ue(r.startTime, this.monotonic, i, !0) : new ue(r.startTime, this.monotonic, i - n);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: W.SUM,
        dataPoints: n.map(function(o) {
          var a = wy(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, e;
  }()
), Lt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), rt = (
  /** @class */
  function() {
    function e() {
    }
    return e.Drop = function() {
      return Ws;
    }, e.Sum = function() {
      return Ys;
    }, e.LastValue = function() {
      return Js;
    }, e.Histogram = function() {
      return Zs;
    }, e.ExponentialHistogram = function() {
      return xy;
    }, e.Default = function() {
      return Dy;
    }, e;
  }()
), Ry = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new ny(), t;
  }(rt)
), Ly = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      switch (r.type) {
        case S.COUNTER:
        case S.OBSERVABLE_COUNTER:
        case S.HISTOGRAM:
          return t.MONOTONIC_INSTANCE;
        default:
          return t.NON_MONOTONIC_INSTANCE;
      }
    }, t.MONOTONIC_INSTANCE = new Ho(!0), t.NON_MONOTONIC_INSTANCE = new Ho(!1), t;
  }(rt)
), Py = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Ay(), t;
  }(rt)
), Ny = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Fs([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), t;
  }(rt)
), Iy = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t(r, n) {
      n === void 0 && (n = !0);
      var i = e.call(this) || this;
      if (i._recordMinMax = n, r == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      r = r.concat(), r = r.sort(function(u, c) {
        return u - c;
      });
      var o = r.lastIndexOf(-1 / 0), a = r.indexOf(1 / 0);
      return a === -1 && (a = void 0), i._boundaries = r.slice(o + 1, a), i;
    }
    return t.prototype.createAggregator = function(r) {
      return new Fs(this._boundaries, this._recordMinMax);
    }, t;
  }(rt)
), Cy = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t(r, n) {
      r === void 0 && (r = 160), n === void 0 && (n = !0);
      var i = e.call(this) || this;
      return i._maxSize = r, i._recordMinMax = n, i;
    }
    return t.prototype.createAggregator = function(r) {
      return new Oy(this._maxSize, this._recordMinMax);
    }, t;
  }(rt)
), My = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype._resolve = function(r) {
      switch (r.type) {
        case S.COUNTER:
        case S.UP_DOWN_COUNTER:
        case S.OBSERVABLE_COUNTER:
        case S.OBSERVABLE_UP_DOWN_COUNTER:
          return Ys;
        case S.GAUGE:
        case S.OBSERVABLE_GAUGE:
          return Js;
        case S.HISTOGRAM:
          return r.advice.explicitBucketBoundaries ? new Iy(r.advice.explicitBucketBoundaries) : Zs;
      }
      return v.warn("Unable to recognize instrument type: " + r.type), Ws;
    }, t.prototype.createAggregator = function(r) {
      return this._resolve(r).createAggregator(r);
    }, t;
  }(rt)
), Ws = new Ry(), Ys = new Ly(), Js = new Py(), Zs = new Ny(), xy = new Cy(), Dy = new My(), Uy = function(e) {
  return rt.Default();
}, By = function(e) {
  return X.CUMULATIVE;
}, ln = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, fn = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, jo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ky = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Gy = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i;
      this._shutdown = !1, this._aggregationSelector = (r = t == null ? void 0 : t.aggregationSelector) !== null && r !== void 0 ? r : Uy, this._aggregationTemporalitySelector = (n = t == null ? void 0 : t.aggregationTemporalitySelector) !== null && n !== void 0 ? n : By, this._metricProducers = (i = t == null ? void 0 : t.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = t == null ? void 0 : t.cardinalitySelector;
    }
    return e.prototype.setMetricProducer = function(t) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = t, this.onInitialized();
    }, e.prototype.selectAggregation = function(t) {
      return this._aggregationSelector(t);
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._aggregationTemporalitySelector(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      return this._cardinalitySelector ? this._cardinalitySelector(t) : 2e3;
    }, e.prototype.onInitialized = function() {
    }, e.prototype.collect = function(t) {
      return ln(this, void 0, void 0, function() {
        var r, n, i, o, a, u;
        return fn(this, function(c) {
          switch (c.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(ky([
                this._sdkMetricProducer.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                })
              ], jo(this._metricProducers.map(function(s) {
                return s.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                });
              })), !1))];
            case 1:
              return r = jo.apply(void 0, [c.sent()]), n = r[0], i = r.slice(1), o = n.errors.concat(Uo(i, function(s) {
                return s.errors;
              })), a = n.resourceMetrics.resource, u = n.resourceMetrics.scopeMetrics.concat(Uo(i, function(s) {
                return s.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: a,
                  scopeMetrics: u
                },
                errors: o
              }];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return ln(this, void 0, void 0, function() {
        return fn(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return r.sent(), [3, 4];
            case 2:
              return [4, Te(this.onShutdown(), t.timeoutMillis)];
            case 3:
              r.sent(), r.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return ln(this, void 0, void 0, function() {
        return fn(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, Te(this.onForceFlush(), t.timeoutMillis)];
            case 3:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), $y = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), He = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, je = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Hy = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, jy = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Vy = (
  /** @class */
  function(e) {
    $y(t, e);
    function t(r) {
      var n, i, o, a, u = e.call(this, {
        aggregationSelector: (n = r.exporter.selectAggregation) === null || n === void 0 ? void 0 : n.bind(r.exporter),
        aggregationTemporalitySelector: (i = r.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(r.exporter),
        metricProducers: r.metricProducers
      }) || this;
      if (r.exportIntervalMillis !== void 0 && r.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportIntervalMillis !== void 0 && r.exportIntervalMillis < r.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return u._exportInterval = (o = r.exportIntervalMillis) !== null && o !== void 0 ? o : 6e4, u._exportTimeout = (a = r.exportTimeoutMillis) !== null && a !== void 0 ? a : 3e4, u._exporter = r.exporter, u;
    }
    return t.prototype._runOnce = function() {
      return He(this, void 0, void 0, function() {
        var r;
        return je(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, Te(this._doRun(), this._exportTimeout)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return r = n.sent(), r instanceof Vs ? (v.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : (Gi(r), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype._doRun = function() {
      var r, n;
      return He(this, void 0, void 0, function() {
        var i, o, a, u, c, s;
        return je(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = l.sent(), o = i.resourceMetrics, a = i.errors, a.length > 0 && (s = v).error.apply(s, jy(["PeriodicExportingMetricReader: metrics collection errors"], Hy(a), !1)), !o.resource.asyncAttributesPending) return [3, 5];
              l.label = 2;
            case 2:
              return l.trys.push([2, 4, , 5]), [4, (n = (r = o.resource).waitForAsyncAttributes) === null || n === void 0 ? void 0 : n.call(r)];
            case 3:
              return l.sent(), [3, 5];
            case 4:
              return u = l.sent(), v.debug("Error while resolving async portion of resource: ", u), Gi(u), [3, 5];
            case 5:
              return o.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, yd._export(this._exporter, o)];
            case 6:
              if (c = l.sent(), c.code !== N.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + c.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onInitialized = function() {
      var r = this;
      this._interval = setInterval(function() {
        r._runOnce();
      }, this._exportInterval);
    }, t.prototype.onForceFlush = function() {
      return He(this, void 0, void 0, function() {
        return je(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return r.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onShutdown = function() {
      return He(this, void 0, void 0, function() {
        return je(this, function(r) {
          switch (r.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return r.sent(), [4, this._exporter.shutdown()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(Gy)
), Fy = (
  /** @class */
  function() {
    function e() {
      this._registeredViews = [];
    }
    return e.prototype.addView = function(t) {
      this._registeredViews.push(t);
    }, e.prototype.findViews = function(t, r) {
      var n = this, i = this._registeredViews.filter(function(o) {
        return n._matchInstrument(o.instrumentSelector, t) && n._matchMeter(o.meterSelector, r);
      });
      return i;
    }, e.prototype._matchInstrument = function(t, r) {
      return (t.getType() === void 0 || r.type === t.getType()) && t.getNameFilter().match(r.name) && t.getUnitFilter().match(r.unit);
    }, e.prototype._matchMeter = function(t, r) {
      return t.getNameFilter().match(r.name) && (r.version === void 0 || t.getVersionFilter().match(r.version)) && (r.schemaUrl === void 0 || t.getSchemaUrlFilter().match(r.schemaUrl));
    }, e;
  }()
), Pt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), yr = (
  /** @class */
  function() {
    function e(t, r) {
      this._writableMetricStorage = t, this._descriptor = r;
    }
    return e.prototype._record = function(t, r, n) {
      if (r === void 0 && (r = {}), n === void 0 && (n = b.active()), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._descriptor.name + ": " + t);
        return;
      }
      this._descriptor.valueType === ft.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._writableMetricStorage.record(t, r, n, ye(Date.now()));
    }, e;
  }()
), Xy = (
  /** @class */
  function(e) {
    Pt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(yr)
), zy = (
  /** @class */
  function(e) {
    Pt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      if (r < 0) {
        v.warn("negative value provided to counter " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(yr)
), qy = (
  /** @class */
  function(e) {
    Pt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(yr)
), Ky = (
  /** @class */
  function(e) {
    Pt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      if (r < 0) {
        v.warn("negative value provided to histogram " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(yr)
), Er = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._observableRegistry = n, this._descriptor = t, this._metricStorages = r;
    }
    return e.prototype.addCallback = function(t) {
      this._observableRegistry.addCallback(t, this);
    }, e.prototype.removeCallback = function(t) {
      this._observableRegistry.removeCallback(t, this);
    }, e;
  }()
), Wy = (
  /** @class */
  function(e) {
    Pt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Er)
), Yy = (
  /** @class */
  function(e) {
    Pt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Er)
), Jy = (
  /** @class */
  function(e) {
    Pt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Er)
);
function Yn(e) {
  return e instanceof Er;
}
var Zy = (
  /** @class */
  function() {
    function e(t) {
      this._meterSharedState = t;
    }
    return e.prototype.createGauge = function(t, r) {
      var n = nt(t, S.GAUGE, r), i = this._meterSharedState.registerMetricStorage(n);
      return new qy(i, n);
    }, e.prototype.createHistogram = function(t, r) {
      var n = nt(t, S.HISTOGRAM, r), i = this._meterSharedState.registerMetricStorage(n);
      return new Ky(i, n);
    }, e.prototype.createCounter = function(t, r) {
      var n = nt(t, S.COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new zy(i, n);
    }, e.prototype.createUpDownCounter = function(t, r) {
      var n = nt(t, S.UP_DOWN_COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new Xy(i, n);
    }, e.prototype.createObservableGauge = function(t, r) {
      var n = nt(t, S.OBSERVABLE_GAUGE, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new Yy(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableCounter = function(t, r) {
      var n = nt(t, S.OBSERVABLE_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new Wy(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      var n = nt(t, S.OBSERVABLE_UP_DOWN_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new Jy(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.addBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.addBatchCallback(t, r);
    }, e.prototype.removeBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.removeBatchCallback(t, r);
    }, e;
  }()
), Qs = (
  /** @class */
  function() {
    function e(t) {
      this._instrumentDescriptor = t;
    }
    return e.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, e.prototype.updateDescription = function(t) {
      this._instrumentDescriptor = nt(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: t,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, e;
  }()
), Qy = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Vo = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, tE = (
  /** @class */
  function() {
    function e(t) {
      this._hash = t, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return e.prototype.get = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.get(r);
    }, e.prototype.getOrDefault = function(t, r) {
      var n = this._hash(t);
      if (this._valueMap.has(n))
        return this._valueMap.get(n);
      var i = r();
      return this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, i), i;
    }, e.prototype.set = function(t, r, n) {
      n != null || (n = this._hash(t)), this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, r);
    }, e.prototype.has = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.has(r);
    }, e.prototype.keys = function() {
      var t, r;
      return Vo(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._keyMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, e.prototype.entries = function() {
      var t, r;
      return Vo(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._valueMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [this._keyMap.get(r.value[0]), r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(e.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), Tt = (
  /** @class */
  function(e) {
    Qy(t, e);
    function t() {
      return e.call(this, js) || this;
    }
    return t;
  }(tE)
), eE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, tu = (
  /** @class */
  function() {
    function e(t, r) {
      this._aggregator = t, this._activeCollectionStorage = new Tt(), this._cumulativeMemoStorage = new Tt(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (r != null ? r : 2e3) - 1, this._overflowHashCode = js(this._overflowAttributes);
    }
    return e.prototype.record = function(t, r, n, i) {
      var o = this, a = this._activeCollectionStorage.get(r);
      if (!a) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var u = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return o._aggregator.createAccumulation(i);
          });
          u == null || u.record(t);
          return;
        }
        a = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(r, a);
      }
      a == null || a.record(t);
    }, e.prototype.batchCumulate = function(t, r) {
      var n = this;
      Array.from(t.entries()).forEach(function(i) {
        var o = eE(i, 3), a = o[0], u = o[1], c = o[2], s = n._aggregator.createAccumulation(r);
        s == null || s.record(u);
        var l = s;
        if (n._cumulativeMemoStorage.has(a, c)) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        } else if (n._cumulativeMemoStorage.size >= n._cardinalityLimit && (a = n._overflowAttributes, c = n._overflowHashCode, n._cumulativeMemoStorage.has(a, c))) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        }
        if (n._activeCollectionStorage.has(a, c)) {
          var d = n._activeCollectionStorage.get(a, c);
          l = n._aggregator.merge(d, l);
        }
        n._cumulativeMemoStorage.set(a, s, c), n._activeCollectionStorage.set(a, l, c);
      });
    }, e.prototype.collect = function() {
      var t = this._activeCollectionStorage;
      return this._activeCollectionStorage = new Tt(), t;
    }, e;
  }()
), dn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Fo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, eu = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this;
      this._aggregator = t, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), r.forEach(function(i) {
        n._unreportedAccumulations.set(i, []);
      });
    }
    return e.prototype.buildMetrics = function(t, r, n, i) {
      this._stashAccumulations(n);
      var o = this._getMergedUnreportedAccumulations(t), a = o, u;
      if (this._reportHistory.has(t)) {
        var c = this._reportHistory.get(t), s = c.collectionTime;
        u = c.aggregationTemporality, u === X.CUMULATIVE ? a = e.merge(c.accumulations, o, this._aggregator) : a = e.calibrateStartTime(c.accumulations, o, s);
      } else
        u = t.selectAggregationTemporality(r.type);
      this._reportHistory.set(t, {
        accumulations: a,
        collectionTime: i,
        aggregationTemporality: u
      });
      var l = rE(a);
      if (l.length !== 0)
        return this._aggregator.toMetricData(
          r,
          u,
          l,
          /* endTime */
          i
        );
    }, e.prototype._stashAccumulations = function(t) {
      var r, n, i = this._unreportedAccumulations.keys();
      try {
        for (var o = dn(i), a = o.next(); !a.done; a = o.next()) {
          var u = a.value, c = this._unreportedAccumulations.get(u);
          c === void 0 && (c = [], this._unreportedAccumulations.set(u, c)), c.push(t);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype._getMergedUnreportedAccumulations = function(t) {
      var r, n, i = new Tt(), o = this._unreportedAccumulations.get(t);
      if (this._unreportedAccumulations.set(t, []), o === void 0)
        return i;
      try {
        for (var a = dn(o), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          i = e.merge(i, c, this._aggregator);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e.merge = function(t, r, n) {
      for (var i = t, o = r.entries(), a = o.next(); a.done !== !0; ) {
        var u = Fo(a.value, 3), c = u[0], s = u[1], l = u[2];
        if (t.has(c, l)) {
          var f = t.get(c, l), d = n.merge(f, s);
          i.set(c, d, l);
        } else
          i.set(c, s, l);
        a = o.next();
      }
      return i;
    }, e.calibrateStartTime = function(t, r, n) {
      var i, o;
      try {
        for (var a = dn(t.keys()), u = a.next(); !u.done; u = a.next()) {
          var c = Fo(u.value, 2), s = c[0], l = c[1], f = r.get(s, l);
          f == null || f.setStartTime(n);
        }
      } catch (d) {
        i = { error: d };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      return r;
    }, e;
  }()
);
function rE(e) {
  return Array.from(e.entries());
}
var nE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), iE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, oE = (
  /** @class */
  function(e) {
    nE(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new tu(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new eu(n, o), u;
    }
    return t.prototype.record = function(r, n) {
      var i = this, o = new Tt();
      Array.from(r.entries()).forEach(function(a) {
        var u = iE(a, 2), c = u[0], s = u[1];
        o.set(i._attributesProcessor.process(c), s);
      }), this._deltaMetricStorage.batchCumulate(o, n);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(Qs)
);
function Xo(e, t) {
  var r = "";
  return e.unit !== t.unit && (r += "	- Unit '" + e.unit + "' does not match '" + t.unit + `'
`), e.type !== t.type && (r += "	- Type '" + e.type + "' does not match '" + t.type + `'
`), e.valueType !== t.valueType && (r += "	- Value Type '" + e.valueType + "' does not match '" + t.valueType + `'
`), e.description !== t.description && (r += "	- Description '" + e.description + "' does not match '" + t.description + `'
`), r;
}
function aE(e, t) {
  return "	- use valueType '" + e.valueType + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function sE(e, t) {
  return "	- use unit '" + e.unit + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function uE(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + "'";
}
function cE(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + `'
    	- OR - create a new view with the name ` + e.name + " and description '" + e.description + "' and InstrumentSelector " + n + `
    	- OR - create a new view with the name ` + t.name + " and description '" + e.description + "' and InstrumentSelector " + n;
}
function zo(e, t) {
  return e.valueType !== t.valueType ? aE(e, t) : e.unit !== t.unit ? sE(e, t) : e.type !== t.type ? uE(e, t) : e.description !== t.description ? cE(e, t) : "";
}
var pn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, lE = (
  /** @class */
  function() {
    function e() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return e.create = function() {
      return new e();
    }, e.prototype.getStorages = function(t) {
      var r, n, i, o, a = [];
      try {
        for (var u = pn(this._sharedRegistry.values()), c = u.next(); !c.done; c = u.next()) {
          var s = c.value;
          a = a.concat(s);
        }
      } catch (p) {
        r = { error: p };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (r) throw r.error;
        }
      }
      var l = this._perCollectorRegistry.get(t);
      if (l != null)
        try {
          for (var f = pn(l.values()), d = f.next(); !d.done; d = f.next()) {
            var s = d.value;
            a = a.concat(s);
          }
        } catch (p) {
          i = { error: p };
        } finally {
          try {
            d && !d.done && (o = f.return) && o.call(f);
          } finally {
            if (i) throw i.error;
          }
        }
      return a;
    }, e.prototype.register = function(t) {
      this._registerStorage(t, this._sharedRegistry);
    }, e.prototype.registerForCollector = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      n == null && (n = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(t, n)), this._registerStorage(r, n);
    }, e.prototype.findOrUpdateCompatibleStorage = function(t) {
      var r = this._sharedRegistry.get(t.name);
      return r === void 0 ? null : this._findOrUpdateCompatibleStorage(t, r);
    }, e.prototype.findOrUpdateCompatibleCollectorStorage = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      if (n === void 0)
        return null;
      var i = n.get(r.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(r, i);
    }, e.prototype._registerStorage = function(t, r) {
      var n = t.getInstrumentDescriptor(), i = r.get(n.name);
      if (i === void 0) {
        r.set(n.name, [t]);
        return;
      }
      i.push(t);
    }, e.prototype._findOrUpdateCompatibleStorage = function(t, r) {
      var n, i, o = null;
      try {
        for (var a = pn(r), u = a.next(); !u.done; u = a.next()) {
          var c = u.value, s = c.getInstrumentDescriptor();
          oy(s, t) ? (s.description !== t.description && (t.description.length > s.description.length && c.updateDescription(t.description), v.warn("A view or instrument with the name ", t.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, Xo(s, t), `The longer description will be used.
To resolve the conflict:`, zo(s, t))), o = c) : v.warn("A view or instrument with the name ", t.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, Xo(s, t), `To resolve the conflict:
`, zo(s, t));
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          u && !u.done && (i = a.return) && i.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      return o;
    }, e;
  }()
), fE = (
  /** @class */
  function() {
    function e(t) {
      this._backingStorages = t;
    }
    return e.prototype.record = function(t, r, n, i) {
      this._backingStorages.forEach(function(o) {
        o.record(t, r, n, i);
      });
    }, e;
  }()
), dE = (
  /** @class */
  function() {
    function e(t, r) {
      this._instrumentName = t, this._valueType = r, this._buffer = new Tt();
    }
    return e.prototype.observe = function(t, r) {
      if (r === void 0 && (r = {}), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._instrumentName + ": " + t);
        return;
      }
      this._valueType === ft.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._buffer.set(r, t);
    }, e;
  }()
), pE = (
  /** @class */
  function() {
    function e() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return e.prototype.observe = function(t, r, n) {
      if (n === void 0 && (n = {}), !!Yn(t)) {
        var i = this._buffer.get(t);
        if (i == null && (i = new Tt(), this._buffer.set(t, i)), typeof r != "number") {
          v.warn("non-number value provided to metric " + t._descriptor.name + ": " + r);
          return;
        }
        t._descriptor.valueType === ft.INT && !Number.isInteger(r) && (v.warn("INT value type cannot accept a floating-point value for " + t._descriptor.name + ", ignoring the fractional digits."), r = Math.trunc(r), !Number.isInteger(r)) || i.set(n, r);
      }
    }, e;
  }()
), hn = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, _n = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, qo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ko = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, hE = (
  /** @class */
  function() {
    function e() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return e.prototype.addCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n >= 0 || this._callbacks.push({ callback: t, instrument: r });
    }, e.prototype.removeCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n < 0 || this._callbacks.splice(n, 1);
    }, e.prototype.addBatchCallback = function(t, r) {
      var n = new Set(r.filter(Yn));
      if (n.size === 0) {
        v.error("BatchObservableCallback is not associated with valid instruments", r);
        return;
      }
      var i = this._findBatchCallback(t, n);
      i >= 0 || this._batchCallbacks.push({ callback: t, instruments: n });
    }, e.prototype.removeBatchCallback = function(t, r) {
      var n = new Set(r.filter(Yn)), i = this._findBatchCallback(t, n);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, e.prototype.observe = function(t, r) {
      return hn(this, void 0, void 0, function() {
        var n, i, o, a;
        return _n(this, function(u) {
          switch (u.label) {
            case 0:
              return n = this._observeCallbacks(t, r), i = this._observeBatchCallbacks(t, r), [4, Zg(Ko(Ko([], qo(n), !1), qo(i), !1))];
            case 1:
              return o = u.sent(), a = o.filter(Qg).map(function(c) {
                return c.reason;
              }), [2, a];
          }
        });
      });
    }, e.prototype._observeCallbacks = function(t, r) {
      var n = this;
      return this._callbacks.map(function(i) {
        var o = i.callback, a = i.instrument;
        return hn(n, void 0, void 0, function() {
          var u, c;
          return _n(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new dE(a._descriptor.name, a._descriptor.valueType), c = Promise.resolve(o(u)), r != null && (c = Te(c, r)), [4, c];
              case 1:
                return s.sent(), a._metricStorages.forEach(function(l) {
                  l.record(u._buffer, t);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._observeBatchCallbacks = function(t, r) {
      var n = this;
      return this._batchCallbacks.map(function(i) {
        var o = i.callback, a = i.instruments;
        return hn(n, void 0, void 0, function() {
          var u, c;
          return _n(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new pE(), c = Promise.resolve(o(u)), r != null && (c = Te(c, r)), [4, c];
              case 1:
                return s.sent(), a.forEach(function(l) {
                  var f = u._buffer.get(l);
                  f != null && l._metricStorages.forEach(function(d) {
                    d.record(f, t);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._findCallback = function(t, r) {
      return this._callbacks.findIndex(function(n) {
        return n.callback === t && n.instrument === r;
      });
    }, e.prototype._findBatchCallback = function(t, r) {
      return this._batchCallbacks.findIndex(function(n) {
        return n.callback === t && ty(n.instruments, r);
      });
    }, e;
  }()
), _E = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), vE = (
  /** @class */
  function(e) {
    _E(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new tu(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new eu(n, o), u;
    }
    return t.prototype.record = function(r, n, i, o) {
      n = this._attributesProcessor.process(n, i), this._deltaMetricStorage.record(r, n, i, o);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(Qs)
), ru = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), hi = (
  /** @class */
  function() {
    function e() {
    }
    return e.Noop = function() {
      return yE;
    }, e;
  }()
), gE = (
  /** @class */
  function(e) {
    ru(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.process = function(r, n) {
      return r;
    }, t;
  }(hi)
);
(function(e) {
  ru(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n._allowedAttributeNames = r, n;
  }
  return t.prototype.process = function(r, n) {
    var i = this, o = {};
    return Object.keys(r).filter(function(a) {
      return i._allowedAttributeNames.includes(a);
    }).forEach(function(a) {
      return o[a] = r[a];
    }), o;
  }, t;
})(hi);
var yE = new gE(), EE = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, mE = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, TE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, SE = (
  /** @class */
  function() {
    function e(t, r) {
      this._meterProviderSharedState = t, this._instrumentationScope = r, this.metricStorageRegistry = new lE(), this.observableRegistry = new hE(), this.meter = new Zy(this);
    }
    return e.prototype.registerMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, vE);
      return r.length === 1 ? r[0] : new fE(r);
    }, e.prototype.registerAsyncMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, oE);
      return r;
    }, e.prototype.collect = function(t, r, n) {
      return EE(this, void 0, void 0, function() {
        var i, o, a;
        return mE(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.observableRegistry.observe(r, n == null ? void 0 : n.timeoutMillis)];
            case 1:
              return i = u.sent(), o = this.metricStorageRegistry.getStorages(t), o.length === 0 ? [2, null] : (a = o.map(function(c) {
                return c.collect(t, r);
              }).filter(Yg), a.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: a
                },
                errors: i
              }]);
          }
        });
      });
    }, e.prototype._registerMetricStorage = function(t, r) {
      var n = this, i = this._meterProviderSharedState.viewRegistry.findViews(t, this._instrumentationScope), o = i.map(function(c) {
        var s = iy(c, t), l = n.metricStorageRegistry.findOrUpdateCompatibleStorage(s);
        if (l != null)
          return l;
        var f = c.aggregation.createAggregator(s), d = new r(s, f, c.attributesProcessor, n._meterProviderSharedState.metricCollectors, c.aggregationCardinalityLimit);
        return n.metricStorageRegistry.register(d), d;
      });
      if (o.length === 0) {
        var a = this._meterProviderSharedState.selectAggregations(t.type), u = a.map(function(c) {
          var s = TE(c, 2), l = s[0], f = s[1], d = n.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(l, t);
          if (d != null)
            return d;
          var p = f.createAggregator(t), _ = l.selectCardinalityLimit(t.type), h = new r(t, p, hi.Noop(), [l], _);
          return n.metricStorageRegistry.registerForCollector(l, h), h;
        });
        o = o.concat(u);
      }
      return o;
    }, e;
  }()
), OE = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, bE = (
  /** @class */
  function() {
    function e(t) {
      this.resource = t, this.viewRegistry = new Fy(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return e.prototype.getMeterSharedState = function(t) {
      var r = Jg(t), n = this.meterSharedStates.get(r);
      return n == null && (n = new SE(this, t), this.meterSharedStates.set(r, n)), n;
    }, e.prototype.selectAggregations = function(t) {
      var r, n, i = [];
      try {
        for (var o = OE(this.metricCollectors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          i.push([u, u.selectAggregation(t)]);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e;
  }()
), Ve = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Fe = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, AE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, wE = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, RE = (
  /** @class */
  function() {
    function e(t, r) {
      this._sharedState = t, this._metricReader = r;
    }
    return e.prototype.collect = function(t) {
      return Ve(this, void 0, void 0, function() {
        var r, n, i, o, a = this;
        return Fe(this, function(u) {
          switch (u.label) {
            case 0:
              return r = ye(Date.now()), n = [], i = [], o = Array.from(this._sharedState.meterSharedStates.values()).map(function(c) {
                return Ve(a, void 0, void 0, function() {
                  var s;
                  return Fe(this, function(l) {
                    switch (l.label) {
                      case 0:
                        return [4, c.collect(this, r, t)];
                      case 1:
                        return s = l.sent(), (s == null ? void 0 : s.scopeMetrics) != null && n.push(s.scopeMetrics), (s == null ? void 0 : s.errors) != null && i.push.apply(i, wE([], AE(s.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: n
                },
                errors: i
              }];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return Ve(this, void 0, void 0, function() {
        return Fe(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.forceFlush(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return Ve(this, void 0, void 0, function() {
        return Fe(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.shutdown(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._metricReader.selectAggregationTemporality(t);
    }, e.prototype.selectAggregation = function(t) {
      return this._metricReader.selectAggregation(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      var r, n, i;
      return (i = (n = (r = this._metricReader).selectCardinalityLimit) === null || n === void 0 ? void 0 : n.call(r, t)) !== null && i !== void 0 ? i : 2e3;
    }, e;
  }()
), Wo = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Yo = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Jo = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function LE(e, t) {
  var r = t != null ? t : zn.empty();
  return e ? zn.default().merge(r) : r;
}
var PE = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o, a;
      if (this._shutdown = !1, this._sharedState = new bE(LE((a = t == null ? void 0 : t.mergeResourceWithDefaults) !== null && a !== void 0 ? a : !0, t == null ? void 0 : t.resource)), (t == null ? void 0 : t.views) != null && t.views.length > 0)
        try {
          for (var u = Jo(t.views), c = u.next(); !c.done; c = u.next()) {
            var s = c.value;
            this._sharedState.viewRegistry.addView(s);
          }
        } catch (p) {
          r = { error: p };
        } finally {
          try {
            c && !c.done && (n = u.return) && n.call(u);
          } finally {
            if (r) throw r.error;
          }
        }
      if ((t == null ? void 0 : t.readers) != null && t.readers.length > 0)
        try {
          for (var l = Jo(t.readers), f = l.next(); !f.done; f = l.next()) {
            var d = f.value;
            this.addMetricReader(d);
          }
        } catch (p) {
          i = { error: p };
        } finally {
          try {
            f && !f.done && (o = l.return) && o.call(l);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return e.prototype.getMeter = function(t, r, n) {
      return r === void 0 && (r = ""), n === void 0 && (n = {}), this._shutdown ? (v.warn("A shutdown MeterProvider cannot provide a Meter"), fl()) : this._sharedState.getMeterSharedState({
        name: t,
        version: r,
        schemaUrl: n.schemaUrl
      }).meter;
    }, e.prototype.addMetricReader = function(t) {
      var r = new RE(this._sharedState, t);
      t.setMetricProducer(r), this._sharedState.metricCollectors.push(r);
    }, e.prototype.shutdown = function(t) {
      return Wo(this, void 0, void 0, function() {
        return Yo(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.shutdown(t);
              }))]);
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return Wo(this, void 0, void 0, function() {
        return Yo(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.forceFlush(t);
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function NE(e, t) {
  var r = Bs(t);
  return {
    resource: ks(e.resource),
    schemaUrl: void 0,
    scopeMetrics: IE(e.scopeMetrics, r)
  };
}
function IE(e, t) {
  return Array.from(e.map(function(r) {
    return {
      scope: Gs(r.scope),
      metrics: r.metrics.map(function(n) {
        return CE(n, t);
      }),
      schemaUrl: r.scope.schemaUrl
    };
  }));
}
function CE(e, t) {
  var r = {
    name: e.descriptor.name,
    description: e.descriptor.description,
    unit: e.descriptor.unit
  }, n = UE(e.aggregationTemporality);
  switch (e.dataPointType) {
    case W.SUM:
      r.sum = {
        aggregationTemporality: n,
        isMonotonic: e.isMonotonic,
        dataPoints: Zo(e, t)
      };
      break;
    case W.GAUGE:
      r.gauge = {
        dataPoints: Zo(e, t)
      };
      break;
    case W.HISTOGRAM:
      r.histogram = {
        aggregationTemporality: n,
        dataPoints: xE(e, t)
      };
      break;
    case W.EXPONENTIAL_HISTOGRAM:
      r.exponentialHistogram = {
        aggregationTemporality: n,
        dataPoints: DE(e, t)
      };
      break;
  }
  return r;
}
function ME(e, t, r) {
  var n = {
    attributes: Rt(e.attributes),
    startTimeUnixNano: r.encodeHrTime(e.startTime),
    timeUnixNano: r.encodeHrTime(e.endTime)
  };
  switch (t) {
    case ft.INT:
      n.asInt = e.value;
      break;
    case ft.DOUBLE:
      n.asDouble = e.value;
      break;
  }
  return n;
}
function Zo(e, t) {
  return e.dataPoints.map(function(r) {
    return ME(r, e.descriptor.valueType, t);
  });
}
function xE(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: Rt(r.attributes),
      bucketCounts: n.buckets.counts,
      explicitBounds: n.buckets.boundaries,
      count: n.count,
      sum: n.sum,
      min: n.min,
      max: n.max,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function DE(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: Rt(r.attributes),
      count: n.count,
      min: n.min,
      max: n.max,
      sum: n.sum,
      positive: {
        offset: n.positive.offset,
        bucketCounts: n.positive.bucketCounts
      },
      negative: {
        offset: n.negative.offset,
        bucketCounts: n.negative.bucketCounts
      },
      scale: n.scale,
      zeroCount: n.zeroCount,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function UE(e) {
  switch (e) {
    case X.DELTA:
      return 1;
    case X.CUMULATIVE:
      return 2;
  }
}
function BE(e, t) {
  return {
    resourceMetrics: e.map(function(r) {
      return NE(r, t);
    })
  };
}
var kE = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, GE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function $E(e, t) {
  var r, n = e.spanContext(), i = e.status;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
    traceState: (r = n.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: Rt(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map(function(o) {
      return jE(o, t);
    }),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: e.links.map(function(o) {
      return HE(o, t);
    }),
    droppedLinksCount: e.droppedLinksCount
  };
}
function HE(e, t) {
  var r;
  return {
    attributes: e.attributes ? Rt(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (r = e.context.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function jE(e, t) {
  return {
    attributes: e.attributes ? Rt(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function VE(e, t) {
  var r = Bs(t);
  return {
    resourceSpans: XE(e, r)
  };
}
function FE(e) {
  var t, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = kE(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, u = n.get(a.resource);
      u || (u = /* @__PURE__ */ new Map(), n.set(a.resource, u));
      var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), s = u.get(c);
      s || (s = [], u.set(c, s)), s.push(a);
    }
  } catch (l) {
    t = { error: l };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function XE(e, t) {
  for (var r = FE(e), n = [], i = r.entries(), o = i.next(); !o.done; ) {
    for (var a = GE(o.value, 2), u = a[0], c = a[1], s = [], l = c.values(), f = l.next(); !f.done; ) {
      var d = f.value;
      if (d.length > 0) {
        var p = d.map(function(h) {
          return $E(h, t);
        });
        s.push({
          scope: Gs(d[0].instrumentationLibrary),
          spans: p,
          schemaUrl: d[0].instrumentationLibrary.schemaUrl
        });
      }
      f = l.next();
    }
    var _ = {
      resource: ks(u),
      scopeSpans: s,
      schemaUrl: void 0
    };
    n.push(_), o = i.next();
  }
  return n;
}
var nu = {
  serializeRequest: function(e) {
    var t = BE([e], {
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, iu = {
  serializeRequest: function(e) {
    var t = VE(e, {
      useHex: !0,
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, zE = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, qE = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, KE = 5, WE = 1e3, YE = 5e3, JE = 1.5, Qo = 0.2;
function ZE() {
  return Math.random() * (2 * Qo) - Qo;
}
var QE = (
  /** @class */
  function() {
    function e(t) {
      this._transport = t;
    }
    return e.prototype.retry = function(t, r, n) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(t, r).then(o, a);
        }, n);
      });
    }, e.prototype.send = function(t, r) {
      var n;
      return zE(this, void 0, void 0, function() {
        var i, o, a, u, c, s, l;
        return qE(this, function(f) {
          switch (f.label) {
            case 0:
              return i = Date.now() + r, [4, this._transport.send(t, r)];
            case 1:
              o = f.sent(), a = KE, u = WE, f.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(u, YE) + ZE(), 0), u = u * JE, s = (n = o.retryInMillis) !== null && n !== void 0 ? n : c, l = i - Date.now(), s > l ? [2, o] : [4, this.retry(t, l, s)]) : [3, 4];
            case 3:
              return o = f.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, e;
  }()
);
function ou(e) {
  return new QE(e.transport);
}
function tm(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function em(e) {
  if (e != null) {
    var t = Number.parseInt(e, 10);
    if (Number.isInteger(t))
      return t > 0 ? t * 1e3 : -1;
    var r = new Date(e).getTime() - Date.now();
    return r >= 0 ? r : 0;
  }
}
var rm = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, nm = (
  /** @class */
  function() {
    function e(t) {
      this._parameters = t;
    }
    return e.prototype.send = function(t, r) {
      var n = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = r, o.open("POST", n._parameters.url);
        var a = n._parameters.headers();
        Object.entries(a).forEach(function(u) {
          var c = rm(u, 2), s = c[0], l = c[1];
          o.setRequestHeader(s, l);
        }), o.ontimeout = function(u) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (v.debug("XHR success"), i({
            status: "success"
          })) : o.status && tm(o.status) ? i({
            status: "retryable",
            retryInMillis: em(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(t);
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function im(e) {
  return new nm(e);
}
var om = (
  /** @class */
  function() {
    function e(t) {
      this._params = t;
    }
    return e.prototype.send = function(t) {
      var r = this;
      return new Promise(function(n) {
        navigator.sendBeacon(r._params.url, new Blob([t], { type: r._params.blobType })) ? (v.debug("SendBeacon success"), n({
          status: "success"
        })) : n({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function am(e) {
  return new om(e);
}
function sm(e, t) {
  return Ms(e, t, ou({
    transport: im(e)
  }));
}
function um(e, t) {
  return Ms(e, t, ou({
    transport: am({
      url: e.url,
      blobType: e.headers()["Content-Type"]
    })
  }));
}
var cm = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function lm(e) {
  return function() {
    var t, r = {};
    return Object.entries((t = e == null ? void 0 : e()) !== null && t !== void 0 ? t : {}).forEach(function(n) {
      var i = cm(n, 2), o = i[0], a = i[1];
      typeof a != "undefined" ? r[o] = String(a) : v.warn('Header "' + o + '" has invalid value (' + a + ") and will be ignored");
    }), r;
  };
}
var At = function() {
  return At = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, At.apply(this, arguments);
};
function fm(e, t, r) {
  var n = At({}, r()), i = {};
  return function() {
    return t != null && Object.assign(i, t()), e != null && Object.assign(i, e()), Object.assign(i, n);
  };
}
function dm(e) {
  if (e != null)
    try {
      return new URL(e), e;
    } catch (t) {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + e + "'");
    }
}
function pm(e, t, r) {
  var n, i, o, a;
  return At(At({}, Pg(e, t, r)), { headers: fm(lm(e.headers), t.headers, r.headers), url: (i = (n = dm(e.url)) !== null && n !== void 0 ? n : t.url) !== null && i !== void 0 ? i : r.url, agentOptions: (a = (o = e.agentOptions) !== null && o !== void 0 ? o : t.agentOptions) !== null && a !== void 0 ? a : r.agentOptions });
}
function hm(e, t) {
  return At(At({}, Ng()), { headers: function() {
    return e;
  }, url: "http://localhost:4318/" + t, agentOptions: { keepAlive: !0 } });
}
function _m(e, t, r) {
  return pm(
    {
      url: e.url,
      timeoutMillis: e.timeoutMillis,
      headers: Lg(e.headers),
      concurrencyLimit: e.concurrencyLimit
    },
    {},
    // no fallback for browser case
    hm(r, t)
  );
}
function au(e, t, r, n) {
  var i = !!e.headers || typeof navigator.sendBeacon != "function", o = _m(e, r, n);
  return i ? sm(o, t) : um(o, t);
}
var vm = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), gm = (
  /** @class */
  function(e) {
    vm(t, e);
    function t(r) {
      return r === void 0 && (r = {}), e.call(this, au(r, iu, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return t;
  }(Cs)
), cr;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE", e[e.LOWMEMORY = 2] = "LOWMEMORY";
})(cr || (cr = {}));
var ym = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Jn = function() {
  return X.CUMULATIVE;
}, su = function(e) {
  switch (e) {
    case S.COUNTER:
    case S.OBSERVABLE_COUNTER:
    case S.GAUGE:
    case S.HISTOGRAM:
    case S.OBSERVABLE_GAUGE:
      return X.DELTA;
    case S.UP_DOWN_COUNTER:
    case S.OBSERVABLE_UP_DOWN_COUNTER:
      return X.CUMULATIVE;
  }
}, uu = function(e) {
  switch (e) {
    case S.COUNTER:
    case S.HISTOGRAM:
      return X.DELTA;
    case S.GAUGE:
    case S.UP_DOWN_COUNTER:
    case S.OBSERVABLE_UP_DOWN_COUNTER:
    case S.OBSERVABLE_COUNTER:
    case S.OBSERVABLE_GAUGE:
      return X.CUMULATIVE;
  }
};
function Em() {
  var e = Ef(), t = e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return t === "cumulative" ? Jn : t === "delta" ? su : t === "lowmemory" ? uu : (v.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), Jn);
}
function mm(e) {
  return e != null ? e === cr.DELTA ? su : e === cr.LOWMEMORY ? uu : Jn : Em();
}
function Tm(e) {
  return e != null && e.aggregationPreference ? e.aggregationPreference : function(t) {
    return rt.Default();
  };
}
var Sm = (
  /** @class */
  function(e) {
    ym(t, e);
    function t(r, n) {
      var i = e.call(this, r) || this;
      return i._aggregationSelector = Tm(n), i._aggregationTemporalitySelector = mm(n == null ? void 0 : n.temporalityPreference), i;
    }
    return t.prototype.selectAggregation = function(r) {
      return this._aggregationSelector(r);
    }, t.prototype.selectAggregationTemporality = function(r) {
      return this._aggregationTemporalitySelector(r);
    }, t;
  }(Cs)
), Om = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), bm = (
  /** @class */
  function(e) {
    Om(t, e);
    function t(r) {
      return e.call(this, au(r != null ? r : {}, nu, "v1/metrics", { "Content-Type": "application/json" }), r) || this;
    }
    return t;
  }(Sm)
);
function Am(e, t) {
  const r = e.spanContext();
  return {
    name: e.name,
    kind: e.kind,
    spanContext: () => r,
    parentSpanId: e.parentSpanId,
    startTime: e.startTime,
    endTime: e.endTime,
    status: e.status,
    attributes: _d(e.attributes, t),
    links: e.links,
    events: e.events,
    duration: e.duration,
    ended: e.ended,
    resource: e.resource,
    instrumentationLibrary: e.instrumentationLibrary,
    droppedAttributesCount: e.droppedAttributesCount,
    droppedEventsCount: e.droppedEventsCount,
    droppedLinksCount: e.droppedLinksCount
  };
}
function wm(e, t) {
  if (!t.isSamplingEnabled())
    return e;
  const r = [], n = {}, i = {};
  for (const o of e) {
    o.parentSpanId && (i[o.parentSpanId] = i[o.parentSpanId] || [], i[o.parentSpanId].push(
      o.spanContext().spanId
    ));
    const a = t.shouldSample(o);
    a.sample ? a.attributes ? n[o.spanContext().spanId] = Am(
      o,
      a.attributes
    ) : n[o.spanContext().spanId] = o : r.push(o.spanContext().spanId);
  }
  for (; r.length > 0; ) {
    const o = r.shift(), a = i[o];
    if (a)
      for (const u of a)
        delete n[u], r.push(u);
  }
  return Object.values(n);
}
const Rm = (e, t, r) => {
  if (typeof navigator == "undefined" || !navigator.sendBeacon)
    return !1;
  try {
    const n = new Blob([t], { type: r });
    return navigator.sendBeacon(e, n);
  } catch (n) {
    return !1;
  }
}, cu = (e, t, r, n) => {
  const i = (o) => {
    if (Rm(e, t, r))
      return n({ code: N.SUCCESS });
    n({ code: N.FAILED, error: o });
  };
  try {
    const o = new Blob([t], { type: r });
    fetch(e, {
      method: "POST",
      body: o,
      keepalive: !0,
      headers: { "Content-Type": r },
      credentials: "omit"
    }).then(
      (a) => {
        if (a.ok)
          return n({ code: N.SUCCESS });
        n({
          code: N.FAILED,
          error: new Error(
            `keepalive fetch export failed with status ${a.status}`
          )
        });
      },
      // Promise rejection path: keepalive body-size overflow, network
      // error, CORS preflight failure, etc. This is where keepalive's
      // ~64KiB overflow lands — per WHATWG Fetch §4.6 it's an async
      // network error, not a synchronous throw.
      (a) => i(a)
    );
  } catch (o) {
    i(o);
  }
};
class Lm extends gm {
  constructor(r, n) {
    var i;
    super(I(m({}, r), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
    O(this, "url");
    O(this, "unloading", !1);
    this.sampler = n, this.url = (i = r == null ? void 0 : r.url) != null ? i : "";
  }
  setUnloading(r) {
    this.unloading = r;
  }
  export(r, n) {
    const i = wm(r, this.sampler);
    if (i.length === 0)
      return;
    if (this.unloading) {
      const u = iu.serializeRequest(i);
      if (!u || !this.url)
        return n({
          code: N.FAILED,
          error: new Error(
            "keepalive export failed: serializer returned empty or url missing"
          )
        });
      cu(
        this.url,
        u,
        "application/json",
        n
      );
      return;
    }
    let o = 0;
    const a = (u) => {
      if (u.code === N.SUCCESS)
        return n({
          code: N.SUCCESS
        });
      if (o++, o > Ea)
        return n({
          code: N.FAILED,
          error: u.error
        });
      new Promise(
        (c) => setTimeout(
          c,
          ma + Ta * Math.pow(2, o)
        )
      ).then(() => {
        super.export(i, a);
      });
    };
    super.export(i, a);
  }
}
class Pm extends bm {
  constructor(r) {
    var n;
    super(I(m({}, r), {
      headers: {}
    }));
    O(this, "url");
    O(this, "unloading", !1);
    this.url = (n = r == null ? void 0 : r.url) != null ? n : "";
  }
  setUnloading(r) {
    this.unloading = r;
  }
  export(r, n) {
    if (this.unloading) {
      const a = nu.serializeRequest(r);
      if (!a || !this.url)
        return n({
          code: N.FAILED,
          error: new Error(
            "keepalive export failed: serializer returned empty or url missing"
          )
        });
      cu(
        this.url,
        a,
        "application/json",
        n
      );
      return;
    }
    let i = 0;
    const o = (a) => {
      var u;
      if (a.code === N.SUCCESS)
        return n({
          code: N.SUCCESS
        });
      if (i++, i > Ea)
        return console.error(
          `[@launchdarkly/observability] failed to export OTeL metrics: ${(u = a.error) == null ? void 0 : u.message}`,
          a.error
        ), n({
          code: N.FAILED,
          error: a.error
        });
      new Promise(
        (c) => setTimeout(
          c,
          ma + Ta * Math.pow(2, i)
        )
      ).then(() => {
        var c;
        console.warn(
          `[@launchdarkly/observability] retry ${i}, failed to export OTeL metrics: ${(c = a.error) == null ? void 0 : c.message}`,
          a.error
        ), super.export(r, o);
      });
    };
    super.export(r, o);
  }
}
const Nm = "OT_ZONE_CONTEXT", Im = "Navigation:";
function Cm() {
  return !1;
}
const z = class z extends Wa {
  constructor(r = {}) {
    var n, i;
    super(
      z.moduleName,
      z.version,
      r
    );
    O(this, "_spansData", /* @__PURE__ */ new WeakMap());
    O(this, "_zonePatched");
    // for addEventListener/removeEventListener state
    O(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    O(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    O(this, "_eventNames");
    O(this, "_shouldPreventSpanCreation");
    O(this, "_getLDContextKeyAttributes");
    this._getLDContextKeyAttributes = r.getLDContextKeyAttributes, this._eventNames = new Set((n = r == null ? void 0 : r.eventNames) != null ? n : []), ((i = r.productAnalyticsEvents) == null ? void 0 : i.clicks) !== !1 && this._eventNames.add("click"), this._shouldPreventSpanCreation = typeof (r == null ? void 0 : r.shouldPreventSpanCreation) == "function" ? r.shouldPreventSpanCreation : Cm;
  }
  init() {
  }
  /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */
  _checkForTimeout(r, n) {
    const i = this._spansData.get(n);
    i && (r.source === "setTimeout" ? i.hrTimeLastTimeout = Df() : r.source !== "Promise.then" && r.source !== "setTimeout" && (i.hrTimeLastTimeout = void 0));
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(r) {
    return this._eventNames.has(r);
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(r, n) {
    var u, c;
    const i = r == null ? void 0 : r.target, o = r == null ? void 0 : r.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = gs(i, !0);
    try {
      const s = this.tracer.startSpan(
        o,
        {
          attributes: {
            [lt]: window.location.href,
            "event.type": o,
            "event.tag": i.tagName,
            "event.xpath": a,
            "event.id": i.id,
            "event.classname": i.className,
            "event.text": (u = i.textContent) != null ? u : "",
            "event.url": window.location.href,
            "viewport.width": window.innerWidth,
            "viewport.height": window.innerHeight
          }
        },
        n ? R.setSpan(b.active(), n) : void 0
      );
      r instanceof MouseEvent && (s.setAttribute("event.x", r.clientX), s.setAttribute("event.y", r.clientY), s.setAttribute(
        "event.relativeX",
        r.clientX / window.innerWidth
      ), s.setAttribute(
        "event.relativeY",
        r.clientY / window.innerHeight
      ), o === "scroll" && (s.setAttribute("event.scrollX", window.scrollX), s.setAttribute("event.scrollY", window.scrollY)));
      const l = (c = this._getLDContextKeyAttributes) == null ? void 0 : c.call(this);
      return l && s.setAttributes(l), this._shouldPreventSpanCreation(o, i, s) === !0 ? void 0 : (this._spansData.set(s, {
        taskCount: 0
      }), s);
    } catch (s) {
      this._diag.error(
        "failed to start create new user interaction span",
        s
      );
    }
  }
  /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */
  _decrementTask(r) {
    const n = this._spansData.get(r);
    n && (n.taskCount--, n.taskCount === 0 && this._tryToEndSpan(r, n.hrTimeLastTimeout));
  }
  /**
   * Return the current span
   * @param zone
   * @private
   */
  _getCurrentSpan(r) {
    const n = r.get(Nm);
    return n && R.getSpan(n);
  }
  /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */
  _incrementTask(r) {
    const n = this._spansData.get(r);
    n && n.taskCount++;
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(r, n, i, o) {
    let a = this._wrappedListeners.get(i);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
    let u = a.get(n);
    return u || (u = /* @__PURE__ */ new Map(), a.set(n, u)), u.has(r) ? !1 : (u.set(r, o), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(r, n, i) {
    const o = this._wrappedListeners.get(i);
    if (!o)
      return;
    const a = o.get(n);
    if (!a)
      return;
    const u = a.get(r);
    return u && (a.delete(r), a.size === 0 && (o.delete(n), o.size === 0 && this._wrappedListeners.delete(i))), u;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(r, n, i) {
    return typeof r == "function" ? r.apply(n, i) : r.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const r = this;
    let n = /* @__PURE__ */ new Map();
    return (i) => function(a, u, c) {
      if (!u)
        return i.call(this, a, u, c);
      const s = c && typeof c == "object" && c.once, l = function(...f) {
        var h;
        let d;
        const p = f[0];
        if (!(p != null && p.type))
          return r._invokeListener(u, this, f);
        if (Date.now() - ((h = n.get(p.type)) != null ? h : 0) < 1e3 / 60)
          return r._invokeListener(u, this, f);
        n.set(p.type, Date.now()), p && (d = r._eventsSpanMap.get(p)), s && r.removePatchedListener(this, a, u);
        const _ = r._createSpan(p, d);
        return _ ? (p && r._eventsSpanMap.set(p, _), b.with(
          R.setSpan(b.active(), _),
          () => {
            const g = r._invokeListener(
              u,
              this,
              f
            );
            return _.end(), g;
          }
        )) : r._invokeListener(u, this, f);
      };
      if (r.addPatchedListener(
        this,
        a,
        u,
        l
      ))
        return i.call(
          this,
          a,
          l,
          c
        );
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = r.removePatchedListener(
        this,
        o,
        a
      );
      return c ? n.call(
        this,
        o,
        c,
        u
      ) : n.call(this, o, a, u);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const r = this;
    return (n) => function(...o) {
      const a = `${location.pathname}${location.hash}${location.search}`, u = n.apply(this, o), c = `${location.pathname}${location.hash}${location.search}`;
      return a !== c && r._updateInteractionName(c), u;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    B(history.replaceState) && this._unwrap(history, "replaceState"), B(history.pushState) && this._unwrap(history, "pushState"), B(history.back) && this._unwrap(history, "back"), B(history.forward) && this._unwrap(history, "forward"), B(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(r) {
    const n = R.getSpan(
      b.active()
    );
    n && typeof n.updateName == "function" && n.updateName(`${Im} ${r}`);
  }
  /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */
  _patchZoneCancelTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && r._decrementTask(u), n.call(this, o);
    };
  }
  /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */
  _patchZoneScheduleTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && (r._incrementTask(u), r._checkForTimeout(o, u)), n.call(this, o);
    };
  }
  /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */
  _patchZoneRunTask() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = Array.isArray(u) && u[0] instanceof Event ? u[0] : void 0, s = c == null ? void 0 : c.target;
      let l;
      const f = this;
      if (s) {
        if (l = r._createSpan(c), l)
          return r._incrementTask(l), f.run(() => {
            try {
              return b.with(
                R.setSpan(
                  b.active(),
                  l
                ),
                () => {
                  const d = Zone.current;
                  return o._zone = d, n.call(
                    d,
                    o,
                    a,
                    u
                  );
                }
              );
            } finally {
              r._decrementTask(l);
            }
          });
      } else
        l = r._getCurrentSpan(f);
      try {
        return n.call(f, o, a, u);
      } finally {
        l && r._shouldCountTask(o, f) && r._decrementTask(l);
      }
    };
  }
  /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */
  _shouldCountTask(r, n) {
    if (r._zone && (n = r._zone), !n || !r.data || r.data.isPeriodic)
      return !1;
    const i = this._getCurrentSpan(n);
    return !i || !this._spansData.get(i) ? !1 : r.type === "macroTask" || r.type === "microTask";
  }
  /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */
  _tryToEndSpan(r, n) {
    r && this._spansData.get(r) && (r.end(n), this._spansData.delete(r));
  }
  /**
   * implements enable function
   */
  enable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "applying patch to",
      z.moduleName,
      z.version,
      "zone:",
      !!r
    ), r ? (B(r.prototype.runTask) && (this._unwrap(r.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), B(r.prototype.scheduleTask) && (this._unwrap(r.prototype, "scheduleTask"), this._diag.debug(
      "removing previous patch from method scheduleTask"
    )), B(r.prototype.cancelTask) && (this._unwrap(r.prototype, "cancelTask"), this._diag.debug(
      "removing previous patch from method cancelTask"
    )), this._zonePatched = !0, this._wrap(
      r.prototype,
      "runTask",
      this._patchZoneRunTask()
    ), this._wrap(
      r.prototype,
      "scheduleTask",
      this._patchZoneScheduleTask()
    ), this._wrap(
      r.prototype,
      "cancelTask",
      this._patchZoneCancelTask()
    )) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach((i) => {
      B(i.addEventListener) && (this._unwrap(i, "addEventListener"), this._diag.debug(
        "removing previous patch from method addEventListener"
      )), B(i.removeEventListener) && (this._unwrap(i, "removeEventListener"), this._diag.debug(
        "removing previous patch from method removeEventListener"
      )), this._wrap(
        i,
        "addEventListener",
        this._patchAddEventListener()
      ), this._wrap(
        i,
        "removeEventListener",
        this._patchRemoveEventListener()
      );
    })), this._patchHistoryApi();
  }
  /**
   * implements unpatch function
   */
  disable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "removing patch from",
      z.moduleName,
      z.version,
      "zone:",
      !!r
    ), r && this._zonePatched ? (B(r.prototype.runTask) && this._unwrap(r.prototype, "runTask"), B(r.prototype.scheduleTask) && this._unwrap(r.prototype, "scheduleTask"), B(r.prototype.cancelTask) && this._unwrap(r.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach((i) => {
      B(i.addEventListener) && this._unwrap(i, "addEventListener"), B(i.removeEventListener) && this._unwrap(i, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * returns Zone
   */
  _getZoneWithPrototype() {
    return window.Zone;
  }
};
O(z, "version", "0.1.1"), O(z, "moduleName", "user-interaction");
let Zn = z;
const $t = class $t extends Wa {
  constructor(r = {}) {
    super(
      $t.moduleName,
      $t.version,
      r
    );
    O(this, "_getLDContextKeyAttributes");
    O(this, "_unlisten");
    O(this, "_lastUrl", "");
    this._getLDContextKeyAttributes = r.getLDContextKeyAttributes;
  }
  init() {
  }
  enable() {
    this._lastUrl = window.location.href, this._unlisten = Du((r) => {
      var i;
      const n = this._lastUrl;
      if (this._lastUrl = r, n !== r)
        try {
          const o = this.tracer.startSpan(Uu, {
            attributes: {
              [lt]: r,
              "page_view.previous_url": n,
              "page_view.url": r
            }
          }), a = (i = this._getLDContextKeyAttributes) == null ? void 0 : i.call(this);
          a && o.setAttributes(a), o.end();
        } catch (o) {
          this._diag.error("failed to create page view span", o);
        }
    });
  }
  disable() {
    var r;
    (r = this._unlisten) == null || r.call(this), this._unlisten = void 0;
  }
};
O($t, "version", "0.1.0"), O($t, "moduleName", "location-change");
let Qn = $t, x = {}, Z, Qe;
const St = "highlight.record", Mm = "highlight.session_id", ti = /* @__PURE__ */ new Map(), lu = (e) => `${e.spanContext().traceId}:${e.spanContext().spanId}`, fu = "launchdarkly.js.log", xm = "launchdarkly.exception.id", ta = "launchdarkly.sampling.ratio", du = "log.severity", pu = "log.message", Dm = (e, t) => {
  var h, g, y, E, A, w, P, M, It, pt;
  if (x.tracerProvider || x.meterProvider) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  Z = e;
  const r = e.backendUrl || void 0 || "https://pub.highlight.io", n = [
    ...(g = (h = e.networkRecordingOptions) == null ? void 0 : h.urlBlocklist) != null ? g : [],
    ...cg
  ], i = (y = e.environment) != null ? y : "production", o = {
    url: e.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 10,
    timeoutMillis: 3e4,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip",
    keepAlive: !0,
    httpAgentOptions: {
      timeout: 6e4,
      keepAlive: !0
    }
  }, a = new Lm(
    o,
    t
  ), u = new lr(a, {
    maxExportBatchSize: 1024,
    // Default value from SDK is 512
    maxQueueSize: 2048,
    // Default value from SDK is 2048
    exportTimeoutMillis: o.timeoutMillis,
    // Default value from SDK is 30_000
    scheduledDelayMillis: 5e3
    // OTEL default; shorter window reduces data lost to page unload
  }), c = new zn({
    [$u]: (E = e.serviceName) != null ? E : "highlight-browser",
    [Gu]: e.serviceVersion,
    "deployment.environment.name": i,
    "highlight.project_id": e.projectId,
    [ku]: navigator.userAgent,
    "browser.language": navigator.language,
    "telemetry.distro.name": "@highlight-run/observability",
    "telemetry.distro.version": Bu
  });
  x.tracerProvider = new Hh({
    resource: c,
    mergeResourceWithDefaults: !0,
    spanProcessors: [u]
  }), R.setGlobalTracerProvider(x.tracerProvider);
  const s = new Pm(I(m({}, o), {
    url: e.otlpEndpoint + "/v1/metrics"
  })), l = new Vy({
    exporter: s,
    exportIntervalMillis: o.timeoutMillis,
    exportTimeoutMillis: o.timeoutMillis
  });
  x.meterProvider = new PE({ resource: c, readers: [l] }), qt.setGlobalMeterProvider(x.meterProvider);
  let f = [];
  if (((A = e.instrumentations) == null ? void 0 : A["@opentelemetry/instrumentation-document-load"]) !== !1 && f.push(
    new d_({
      applyCustomAttributesOnSpan: {
        documentLoad: na,
        documentFetch: na,
        resourceFetch: qm
      }
    })
  ), ((w = e.instrumentations) == null ? void 0 : w["@opentelemetry/instrumentation-user-interaction"]) !== !1 && f.push(
    new Zn({
      productAnalyticsEvents: e.productAnalyticsEvents,
      getLDContextKeyAttributes: e.getLDContextKeyAttributes
    })
  ), ((P = e.productAnalyticsEvents) == null ? void 0 : P.pageViews) !== !1 && f.push(
    new Qn({
      getLDContextKeyAttributes: e.getLDContextKeyAttributes
    })
  ), (M = e.networkRecordingOptions) != null && M.enabled) {
    if (((It = e.instrumentations) == null ? void 0 : It["@opentelemetry/instrumentation-fetch"]) !== !1) {
      const ht = new av({
        propagateTraceHeaderCorsUrls: ia(
          e.tracingOrigins
        ),
        applyCustomAttributesOnSpan: ($, Yt, Mt) => {
          var Zt, Qt;
          if (!$.attributes)
            return;
          const Jt = $;
          if (Jt.attributes[St] !== !1) {
            if (ra(
              $,
              Yt.body,
              Yt.headers,
              e.networkRecordingOptions
            ), !(Mt instanceof Response)) {
              $.setAttributes({
                "http.response.error": Mt.message,
                [Sa]: Mt.status
              });
              return;
            }
            if (!((Zt = e.networkRecordingOptions) != null && Zt.requestResponseSanitizer && (vn(
              $,
              e.networkRecordingOptions.requestResponseSanitizer
            ), Jt.attributes[St] === !1)) && (Qt = e.networkRecordingOptions) != null && Qt.recordHeadersAndBody) {
              const Ne = U(void 0, null, function* () {
                var mi, Ti, Si, Oi, bi, Ai;
                const Ie = yield Is(
                  Mt,
                  (mi = e.networkRecordingOptions) == null ? void 0 : mi.bodyKeysToRecord,
                  (Ti = e.networkRecordingOptions) == null ? void 0 : Ti.networkBodyKeysToRedact
                ), Or = Object.fromEntries(
                  Mt.headers.entries()
                ), wu = gr(
                  (Oi = (Si = e.networkRecordingOptions) == null ? void 0 : Si.networkHeadersToRedact) != null ? Oi : [],
                  Or,
                  (bi = e.networkRecordingOptions) == null ? void 0 : bi.headerKeysToRecord
                ), Ru = _i(
                  wu,
                  "http.response.header"
                );
                Object.assign(
                  $.attributes,
                  m({
                    "http.response.body": Ie
                  }, Ru)
                ), (Ai = e.networkRecordingOptions) != null && Ai.requestResponseSanitizer && vn(
                  $,
                  e.networkRecordingOptions.requestResponseSanitizer
                );
              });
              ti.set(lu($), Ne);
            }
          }
        }
      });
      f.push(ht);
    }
    ((pt = e.instrumentations) == null ? void 0 : pt["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && f.push(
      new Kv({
        propagateTraceHeaderCorsUrls: ia(
          e.tracingOrigins
        ),
        applyCustomAttributesOnSpan: (ht, $) => {
          var Jt, Zt, Qt, Ne;
          const Yt = $;
          if (!(!ht.attributes || ht.attributes[St] === !1)) {
            if (ra(
              ht,
              Yt._body,
              Yt._requestHeaders,
              e.networkRecordingOptions
            ), (Jt = e.networkRecordingOptions) != null && Jt.recordHeadersAndBody) {
              let Ie = "";
              ($.responseType === "" || $.responseType === "text") && (Ie = et(
                $.responseText,
                (Zt = e.networkRecordingOptions) == null ? void 0 : Zt.networkBodyKeysToRedact,
                (Qt = e.networkRecordingOptions) == null ? void 0 : Qt.bodyKeysToRecord,
                void 0
              ));
              const Or = Hm(
                $.getAllResponseHeaders()
              );
              Xm(
                ht,
                Or,
                Ie,
                e.networkRecordingOptions
              );
            }
            (Ne = e.networkRecordingOptions) != null && Ne.requestResponseSanitizer && vn(
              ht,
              e.networkRecordingOptions.requestResponseSanitizer
            );
          }
        }
      })
    );
  }
  Rd({ instrumentations: f });
  const _ = new hs();
  return _.enable(), x.tracerProvider.register({
    contextManager: _,
    propagator: new Gf({
      propagators: [
        new Jl(),
        new Bm({
          backendUrl: r,
          otlpEndpoint: e.otlpEndpoint,
          tracingOrigins: e.tracingOrigins,
          urlBlocklist: n
        })
      ]
    })
  }), Qe = Um(
    a,
    s,
    u,
    () => x
  ), x;
}, Um = (e, t, r, n) => {
  if (typeof document == "undefined" || typeof window == "undefined")
    return () => {
    };
  const i = () => {
    var c, s;
    e.setUnloading(!0), t.setUnloading(!0), r.setSkipPendingOnFlush(!0);
    const u = n();
    (c = u.tracerProvider) == null || c.forceFlush().catch(() => {
    }), (s = u.meterProvider) == null || s.forceFlush().catch(() => {
    });
  }, o = () => {
    document.visibilityState === "hidden" ? i() : document.visibilityState === "visible" && (e.setUnloading(!1), t.setUnloading(!1), r.setSkipPendingOnFlush(!1));
  }, a = () => i();
  return document.addEventListener("visibilitychange", o), window.addEventListener("pagehide", a), () => {
    document.removeEventListener("visibilitychange", o), window.removeEventListener("pagehide", a);
  };
};
class lr extends ps {
  constructor() {
    super(...arguments);
    O(this, "_pendingSpans", /* @__PURE__ */ new Set());
    // When set, forceFlush/shutdown return immediately without waiting for
    // in-flight response-body reads. Used on page unload where waiting risks
    // the browser freezing JS before we hand the spans to the transport.
    O(this, "_skipPendingOnFlush", !1);
  }
  setSkipPendingOnFlush(r) {
    this._skipPendingOnFlush = r;
  }
  onStart(r, n) {
    r.setAttribute(Mm, it()), super.onStart(r, n);
  }
  onEnd(r) {
    if (r.attributes[St] === !1)
      return;
    const n = lu(r), i = ti.get(n);
    if (i) {
      const o = i.catch((a) => {
        console.warn(
          "[CustomBatchSpanProcessor] Failed to capture response body attributes",
          a
        );
      }).finally(() => {
        ti.delete(n), this._pendingSpans.delete(o), r.attributes[St] !== !1 && super.onEnd(r);
      });
      this._pendingSpans.add(o);
      return;
    }
    super.onEnd(r);
  }
  shutdown() {
    return U(this, null, function* () {
      return this._skipPendingOnFlush || (yield Promise.allSettled(this._pendingSpans)), wr(lr.prototype, this, "shutdown").call(this);
    });
  }
  forceFlush() {
    return U(this, null, function* () {
      return this._skipPendingOnFlush || (yield Promise.allSettled(this._pendingSpans)), wr(lr.prototype, this, "forceFlush").call(this);
    });
  }
}
class Bm extends rd {
  constructor(r) {
    super();
    O(this, "highlightEndpoints");
    O(this, "tracingOrigins");
    O(this, "urlBlocklist");
    this.highlightEndpoints = [
      r.backendUrl,
      `${r.otlpEndpoint}/v1/traces`,
      `${r.otlpEndpoint}/v1/logs`,
      `${r.otlpEndpoint}/v1/metrics`
    ], this.tracingOrigins = r.tracingOrigins, this.urlBlocklist = r.urlBlocklist;
  }
  inject(r, n, i) {
    var u;
    const o = R.getSpan(r);
    if (!o || !o.attributes)
      return;
    const a = vu(o);
    typeof a == "string" && (zm(
      a,
      this.highlightEndpoints,
      this.tracingOrigins,
      this.urlBlocklist
    ) || o.setAttribute(St, !1), !di(
      a,
      (u = this.tracingOrigins) != null ? u : [],
      this.urlBlocklist
    )) || super.inject(r, n, i);
  }
}
const hu = "highlight-browser", km = hu, ea = () => {
  var e;
  return (e = x.tracerProvider) == null ? void 0 : e.getTracer(hu);
}, Xe = () => {
  var e;
  return (e = x.meterProvider) == null ? void 0 : e.getMeter(km);
}, Gm = () => R.getActiveSpan(), $m = () => U(void 0, null, function* () {
  Qe && (Qe(), Qe = void 0), yield Promise.allSettled([
    U(void 0, null, function* () {
      x.tracerProvider ? (yield x.tracerProvider.shutdown(), x.tracerProvider = void 0) : console.warn(
        "OTEL shutdown called without initialized tracerProvider."
      );
    }),
    U(void 0, null, function* () {
      x.meterProvider ? (yield x.meterProvider.shutdown(), x.meterProvider = void 0) : console.warn(
        "OTEL shutdown called without initialized meterProvider."
      );
    })
  ]);
}), ra = (e, t, r, n) => {
  var s;
  if (!e.attributes)
    return;
  const o = vu(e), a = qn(o), u = ws(a), c = ig(t);
  if (c && (c.name && e.setAttribute("graphql.operation.name", c.name), c.type && e.setAttribute("graphql.operation.type", c.type)), e.setAttributes({
    "highlight.type": "http.request",
    [Vt]: a,
    // overwrite with sanitized version
    [lt]: a,
    [qe]: u.pathname,
    [ju]: u.search
  }), e.setAttributes(
    jm(
      u.searchParams,
      "url.query_params"
    )
  ), n != null && n.recordHeadersAndBody) {
    const l = et(
      t,
      n.networkBodyKeysToRedact,
      n.bodyKeysToRecord,
      r
    );
    e.setAttribute("http.request.body", l);
    const f = gr(
      (s = n.networkHeadersToRedact) != null ? s : [],
      r,
      n.headerKeysToRecord
    ), d = _i(
      f,
      "http.request.header"
    );
    e.setAttributes(d);
  }
}, Hm = (e) => {
  const t = {};
  return e && e.trim().split(/[\r\n]+/).forEach((r) => {
    const n = r.split(": "), i = n.shift();
    i && (t[i] = n.join(": "));
  }), t;
}, _i = (e, t) => {
  const r = {};
  return Object.entries(e).forEach(([n, i]) => {
    const o = n.toLowerCase().replace(/_/g, "-"), a = `${t}.${o}`, u = Fm(o, i);
    if (r[a]) {
      const c = r[a];
      Array.isArray(c) ? r[a] = [...c, ...u] : r[a] = [c, ...u];
    } else
      r[a] = u.length === 1 ? u[0] : u;
  }), r;
}, jm = (e, t) => {
  const r = {};
  for (const [n, i] of e.entries()) {
    const o = `${t}.${n}`, a = r[o];
    a === void 0 ? r[o] = i : Array.isArray(a) ? a.push(i) : r[o] = [a, i];
  }
  return r;
}, Vm = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "accept-encoding",
  "accept-language",
  "accept-ranges",
  "allow",
  "cache-control",
  "connection",
  "content-encoding",
  "content-language",
  "expect",
  "if-match",
  "if-none-match",
  "pragma",
  "proxy-authenticate",
  "te",
  "trailer",
  "transfer-encoding",
  "upgrade",
  "vary",
  "via",
  "warning",
  "www-authenticate",
  "access-control-allow-headers",
  "access-control-allow-methods",
  "access-control-expose-headers",
  "access-control-request-headers"
]), Fm = (e, t) => Vm.has(e) ? t.split(",").map((r) => r.trim()).filter((r) => r.length > 0) : [t], Xm = (e, t, r, n) => {
  var a;
  e.setAttribute("http.response.body", r);
  const i = gr(
    (a = n.networkHeadersToRedact) != null ? a : [],
    t,
    n.headerKeysToRecord
  ), o = _i(
    i,
    "http.response.header"
  );
  e.setAttributes(o);
}, vn = (e, t) => {
  var f, d, p, _, h, g, y, E, A, w;
  const n = e.attributes, i = {}, o = {};
  for (const [P, M] of Object.entries(n))
    P.startsWith("http.request.header.") && (i[P.slice(20)] = String(M)), P.startsWith("http.response.header.") && (o[P.slice(21)] = String(M));
  let u = {
    request: {
      sessionSecureID: "",
      id: "",
      url: (d = (f = n[lt]) != null ? f : n[Vt]) != null ? d : "",
      verb: (p = n["http.request.method"]) != null ? p : "GET",
      headers: i,
      body: (_ = n["http.request.body"]) != null ? _ : ""
    },
    response: {
      status: Number(
        (h = n[Sa]) != null ? h : 0
      ),
      headers: o,
      body: (g = n["http.response.body"]) != null ? g : ""
    },
    urlBlocked: !1
  }, c = !0;
  try {
    u.request.body = JSON.parse(u.request.body);
  } catch (P) {
    c = !1;
  }
  let s = !0;
  try {
    u.response.body = JSON.parse(u.response.body);
  } catch (P) {
    s = !1;
  }
  let l;
  try {
    l = t(u);
  } catch (P) {
    return;
  }
  if (!l) {
    Object.assign(e.attributes, {
      [St]: !1
    });
    return;
  }
  c && ((y = l.request) != null && y.body) && (l.request.body = JSON.stringify(l.request.body)), s && ((E = l.response) != null && E.body) && (l.response.body = JSON.stringify(l.response.body)), Object.assign(e.attributes, {
    "http.request.body": (A = l.request.body) != null ? A : "",
    "http.response.body": (w = l.response.body) != null ? w : ""
  });
}, zm = (e, t, r, n) => n != null && n.some(
  (o) => e.toLowerCase().includes(o)
) ? !1 : fi(
  e,
  t
), na = (e) => {
  var o, a, u;
  if (!e.events)
    return;
  const r = e.events, n = {
    unload: H("unloadEventStart", "unloadEventEnd", r),
    dom_interactive: H(
      "fetchStart",
      "domInteractive",
      r
    ),
    dom_content_loaded: H(
      "domContentLoadedEventStart",
      "domContentLoadedEventEnd",
      r
    ),
    dom_complete: H("fetchStart", "domComplete", r),
    load_event: H("loadEventStart", "loadEventEnd", r),
    document_load: H("fetchStart", "loadEventEnd", r),
    first_paint: H("fetchStart", "firstPaint", r),
    first_contentful_paint: H(
      "fetchStart",
      "firstContentfulPaint",
      r
    ),
    domain_lookup: H(
      "domainLookupStart",
      "domainLookupEnd",
      r
    ),
    connect: H("connectStart", "connectEnd", r),
    request: H("requestStart", "requestEnd", r),
    response: H("responseStart", "responseEnd", r)
  }, i = (a = (o = Z == null ? void 0 : Z.getIntegrations) == null ? void 0 : o.call(Z)) != null ? a : [];
  if (n.document_load !== void 0)
    for (const c of i)
      c.recordGauge((u = Z == null ? void 0 : Z.sessionSecureId) != null ? u : "", {
        name: Hu,
        value: n.document_load / 1e6
      });
  Object.entries(n).forEach(([c, s]) => {
    s !== void 0 && (e.setAttribute(`timings.${c}.ns`, s), e.setAttribute(
      `timings.${c}.readable`,
      _u(s)
    ));
  });
};
function H(e, t, r) {
  const n = r.find((u) => u.name === e), i = r.find((u) => u.name === t);
  if (!n || !i)
    return;
  const o = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const qm = (e, t) => {
  const r = {
    domain_lookup: (t.domainLookupEnd - t.domainLookupStart) * 1e9,
    connect: (t.connectEnd - t.connectStart) * 1e9,
    request: (t.responseEnd - t.requestStart) * 1e9,
    response: (t.responseEnd - t.responseStart) * 1e9
  };
  Object.entries(r).forEach(([n, i]) => {
    e.setAttribute(`timings.${n}.ns`, i), e.setAttribute(`timings.${n}.readable`, _u(i));
  });
}, _u = (e) => {
  if (e >= 36e11) {
    const a = e / 36e11;
    return `${Number(a.toFixed(1))}h`;
  } else if (e >= 6e10) {
    const a = e / 6e10;
    return `${Number(a.toFixed(1))}m`;
  } else if (e >= 1e9) {
    const a = e / 1e9;
    return `${Number(a.toFixed(1))}s`;
  } else if (e >= 1e6) {
    const a = e / 1e6;
    return `${Number(a.toFixed(1))}ms`;
  } else if (e >= 1e3) {
    const a = e / 1e3;
    return `${Number(a.toFixed(1))}µs`;
  } else
    return `${Number(e.toFixed(1))}ns`;
}, ia = (e) => e === !0 ? [
  /localhost/,
  /^\//,
  Ls(window.location.host)
] : Array.isArray(e) ? e.map(
  (t) => typeof t == "string" ? new RegExp(t) : t
) : /^$/, vu = (e) => e.attributes[lt] ? e.attributes[lt] : e.attributes[Vt], Km = 30, Wm = () => new Promise(
  (e) => requestAnimationFrame(
    (t) => requestAnimationFrame((r) => e(r - t))
  )
), Ym = () => U(void 0, null, function* () {
  const e = [];
  for (let t = 0; t < Km; t++)
    e.push(yield Wm());
  return e.reduce((t, r) => t + r, 0) / e.length;
}), Jm = (e, t) => {
  let r = {}, n = 16.666666666666668;
  Ym().then((c) => n = c);
  const i = (c) => {
    var s;
    r != null && r.event || (r = {
      event: c,
      location: window.location.href,
      timerStart: (s = window.performance) == null ? void 0 : s.now()
    }, window.requestAnimationFrame(o));
  }, o = () => {
    if (!(r != null && r.timerStart)) return;
    const c = window.performance.now() - r.timerStart - n;
    a(c), r = {};
  }, a = (c) => {
    const s = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: s,
      jankAmount: c,
      querySelector: u(),
      newLocation: window.location.href != r.location ? window.location.href : void 0
    });
  }, u = () => {
    var c;
    return (c = r == null ? void 0 : r.event) != null && c.target ? Vu(r.event.target) : "";
  };
  return window.addEventListener("click", i, !0), window.addEventListener("keydown", i, !0), () => {
    window.removeEventListener("keydown", i, !0), window.removeEventListener("click", i, !0);
  };
}, Zm = typeof window != "undefined", oa = Zm && "performance" in window && "memory" in performance ? performance : { memory: {} }, Qm = (e, t) => {
  let r = 0, n = 0;
  const i = () => {
    const l = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3, f = oa.memory.jsHeapSizeLimit || 0, d = oa.memory.usedJSHeapSize || 0;
    e({
      jsHeapSizeLimit: f,
      usedJSHeapSize: d,
      relativeTimestamp: l,
      fps: r
    });
  };
  i();
  let o;
  o = setInterval(() => {
    i();
  }, 1e3);
  let a = 0, u = Date.now();
  const c = function() {
    var s = Date.now();
    a++, s > 1e3 + u && (r = Math.round(a * 1e3 / (s - u)), a = 0, u = s), n = requestAnimationFrame(c);
  };
  return c(), () => {
    clearInterval(o), cancelAnimationFrame(n);
  };
};
var st, pe, gu, fr, ei, Kt = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, Oe = function(e) {
  if (document.readyState === "loading") return "loading";
  var t = Kt();
  if (t) {
    if (e < t.domInteractive) return "loading";
    if (t.domContentLoadedEventStart === 0 || e < t.domContentLoadedEventStart) return "dom-interactive";
    if (t.domComplete === 0 || e < t.domComplete) return "dom-content-loaded";
  }
  return "complete";
}, tT = function(e) {
  var t = e.nodeName;
  return e.nodeType === 1 ? t.toLowerCase() : t.toUpperCase().replace(/^#/, "");
}, mr = function(e, t) {
  var r = "";
  try {
    for (; e && e.nodeType !== 9; ) {
      var n = e, i = n.id ? "#" + n.id : tT(n) + (n.classList && n.classList.value && n.classList.value.trim() && n.classList.value.trim().length ? "." + n.classList.value.trim().replace(/\s+/g, ".") : "");
      if (r.length + i.length > 99) return r || i;
      if (r = r ? i + ">" + r : i, n.id) break;
      e = n.parentNode;
    }
  } catch (o) {
  }
  return r;
}, yu = -1, Eu = function() {
  return yu;
}, Nt = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && (yu = t.timeStamp, e(t));
  }, !0);
}, Tr = function() {
  var e = Kt();
  return e && e.activationStart || 0;
}, V = function(e, t) {
  var r = Kt(), n = "navigate";
  return Eu() >= 0 ? n = "back-forward-cache" : r && (document.prerendering || Tr() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : r.type && (n = r.type.replace(/_/g, "-"))), { name: e, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, Wt = function(e, t, r) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var n = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          t(i.getEntries());
        });
      });
      return n.observe(Object.assign({ type: e, buffered: !0 }, r || {})), n;
    }
  } catch (i) {
  }
}, F = function(e, t, r, n) {
  var i, o;
  return function(a) {
    t.value >= 0 && (a || n) && ((o = t.value - (i || 0)) || i === void 0) && (i = t.value, t.delta = o, t.rating = function(u, c) {
      return u > c[1] ? "poor" : u > c[0] ? "needs-improvement" : "good";
    }(t.value, r), e(t));
  };
}, vi = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, Sr = function(e) {
  var t = function(r) {
    r.type !== "pagehide" && document.visibilityState !== "hidden" || e(r);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, gi = function(e) {
  var t = !1;
  return function(r) {
    t || (e(r), t = !0);
  };
}, Gt = -1, aa = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, dr = function(e) {
  document.visibilityState === "hidden" && Gt > -1 && (Gt = e.type === "visibilitychange" ? e.timeStamp : 0, eT());
}, sa = function() {
  addEventListener("visibilitychange", dr, !0), addEventListener("prerenderingchange", dr, !0);
}, eT = function() {
  removeEventListener("visibilitychange", dr, !0), removeEventListener("prerenderingchange", dr, !0);
}, yi = function() {
  return Gt < 0 && (Gt = aa(), sa(), Nt(function() {
    setTimeout(function() {
      Gt = aa(), sa();
    }, 0);
  })), { get firstHiddenTime() {
    return Gt;
  } };
}, Pe = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, ua = [1800, 3e3], mu = function(e, t) {
  t = t || {}, Pe(function() {
    var r, n = yi(), i = V("FCP"), o = Wt("paint", function(a) {
      a.forEach(function(u) {
        u.name === "first-contentful-paint" && (o.disconnect(), u.startTime < n.firstHiddenTime && (i.value = Math.max(u.startTime - Tr(), 0), i.entries.push(u), r(!0)));
      });
    });
    o && (r = F(e, i, ua, t.reportAllChanges), Nt(function(a) {
      i = V("FCP"), r = F(e, i, ua, t.reportAllChanges), vi(function() {
        i.value = performance.now() - a.timeStamp, r(!0);
      });
    }));
  });
}, ca = [0.1, 0.25], rT = function(e, t) {
  (function(r, n) {
    n = n || {}, mu(gi(function() {
      var i, o = V("CLS", 0), a = 0, u = [], c = function(l) {
        l.forEach(function(f) {
          if (!f.hadRecentInput) {
            var d = u[0], p = u[u.length - 1];
            a && f.startTime - p.startTime < 1e3 && f.startTime - d.startTime < 5e3 ? (a += f.value, u.push(f)) : (a = f.value, u = [f]);
          }
        }), a > o.value && (o.value = a, o.entries = u, i());
      }, s = Wt("layout-shift", c);
      s && (i = F(r, o, ca, n.reportAllChanges), Sr(function() {
        c(s.takeRecords()), i(!0);
      }), Nt(function() {
        a = 0, o = V("CLS", 0), i = F(r, o, ca, n.reportAllChanges), vi(function() {
          return i();
        });
      }), setTimeout(i, 0));
    }));
  })(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries.reduce(function(u, c) {
          return u && u.value > c.value ? u : c;
        });
        if (i && i.sources && i.sources.length) {
          var o = (a = i.sources).find(function(u) {
            return u.node && u.node.nodeType === 1;
          }) || a[0];
          if (o) return void (n.attribution = { largestShiftTarget: mr(o.node), largestShiftTime: i.startTime, largestShiftValue: i.value, largestShiftSource: o, largestShiftEntry: i, loadState: Oe(i.startTime) });
        }
      }
      var a;
      n.attribution = {};
    })(r), e(r);
  }, t);
}, nT = function(e, t) {
  mu(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = Kt(), o = n.entries[n.entries.length - 1];
        if (i) {
          var a = i.activationStart || 0, u = Math.max(0, i.responseStart - a);
          return void (n.attribution = { timeToFirstByte: u, firstByteToFCP: n.value - u, loadState: Oe(n.entries[0].startTime), navigationEntry: i, fcpEntry: o });
        }
      }
      n.attribution = { timeToFirstByte: 0, firstByteToFCP: n.value, loadState: Oe(Eu()) };
    })(r), e(r);
  }, t);
}, ce = { passive: !0, capture: !0 }, iT = /* @__PURE__ */ new Date(), la = function(e, t) {
  st || (st = t, pe = e, gu = /* @__PURE__ */ new Date(), Su(removeEventListener), Tu());
}, Tu = function() {
  if (pe >= 0 && pe < gu - iT) {
    var e = { entryType: "first-input", name: st.type, target: st.target, cancelable: st.cancelable, startTime: st.timeStamp, processingStart: st.timeStamp + pe };
    fr.forEach(function(t) {
      t(e);
    }), fr = [];
  }
}, oT = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(r, n) {
      var i = function() {
        la(r, n), a();
      }, o = function() {
        a();
      }, a = function() {
        removeEventListener("pointerup", i, ce), removeEventListener("pointercancel", o, ce);
      };
      addEventListener("pointerup", i, ce), addEventListener("pointercancel", o, ce);
    }(t, e) : la(t, e);
  }
}, Su = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, oT, ce);
  });
}, fa = [100, 300], aT = function(e, t) {
  t = t || {}, Pe(function() {
    var r, n = yi(), i = V("FID"), o = function(c) {
      c.startTime < n.firstHiddenTime && (i.value = c.processingStart - c.startTime, i.entries.push(c), r(!0));
    }, a = function(c) {
      c.forEach(o);
    }, u = Wt("first-input", a);
    r = F(e, i, fa, t.reportAllChanges), u && Sr(gi(function() {
      a(u.takeRecords()), u.disconnect();
    })), u && Nt(function() {
      var c;
      i = V("FID"), r = F(e, i, fa, t.reportAllChanges), fr = [], pe = -1, st = null, Su(addEventListener), c = o, fr.push(c), Tu();
    });
  });
}, sT = function(e, t) {
  aT(function(r) {
    (function(n) {
      var i = n.entries[0];
      n.attribution = { eventTarget: mr(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: Oe(i.startTime) };
    })(r), e(r);
  }, t);
}, Ou = 0, gn = 1 / 0, ze = 0, uT = function(e) {
  e.forEach(function(t) {
    t.interactionId && (gn = Math.min(gn, t.interactionId), ze = Math.max(ze, t.interactionId), Ou = ze ? (ze - gn) / 7 + 1 : 0);
  });
}, bu = function() {
  return ei ? Ou : performance.interactionCount || 0;
}, cT = function() {
  "interactionCount" in performance || ei || (ei = Wt("event", uT, { type: "event", buffered: !0, durationThreshold: 0 }));
}, da = [200, 500], Au = 0, pa = function() {
  return bu() - Au;
}, K = [], yn = {}, ha = function(e) {
  var t = K[K.length - 1], r = yn[e.interactionId];
  if (r || K.length < 10 || e.duration > t.latency) {
    if (r) r.entries.push(e), r.latency = Math.max(r.latency, e.duration);
    else {
      var n = { id: e.interactionId, latency: e.duration, entries: [e] };
      yn[n.id] = n, K.push(n);
    }
    K.sort(function(i, o) {
      return o.latency - i.latency;
    }), K.splice(10).forEach(function(i) {
      delete yn[i.id];
    });
  }
}, lT = function(e, t) {
  t = t || {}, Pe(function() {
    var r;
    cT();
    var n, i = V("INP"), o = function(u) {
      u.forEach(function(l) {
        l.interactionId && ha(l), l.entryType === "first-input" && !K.some(function(f) {
          return f.entries.some(function(d) {
            return l.duration === d.duration && l.startTime === d.startTime;
          });
        }) && ha(l);
      });
      var c, s = (c = Math.min(K.length - 1, Math.floor(pa() / 50)), K[c]);
      s && s.latency !== i.value && (i.value = s.latency, i.entries = s.entries, n());
    }, a = Wt("event", o, { durationThreshold: (r = t.durationThreshold) !== null && r !== void 0 ? r : 40 });
    n = F(e, i, da, t.reportAllChanges), a && ("interactionId" in PerformanceEventTiming.prototype && a.observe({ type: "first-input", buffered: !0 }), Sr(function() {
      o(a.takeRecords()), i.value < 0 && pa() > 0 && (i.value = 0, i.entries = []), n(!0);
    }), Nt(function() {
      K = [], Au = bu(), i = V("INP"), n = F(e, i, da, t.reportAllChanges);
    }));
  });
}, fT = function(e, t) {
  lT(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries.sort(function(o, a) {
          return a.duration - o.duration || a.processingEnd - a.processingStart - (o.processingEnd - o.processingStart);
        })[0];
        n.attribution = { eventTarget: mr(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: Oe(i.startTime) };
      } else n.attribution = {};
    })(r), e(r);
  }, t);
}, _a = [2500, 4e3], En = {}, dT = function(e, t) {
  (function(r, n) {
    n = n || {}, Pe(function() {
      var i, o = yi(), a = V("LCP"), u = function(l) {
        var f = l[l.length - 1];
        f && f.startTime < o.firstHiddenTime && (a.value = Math.max(f.startTime - Tr(), 0), a.entries = [f], i());
      }, c = Wt("largest-contentful-paint", u);
      if (c) {
        i = F(r, a, _a, n.reportAllChanges);
        var s = gi(function() {
          En[a.id] || (u(c.takeRecords()), c.disconnect(), En[a.id] = !0, i(!0));
        });
        ["keydown", "click"].forEach(function(l) {
          addEventListener(l, function() {
            return setTimeout(s, 0);
          }, !0);
        }), Sr(s), Nt(function(l) {
          a = V("LCP"), i = F(r, a, _a, n.reportAllChanges), vi(function() {
            a.value = performance.now() - l.timeStamp, En[a.id] = !0, i(!0);
          });
        });
      }
    });
  })(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = Kt();
        if (i) {
          var o = i.activationStart || 0, a = n.entries[n.entries.length - 1], u = a.url && performance.getEntriesByType("resource").filter(function(p) {
            return p.name === a.url;
          })[0], c = Math.max(0, i.responseStart - o), s = Math.max(c, u ? (u.requestStart || u.startTime) - o : 0), l = Math.max(s, u ? u.responseEnd - o : 0), f = Math.max(l, a ? a.startTime - o : 0), d = { element: mr(a.element), timeToFirstByte: c, resourceLoadDelay: s - c, resourceLoadTime: l - s, elementRenderDelay: f - l, navigationEntry: i, lcpEntry: a };
          return a.url && (d.url = a.url), u && (d.lcpResourceEntry = u), void (n.attribution = d);
        }
      }
      n.attribution = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadTime: 0, elementRenderDelay: n.value };
    })(r), e(r);
  }, t);
}, va = [800, 1800], pT = function e(t) {
  document.prerendering ? Pe(function() {
    return e(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(t);
  }, !0) : setTimeout(t, 0);
}, hT = function(e, t) {
  t = t || {};
  var r = V("TTFB"), n = F(e, r, va, t.reportAllChanges);
  pT(function() {
    var i = Kt();
    if (i) {
      var o = i.responseStart;
      if (o <= 0 || o > performance.now()) return;
      r.value = Math.max(o - Tr(), 0), r.entries = [i], n(!0), Nt(function() {
        r = V("TTFB", 0), (n = F(e, r, va, t.reportAllChanges))(!0);
      });
    }
  });
}, _T = function(e, t) {
  hT(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries[0], o = i.activationStart || 0, a = Math.max(i.domainLookupStart - o, 0), u = Math.max(i.connectStart - o, 0), c = Math.max(i.requestStart - o, 0);
        n.attribution = { waitingTime: a, dnsTime: u - a, connectionTime: c - u, requestTime: n.value - c, navigationEntry: i };
      } else n.attribution = { waitingTime: 0, dnsTime: 0, connectionTime: 0, requestTime: 0 };
    })(r), e(r);
  }, t);
};
const vT = (e) => (rT(e), nT(e), sT(e), dT(e), _T(e), fT(e), () => {
}), kt = typeof navigator != "undefined" && "connection" in navigator ? navigator.connection : {}, gT = (e, t) => {
  const r = () => {
    const o = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: o,
      downlink: kt.downlink,
      downlinkMax: kt.downlinkMax,
      effectiveType: kt.effectiveType,
      rtt: kt.rtt,
      saveData: kt.saveData,
      type: kt.type
    });
  };
  r();
  let n;
  return n = setInterval(() => {
    r();
  }, 1e3), () => {
    clearInterval(n);
  };
}, yT = () => {
  if (!("performance" in window && "memory" in performance))
    return {
      getDeviceDetails: void 0,
      getCurrentDeviceDetails: void 0
    };
  const e = window.performance;
  return {
    getDeviceDetails: () => ({
      deviceMemory: ET(
        navigator.deviceMemory || 0
      )
    }),
    getCurrentDeviceDetails: () => {
      const n = mn(
        e.memory.jsHeapSizeLimit
      ), i = mn(
        e.memory.totalJSHeapSize
      ), o = mn(
        e.memory.usedJSHeapSize
      );
      return {
        jsHeapSizeLimit: n,
        totalJSHeapSize: i,
        usedJSHeapSize: o
      };
    }
  };
}, mn = (e) => e / Math.pow(1e3, 2), ET = (e) => 1024 * e;
function mT(e) {
  return "regexValue" in e;
}
function TT(e) {
  return "matchValue" in e;
}
function ST(e) {
  const t = Math.trunc(e);
  return t === 1 ? !0 : t === 0 ? !1 : Math.floor(Math.random() * t) === 0;
}
class OT {
  /**
   * @param config The sampling configuration.
   * @param sampler The sampler to use. This is intended to be used for testing purposes.
   */
  constructor(t = ST) {
    O(this, "regexCache", /* @__PURE__ */ new Map());
    O(this, "config");
    this.sampler = t;
  }
  setConfig(t) {
    this.config = t;
  }
  isSamplingEnabled() {
    var t, r, n, i;
    return !!((r = (t = this.config) == null ? void 0 : t.logs) != null && r.length || (i = (n = this.config) == null ? void 0 : n.spans) != null && i.length);
  }
  shouldSample(t) {
    var r, n;
    return t.name === fu ? this.sampleLog((r = this.config) == null ? void 0 : r.logs, t) : this.sampleSpan((n = this.config) == null ? void 0 : n.spans, t);
  }
  /**
   * Check if a value matches a match config.
   */
  matchesValue(t, r) {
    if (!t)
      return !1;
    if (TT(t))
      return t.matchValue === r;
    if (mT(t)) {
      const n = t.regexValue;
      if (n === null)
        return !1;
      this.regexCache.has(n) || this.regexCache.set(n, new RegExp(n));
      const i = this.regexCache.get(n);
      if (typeof r == "string")
        return i.test(r);
    }
    return !1;
  }
  /**
   * Check if the attributes match the attribute configs.
   */
  matchesAttributes(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of Object.keys(r))
          if (this.matchesValue(n.key, o)) {
            const a = r[o];
            if (this.matchesValue(
              n.attribute,
              a
            )) {
              i = !0;
              break;
            }
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  matchEvent(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || t.attributes && (!r.attributes || !this.matchesAttributes(
      t.attributes,
      r.attributes
    )));
  }
  matchesEvents(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of r)
          if (this.matchEvent(n, o)) {
            i = !0;
            break;
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  /**
   * Attempts to match the span to the config. The span will match only if all defined conditions are met.
   *
   * @param config The config to match against.
   * @param name The name of the span to match.
   * @param attributes The attributes of the span to match.
   * @returns True if the span matches the config, false otherwise.
   */
  matchesSpanConfig(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || !this.matchesAttributes(t.attributes, r.attributes) || !this.matchesEvents(t.events, r.events));
  }
  matchesLogConfig(t, r) {
    if (t.severityText) {
      const n = r[du];
      if (!this.matchesValue(t.severityText, n))
        return !1;
    }
    if (t.message) {
      const n = r[pu];
      if (!this.matchesValue(t.message, n))
        return !1;
    }
    return !!this.matchesAttributes(t.attributes, r);
  }
  /**
   * Sample a span based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param name The name of the span to sample.
   * @param attributes The attributes of the span to sample.
   * @returns The sampling result.
   */
  sampleSpan(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesSpanConfig(n, r))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [ta]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
  /**
   * Sample a log based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param attributes The attributes of the log to sample.
   * @returns The sampling result.
   */
  sampleLog(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesLogConfig(n, r.attributes))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [ta]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
}
const ga = () => {
  const e = {
    end: () => {
    },
    spanContext: () => ({
      traceId: "",
      spanId: "",
      traceFlags: 0
    }),
    setAttribute: (t, r) => e,
    setAttributes: (t) => e,
    addEvent: (t, r, n) => e,
    addLinks: (t) => e,
    setStatus: (t) => e,
    recordException: () => {
    },
    addLink: () => e,
    updateName: () => e,
    isRecording: () => !1
  };
  return e;
}, bT = () => {
  if (typeof window == "undefined" || typeof PerformanceObserver == "undefined") return !1;
  const e = PerformanceObserver.supportedEntryTypes;
  return Array.isArray(e) && e.includes("longtask");
}, AT = (e) => {
  if (!bT()) return () => {
  };
  let t;
  try {
    t = new PerformanceObserver((r) => {
      var n;
      for (const i of r.getEntries()) {
        const o = (n = i.attribution) == null ? void 0 : n[0];
        e({
          duration: i.duration,
          name: i.name,
          startTime: i.startTime,
          containerType: o == null ? void 0 : o.containerType,
          containerSrc: o == null ? void 0 : o.containerSrc,
          containerId: o == null ? void 0 : o.containerId,
          containerName: o == null ? void 0 : o.containerName
        });
      }
    }), t.observe({ type: "longtask", buffered: !0 });
  } catch (r) {
    return () => {
    };
  }
  return () => {
    try {
      t.disconnect();
    } catch (r) {
    }
  };
}, wT = /* @__PURE__ */ new Set(["string", "number", "boolean"]), RT = () => typeof window != "undefined" && typeof window.ReportingObserver != "undefined", LT = (e) => {
  const t = {};
  if (!e || typeof e != "object") return t;
  for (const [r, n] of Object.entries(
    e
  ))
    if (n != null)
      if (wT.has(typeof n))
        t[`report.body.${r}`] = n;
      else
        try {
          t[`report.body.${r}`] = JSON.stringify(n);
        } catch (i) {
        }
  return t;
}, PT = (e) => {
  var n;
  const t = (n = e.body) != null ? n : {}, r = t.message || t.reason || t.id || e.type;
  return typeof r == "string" ? r : e.type;
}, NT = (e, t) => {
  if (!RT()) return () => {
  };
  const r = [
    "deprecation",
    "intervention",
    "csp-violation"
  ], n = window.ReportingObserver;
  let i;
  try {
    i = new n(
      (o) => {
        var a, u;
        for (const c of o) {
          const s = (a = c.type) != null ? a : "unknown", l = (u = c.body) != null ? u : {}, f = m({
            "report.type": s,
            "report.url": c.url
          }, LT(l)), d = PT({ type: s, body: l });
          e(s === "deprecation" ? {
            kind: "log",
            level: "warn",
            type: s,
            message: d,
            url: c.url,
            attributes: f
          } : {
            kind: "error",
            type: s,
            message: d,
            url: c.url,
            attributes: f
          });
        }
      },
      { buffered: !0, types: r }
    ), i.observe();
  } catch (o) {
    return () => {
    };
  }
  return () => {
    try {
      i.disconnect();
    } catch (o) {
    }
  };
}, IT = "exception", CT = function(e, t, r) {
  if (!e)
    return;
  const n = m({}, r);
  typeof t == "string" ? n[Lr] = t : t && (t.code ? n[Rr] = t.code.toString() : t.name && (n[Rr] = t.name), t.message && (n[Lr] = t.message), t.stack && (n[Fu] = t.stack)), n[Rr] || n[Lr] ? e.addEvent(IT, n) : _c(
    "otel",
    "recordException",
    "warn",
    `Failed to record an exception ${t}`
  );
};
var be;
class MT {
  constructor(t) {
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    O(this, "organizationID");
    O(this, "_options");
    O(this, "_integrations", []);
    O(this, "_gauges", /* @__PURE__ */ new Map());
    O(this, "_counters", /* @__PURE__ */ new Map());
    O(this, "_histograms", /* @__PURE__ */ new Map());
    O(this, "_up_down_counters", /* @__PURE__ */ new Map());
    O(this, "sampler", new OT());
    O(this, "_started", !1);
    O(this, "_ldContextKeys");
    // ECMAScript-private (#) so the internal GraphQL SDK type — which
    // references graphql-request / graphql — does not leak into the published
    // declaration file and break consumer type-checking.
    Ii(this, be);
    this._options = t, this.organizationID = t.projectId;
  }
  _productAnalyticsEvents() {
    var n;
    const t = (n = this._options) == null ? void 0 : n.productAnalytics;
    if (t === !1)
      return {};
    const r = {
      clicks: !0,
      pageViews: !0,
      trackEvents: !0
    };
    if (t === void 0 || t === !0)
      return r;
    for (const i of Object.keys(t))
      t[i] === !1 && (r[i] = !1);
    return r;
  }
  setLDContextKeyAttributes(t) {
    t && (this._ldContextKeys = Object.fromEntries(
      Object.entries(t).map(([r, n]) => [
        `${Xu}.${r}`,
        n
      ])
    ));
  }
  getLDContextKeyAttributes() {
    return this._ldContextKeys;
  }
  start() {
    return U(this, null, function* () {
      var r, n, i, o, a, u, c, s, l, f, d, p, _, h, g;
      if (this._started)
        return;
      this._started = !0, Dm(
        {
          backendUrl: (n = (r = this._options) == null ? void 0 : r.backendUrl) != null ? n : "https://pub.observability.app.launchdarkly.com",
          otlpEndpoint: (a = (o = (i = this._options) == null ? void 0 : i.otel) == null ? void 0 : o.otlpEndpoint) != null ? a : "https://otel.observability.app.launchdarkly.com",
          projectId: this._options.projectId,
          sessionSecureId: this._options.sessionSecureId,
          environment: (c = (u = this._options) == null ? void 0 : u.environment) != null ? c : "production",
          networkRecordingOptions: typeof ((s = this._options) == null ? void 0 : s.networkRecording) == "object" ? this._options.networkRecording : void 0,
          tracingOrigins: (l = this._options) == null ? void 0 : l.tracingOrigins,
          serviceName: (d = (f = this._options) == null ? void 0 : f.serviceName) != null ? d : "browser",
          serviceVersion: (p = this._options) == null ? void 0 : p.version,
          instrumentations: (h = (_ = this._options) == null ? void 0 : _.otel) == null ? void 0 : h.instrumentations,
          productAnalyticsEvents: this._productAnalyticsEvents(),
          getLDContextKeyAttributes: () => this.getLDContextKeyAttributes(),
          getIntegrations: () => this._integrations
        },
        this.sampler
      ), this._gauges.clear(), this._counters.clear(), this._histograms.clear(), this._up_down_counters.clear();
      const t = new Ku(
        (g = this._options.backendUrl) != null ? g : "https://pub.observability.app.launchdarkly.com",
        {
          headers: {}
        }
      );
      Ci(this, be, zu(t, qu())), yield this.configureSampling(), this.setupListeners();
    });
  }
  stop() {
    return U(this, null, function* () {
      this._started && (this._started = !1, yield $m());
    });
  }
  configureSampling() {
    return U(this, null, function* () {
      try {
        const t = yield Ni(this, be).GetSamplingConfig({
          organization_verbose_id: `${this.organizationID}`
        });
        this.sampler.setConfig(t.sampling);
      } catch (t) {
        Oa(
          "sampling",
          "warn",
          `LaunchDarkly Observability: Failed to configure sampling: ${t}`
        );
      }
    });
  }
  _recordLog(t, r, n, i) {
    this.startSpan(fu, (o) => {
      var c, s, l, f, d;
      const a = typeof t == "string" ? t : he(t), u = i ? i.map((p) => p.toString()).join(`
`) : void 0;
      if (o == null || o.addEvent("log", m(m({
        [du]: r,
        [pu]: a,
        "code.stacktrace": u
      }, (c = this._ldContextKeys) != null ? c : {}), n)), this._options.reportConsoleErrors && r === "error") {
        const p = new Error(a);
        o == null || o.recordException(p), o == null || o.setStatus({
          code: er.ERROR,
          message: a
        }), i ? this._recordErrorMessage({
          error: p,
          event: p.message,
          type: "custom",
          url: window.location.href,
          source: "frontend",
          lineNumber: (l = (s = i[0]) == null ? void 0 : s.lineNumber) != null ? l : 0,
          columnNumber: (d = (f = i[0]) == null ? void 0 : f.columnNumber) != null ? d : 0,
          stackTrace: i,
          timestamp: (/* @__PURE__ */ new Date()).toISOString(),
          id: Sn()
        }) : this.recordError(p);
      }
    });
  }
  _recordErrorMessage(t, r) {
    try {
      t.payload && (r = m(m({}, JSON.parse(t.payload)), r || {}));
    } catch (a) {
    }
    this.startSpan("highlight.exception", (a) => {
      var u;
      CT(a, (u = t.error) != null ? u : new Error(t.event), {
        [xm]: t.id
      }), a == null || a.setAttributes(m({
        event: t.event,
        type: t.type,
        url: t.url,
        source: t.source,
        lineNumber: t.lineNumber,
        columnNumber: t.columnNumber
      }, r));
    });
    const o = t, { payload: n } = o, i = Ar(o, ["payload"]);
    for (const a of this._integrations)
      a.error(it(), I(m({}, i), {
        payload: JSON.stringify(r)
      }));
  }
  recordError(t, r, n, i, o) {
    var s, l, f, d;
    t = t || new Error("Unknown error"), t instanceof Error && t.cause && (n = I(m({}, n), {
      "exception.cause": JSON.stringify(t.cause)
    }));
    let a = r ? r + ":" + t.message : t.message;
    o === "React.ErrorBoundary" && (a = "ErrorBoundary: " + a);
    const u = pr(t), c = {
      error: t,
      event: a,
      type: o != null ? o : "custom",
      url: window.location.href,
      source: i != null ? i : "frontend",
      lineNumber: (s = u[0]) != null && s.lineNumber ? (l = u[0]) == null ? void 0 : l.lineNumber : 0,
      columnNumber: (f = u[0]) != null && f.columnNumber ? (d = u[0]) == null ? void 0 : d.columnNumber : 0,
      stackTrace: u,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      id: Sn()
    };
    this._recordErrorMessage(c, n);
  }
  recordCount(t) {
    var n, i;
    let r = this._counters.get(t.name);
    if (!r) {
      if (r = (n = Xe()) == null ? void 0 : n.createCounter(t.name), !r) return;
      this._counters.set(t.name, r);
    }
    r.add(t.value, I(m(m({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": it()
    }));
  }
  recordGauge(t) {
    var o, a, u;
    let r = this._gauges.get(t.name);
    if (!r) {
      if (r = (o = Xe()) == null ? void 0 : o.createGauge(t.name), !r) return;
      this._gauges.set(t.name, r);
    }
    const n = m(m({}, (a = this._ldContextKeys) != null ? a : {}), t.attributes);
    r.record(t.value, I(m({}, n), {
      "highlight.session_id": it()
    }));
    const i = {
      name: t.name,
      value: t.value,
      category: n.category,
      group: (u = n.group) == null ? void 0 : u.toString(),
      tags: Object.entries(n).map(([c, s]) => {
        var l;
        return {
          name: c != null ? c : "",
          value: (l = s == null ? void 0 : s.toString()) != null ? l : ""
        };
      })
    };
    for (const c of this._integrations)
      c.recordGauge(
        it(),
        i
      );
  }
  recordIncr(t) {
    this.recordCount(I(m({}, t), { value: 1 }));
  }
  recordHistogram(t) {
    var n, i;
    let r = this._histograms.get(t.name);
    if (!r) {
      if (r = (n = Xe()) == null ? void 0 : n.createHistogram(t.name), !r) return;
      this._histograms.set(t.name, r);
    }
    r.record(t.value, I(m(m({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": it()
    }));
  }
  recordUpDownCounter(t) {
    var n, i;
    let r = this._up_down_counters.get(t.name);
    if (!r) {
      if (r = (n = Xe()) == null ? void 0 : n.createUpDownCounter(t.name), !r) return;
      this._up_down_counters.set(t.name, r);
    }
    r.add(t.value, I(m(m({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": it()
    }));
  }
  startSpan(t, r, n, i) {
    const o = ea();
    if (!o) {
      const u = ga();
      return i === void 0 && n === void 0 ? r(u) : i === void 0 ? n(u) : i(u);
    }
    const a = (u, c) => {
      this._ldContextKeys && u.setAttributes(this._ldContextKeys);
      const s = c(u);
      return s instanceof Promise ? s.finally(() => u.end()) : (u.end(), s);
    };
    return i === void 0 && n === void 0 ? o.startActiveSpan(
      t,
      (u) => a(u, r)
    ) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      (u) => a(u, n)
    ) : o.startActiveSpan(
      t,
      r,
      n,
      (u) => a(u, i)
    );
  }
  startManualSpan(t, r, n, i) {
    const o = ea();
    if (!o) {
      const a = ga();
      return i === void 0 && n === void 0 ? r(a) : i === void 0 ? n(a) : i(a);
    }
    return i === void 0 && n === void 0 ? o.startActiveSpan(t, r) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      n
    ) : o.startActiveSpan(
      t,
      r,
      n,
      i
    );
  }
  register(t, r) {
    this._integrations.push(new Wu(t, r));
  }
  getHooks(t) {
    return this._integrations.flatMap((r) => {
      var n, i;
      return (i = (n = r.getHooks) == null ? void 0 : n.call(r, t)) != null ? i : [];
    });
  }
  submitViewportMetrics({
    height: t,
    width: r,
    availHeight: n,
    availWidth: i
  }) {
    this.recordGauge({
      name: _t.ViewportHeight,
      value: t,
      attributes: {
        category: j.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: _t.ViewportWidth,
      value: r,
      attributes: {
        category: j.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: _t.ScreenHeight,
      value: n,
      attributes: {
        category: j.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: _t.ScreenWidth,
      value: i,
      attributes: {
        category: j.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: _t.ViewportArea,
      value: t * r,
      attributes: {
        category: j.Device,
        group: window.location.href
      }
    });
  }
  setupListeners() {
    var r;
    this._options.disableConsoleRecording || Ec(
      (n) => {
        var i;
        this._recordLog(
          (i = n.value) == null ? void 0 : i.join(" "),
          n.type,
          n.attributes ? JSON.parse(n.attributes) : {},
          n.trace
        );
      },
      {
        level: (r = this._options.consoleMethodsToRecord) != null ? r : [
          ...ba
        ],
        logger: "console",
        stringifyOptions: {
          depthOfLimit: 10,
          numOfKeysLimit: 100,
          stringLengthLimit: 1e3
        }
      }
    ), this._options.enablePerformanceRecording !== !1 && (Qm((n) => {
      Object.entries(n).filter(([i]) => i !== "relativeTimestamp").forEach(
        ([i, o]) => o && this.recordGauge({
          name: i,
          value: o,
          attributes: {
            category: j.Performance,
            group: window.location.href
          }
        })
      );
    }, 0), Jm((n) => {
      this.recordGauge({
        name: "Jank",
        value: n.jankAmount,
        attributes: {
          category: j.WebVital,
          group: n.querySelector
        }
      });
    }, 0)), Lc(
      (n) => {
        var a;
        if (Nc.includes(n.event) || Ic.some(
          (u) => n.event.includes(u)
        ))
          return;
        const i = new Error(n.event);
        i.stack = he(n.stackTrace.map((u) => u.toString()));
        let o = {};
        try {
          n.payload && (o = JSON.parse(n.payload));
        } catch (u) {
        }
        this._recordErrorMessage(
          I(m({}, n), { error: (a = n.error) != null ? a : i }),
          o
        );
      },
      { enablePromisePatch: !!this._options.enablePromisePatch }
    ), vT((n) => {
      const { name: i, value: o } = n, { hostname: a, pathname: u, href: c } = window.location, s = {
        group: window.location.pathname,
        category: j.WebVital,
        [lt]: qn(c),
        [qe]: u,
        [Zu]: a
      };
      switch (n.name) {
        case "LCP": {
          const l = n.attribution;
          l.element && (s["web_vital.element"] = l.element), l.url && (s["web_vital.attribution.url"] = qn(
            l.url
          ));
          break;
        }
        case "CLS": {
          const l = n.attribution;
          l.largestShiftTarget && (s["web_vital.element"] = l.largestShiftTarget), l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
        case "INP": {
          const l = n.attribution;
          l.eventTarget && (s["web_vital.element"] = l.eventTarget), l.eventType && (s["web_vital.event_type"] = l.eventType), l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
        case "FID": {
          const l = n.attribution;
          l.eventTarget && (s["web_vital.element"] = l.eventTarget), l.eventType && (s["web_vital.event_type"] = l.eventType);
          break;
        }
        case "FCP": {
          const l = n.attribution;
          l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
      }
      this.recordGauge({
        name: i,
        value: o,
        attributes: s
      });
    }), Yu((n) => {
      this.submitViewportMetrics(n);
    }), gT((n) => {
      const i = {
        category: j.Performance,
        group: window.location.href
      };
      n.saveData !== void 0 && (i.saveData = n.saveData.toString()), n.effectiveType !== void 0 && (i.effectiveType = n.effectiveType.toString()), n.type !== void 0 && (i.type = n.type.toString()), Object.entries(n).filter(([o]) => o !== "relativeTimestamp").forEach(([o, a]) => {
        Ju(a) && this.recordGauge({
          name: o,
          value: a,
          attributes: i
        });
      });
    }, (/* @__PURE__ */ new Date()).getTime());
    const { getDeviceDetails: t } = yT();
    t && this.recordGauge({
      name: _t.DeviceMemory,
      value: t().deviceMemory,
      attributes: {
        category: j.Device,
        group: window.location.href
      }
    }), this._options.enableLongtaskRecording !== !1 && AT((n) => {
      const i = {
        category: j.Performance,
        name: n.name,
        [qe]: window.location.pathname
      };
      n.containerType && (i.container_type = n.containerType), n.containerSrc && (i.container_src = n.containerSrc), n.containerId && (i.container_id = n.containerId), n.containerName && (i.container_name = n.containerName), this.recordHistogram({
        name: "long_task.duration",
        value: n.duration,
        attributes: i
      });
    }), this._options.enableReportingObserver !== !1 && NT((n) => {
      var o;
      const i = I(m({}, n.attributes), {
        [qe]: window.location.pathname
      });
      if (n.kind === "log")
        this._recordLog(
          n.message,
          (o = n.level) != null ? o : "warn",
          i
        );
      else {
        const a = new Error(n.message);
        this.recordError(
          a,
          void 0,
          Object.fromEntries(
            Object.entries(i).map(([u, c]) => [
              u,
              c === void 0 ? "" : String(c)
            ])
          ),
          "reporting-observer",
          "custom"
        );
      }
    });
  }
  recordLog(t, r, n) {
    return this._recordLog(t, r, n);
  }
}
be = new WeakMap();
class VT extends Qu {
  constructor(r) {
    super(r);
    O(this, "observe");
    O(this, "options");
    this.options = r;
  }
  initialize(r, n) {
    try {
      if (typeof window == "undefined" || typeof document == "undefined") {
        console.warn(
          "@launchdarkly/observability is not initializing because it is not supported in this environment."
        );
        return;
      }
      if (!r) {
        console.warn(
          "@launchdarkly/observability is not initializing because the SDK credential is undefined."
        );
        return;
      }
      this.configureSession(r, n), this.observe = new MT(I(m({}, n), {
        projectId: r,
        sessionSecureId: this.sessionSecureID
      })), n != null && n.manualStart || this.observe.start(), vc.load(this.observe);
    } catch (i) {
      Oa(
        "Error initializing @launchdarkly/observability SDK",
        "error",
        i
      );
    }
  }
  getMetadata() {
    return {
      name: "@launchdarkly/observability"
    };
  }
  register(r, n) {
    var i;
    (i = this.observe) == null || i.register(r, n);
  }
  getHooks(r) {
    var i, o, a, u;
    const n = m(m({
      [cc]: r.sdk.name,
      [uc]: r.sdk.version,
      [sc]: r.clientSideId,
      [ac]: "LaunchDarkly"
    }, (i = r.application) != null && i.id ? { [oc]: r.application.id } : {}), (o = r.application) != null && o.version ? {
      [ic]: r.application.version
    } : {});
    return this.initialize(
      (u = (a = r.sdkKey) != null ? a : r.mobileKey) != null ? u : r.clientSideId,
      this.options
    ), [
      {
        getMetadata: () => ({
          name: "@launchdarkly/observability/hooks"
        }),
        afterIdentify: (c, s, l) => {
          var d, p, _, h, g, y, E, A, w;
          for (const P of (_ = (p = (d = this.observe) == null ? void 0 : d.getHooks) == null ? void 0 : p.call(d, r)) != null ? _ : [])
            (h = P.afterIdentify) == null || h.call(P, c, s, l);
          const f = Mi(c.context);
          if ((g = this.observe) == null || g.setLDContextKeyAttributes(f), l.status === "completed") {
            const P = I(m({}, f), {
              key: (A = (E = (y = this.options) == null ? void 0 : y.contextFriendlyName) == null ? void 0 : E.call(
                y,
                c.context
              )) != null ? A : Pr(c.context),
              timeout: c.timeout,
              canonicalKey: Pr(c.context),
              [hc]: l.status
            });
            (w = this.observe) == null || w.recordLog("LD.identify", "info", m(m({}, n), P));
          }
          return s;
        },
        afterEvaluation: (c, s, l) => {
          var p, _, h, g, y;
          for (const E of (h = (_ = (p = this.observe) == null ? void 0 : p.getHooks) == null ? void 0 : _.call(p, r)) != null ? h : [])
            (g = E.afterEvaluation) == null || g.call(E, c, s, l);
          const f = m({
            [fc]: c.flagKey,
            [ec]: JSON.stringify(l.value)
          }, l.variationIndex ? {
            [lc]: l.variationIndex
          } : {});
          if (l.reason)
            for (const E in xi) {
              const A = E, w = l.reason[A];
              w && (f[xi[A]] = w);
            }
          c.context && (f[dc] = JSON.stringify(Mi(c.context)), f[pc] = Pr(c.context));
          const d = m(m({}, n), f);
          return (y = this.observe) == null || y.startSpan(rc, (E) => {
            E && E.addEvent(nc, d);
          }), s;
        },
        afterTrack: (c) => {
          var f, d, p, _, h, g, y, E, A;
          for (const w of (p = (d = (f = this.observe) == null ? void 0 : f.getHooks) == null ? void 0 : d.call(f, r)) != null ? p : [])
            (_ = w.afterTrack) == null || _.call(w, c);
          if (!(((h = this.options) == null ? void 0 : h.productAnalytics) !== !1 && (typeof ((g = this.options) == null ? void 0 : g.productAnalytics) != "object" || this.options.productAnalytics.trackEvents !== !1)))
            return;
          const l = m(I(m(m({
            [lt]: window.location.href
          }, (E = (y = this.observe) == null ? void 0 : y.getLDContextKeyAttributes()) != null ? E : {}), n), {
            key: c.key,
            value: c.metricValue
          }), typeof c.data == "object" ? c.data : {});
          (A = this.observe) == null || A.startSpan(tc, (w) => {
            w && w.setAttributes(l);
          });
        }
      }
    ];
  }
}
export {
  ba as A,
  Ec as C,
  cg as D,
  Lc as E,
  jT as F,
  Jm as J,
  j as M,
  gT as N,
  VT as O,
  Qm as P,
  vT as W,
  HT as X,
  fi as a,
  Nc as b,
  Ic as c,
  kT as d,
  mc as e,
  Dm as f,
  OT as g,
  _t as h,
  Xe as i,
  yT as j,
  qn as k,
  Ps as l,
  $T as m,
  ea as n,
  ga as o,
  pr as p,
  Sn as r,
  $m as s
};
//# sourceMappingURL=observe-DuoVpgPC.js.map
